import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { AuthService } from './../auth/auth.service';
import {  map } from 'rxjs';
import '../../assets/parcord.js';
import '../../assets/divgrid.js';
import { Router } from '@angular/router';
//import '../../assets/gsta.js';
//import '../../assets/googlecharts.js';
import { jsPDF } from 'jspdf';
//import * as html2canvas from "html2canvas";
import { Location } from '@angular/common';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GooglesnakeyComponent } from '../googlesnakey/googlesnakey.component';
import { SankeyreportComponent } from '../sankeyreport/sankeyreport.component';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../dialog-overview-example-dialog/dialog-overview-example-dialog.component';

@Component({
  selector: 'app-snakeychart',
  templateUrl: './snakeychart.component.html',
  styleUrls: ['./snakeychart.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SnakeychartComponent implements OnInit {
  @ViewChild(GooglesnakeyComponent) child: GooglesnakeyComponent;
  @ViewChild(SankeyreportComponent) childNew: SankeyreportComponent;

  d3: any;
  message: string;
  msgurl: string;
  cellmessage: string;
  cellTwomessage;
  cellThreemessage;
  cellFourmessage;
  cellFivemessage;
  cellSixmessage;
  data: any;
  projLists: any;
  newUserId: number;
  currentId: any;
  newEventId: number;
  newProjId: any;
  i;
  Plotly: any;
  newChartMsg: string;
  proDat: any;
  ids = [];
  cellone;
  celltwo;
  cellthree;
  cellfour;
  cellfive;
  cellsix;
  authser;
  newcell;
  firstCol;
  secondCol;
  thirdCol;
  fourcol;
  fivecol;
  sixcol;
  condId;
  walloneCost;
  uniwall = [];
  selectionUserId;
  crtDate: any;
  modval: any;
  buildEnv: any;
  lightData: any;
  infData: any;
  freshAir: any;
  heatEffect;
  coolEffect;
  ashraeval;
  newcustBase;
  newcustBaseRoof;
  newcustBaseFloor;
  newcustBaseWindow;
  newcustBaseShading;
  newcustBaseLighting;
  newcustBaseInf;
  newcustBaseWwr;
  newcustDaylight;
  newToggleEditable;
  custBase;
  custBaseValue;
  costPrem;
  costHeat;
  costCool;
  costDist;
  costPump;
  costRejp;
  animal: string;
  name: string;
  newAshNecb;
  custBaseNew;
  heattwo;
  lpduvalCost;
  dls;
  eui;
  lit;
  wal;
  rvi;
  fvi;
  wvi;
  shd;
  hva;
  hre;
  newAshNecbNew;
  wwr;
  newrn;
  newrt;
  nwert;
  msgurlnw: string;
  gogdat;
  hteng;
  coeng;
  newrtlgt;
  newrtlgtnew;
  newrtlgtfirst;
  ltfirst;
  wwrfirst;
  newrtwallfirst;
  newrtwall;
  newrtwallfirstNew;
  wallfirst;
  newrtrooffirst;
  newrtroof;
  newrtrooffirstNew;
  rooffirst;
  newrtfloorfirst;
  newrtfloor;
  newrtfloorfirstNew;
  floorfirst;
  newrtwinfirst;
  newrtwin;
  newrtwinfirstNew;
  winfirst;
  newrtshdfirst;
  newrtshd;
  newrtshdfirstNew;
  shdfirst;
  newdl;
  nwertdl;
  newrtdlnew;
  dlfirst;
  newhvac;
  nwerthvac;
  newheat;
  nwertheat;
  engcu;
  gdatanew;
  engTotal;
  engtotalnew;
  msgurlnwss;
  engTotalss;
  engtotalnewss;
  engtotalfeb;
  engtotalmar;
  engtotalapr;
  engtotalmay;
  engtotaljun;
  engtotaljul;
  engtotalaug;
  engtotaloct;
  engtotalnov;
  engtotaldec;
  engtotalsep;
  engtotalssfeb;
  engtotalssmar;
  engtotalssapr;
  engtotalssmay;
  engtotalssjun;
  engtotalssjul;
  engtotalssaug;
  engtotalsssep;
  engtotalssoct;
  engtotalssnov;
  engtotalssdec;
  initfloor;
  initROOF;
  initWINDOW;
  initWALL;
  initWWR;
  optone;
  Heating;
  Cooling;
  Fans;
  Pumps;
  HeatRej;
  Lighting;
  DHW;
  Solar;
  Wind;
  rootDomainUrl;
  necbwwr;
  //Added by Divya
  newcustBaseHvac;
  custBaseNew1;
  custBaseDispWall;
  custBaseDispRoof;
  custBaseDispFloor;
  custBaseDispWin;
  custBaseDispLight;
  customeui;
  msgurl1;
  data1;
  toggleStatusNew;
  newcustHtRec;
  newcustumeui: any;
  msgurlNew: any;
  clickme: boolean = false;
  glbd: any;
  newdat: any;
  selectedWwr;
  htnewgl;
  cellten;
  wallone;
  roofone;
  florone;
  windone;
  shadone;
  ligtone;
  wwrone;
  dlone;
  hvacone;
  heatone;
  sumengurl;
  celltenmessage;
  celltwoNew;
  cellfourNew;
  cellthreeNew;
  solarselnew;
  //cellTenmessage: any;
  cellTenmessageNew;
  celltenNewmessage;
  celltenNew;
  cellseven;
  cellSevenmessage;
  celleight;
  cellEightmessage;
  cellnine;
  cellNinemessage;
  cellOption;
  cellopt;
  heatPeakurl;
  heatonenew;
  heatLoadDesign;
  coolLoadDesign;
  heatLoadBaseline;
  coolLoadBaseline;
  CoolingEnergyData;
  HeatingEnergyData;
  FansEnergyData;
  PumpsEnergyData;
  HeatRejEnergyData;
  LightingEnergyData;
  DHWEnergyData;
  RenewBaseline;
SolarBaseline;
WindBaseline;
  equipBaseline;
  RenewEnergyData;
  equipEnergyData;
solarEnergyData;
windEnergyData;
costpremium: any;
  euiC: any;
  costC: any;
  defaultId;
  newEmail;
  optionTotal;
  baselineTotal;
  wall_cost;
  roof_cost;
  flr_cost;
  win_cost;
  shading_cost;
  lpd_cost;
  daylight_sensor_cost;
  hvacCost;
  heatRecoveryCost;
  costSur;
  wwronerepNew;
  wall_costopt;
  roof_costopt;
  flr_costopt;
  win_costopt;
  shading_costopt;
  lpd_costopt;
  daylight_sensor_costopt;
  hvacCostopt;
  heatRecoveryCostopt;
  windCostopt;
  solarCostopt;
  savingone;
  cprep;
  euirep;
  newWwr;
  celloneNew;
  litNew;
  windCost;
  heatRecoveryCostLum;
  boilercopanCust;
  chillercopanCust;
HumData;
Hum;

  celltenNewHeat = 'Y';

  modvalNew;
  city;
  country;
  buildproj;

  ashraewall;
  necbwall;
  ashraeroof;
  necbroof;
  ashraefloor;
  necbfloor;

  walluval;
  wallip;

  roofuval;
  roofip;

  flooruval;
  floorip;

  winuval;
  winip;

  winshgc;
  custwwr;
  shadonerep;
  cellnineNew;
  wwronerep;

  lpduval;
  DLnew;

  inflt;

  occup;
  wallan;
  roofan;
  flooran;
  winan;
  winanshgc;
  heatrep;
  frAirrep;
  baselincool;
  baselinheat;
  optheat;
  optcool;
  hvaconerep;
  hvData;
  boilercop;
  chillercop;
  winipCust;
  winipBase;
  windselnew;
  ashwwr;

  boilercopan;
  chillercopan;
  newOptionMsg;

  frrep;
  frrepval;
  heatRec;
  savingsrep;
  euirepnew;
  costNew;
  cellsixlpd;
  celleightDl;
  screenwidth;
  screenheight;
  flooranfvi;
  roofrvi;
  walashnec;
  ebmbededCode;
  newwwrVal;

  demo_user_id = '5';
  demo_proj_id = '220';
  custheat;
  custcool;
  hvacID;
  hideAxisArr = [];
  currentkpiFactors;
  dynamicSingleWidth: number;
  math: Math;
ashrae : any;
necb : any;
cb : any;
baselineDefn : any;
  
  @ViewChild('content') content: ElementRef;
  currentHideArr: any[];
  combIdSelected: any;
  gridLen: any = 0;
  wwrSelected: any;
  co2: any;
  opCost1: any;
  actualName: any;
  custName: any;
  hvacIdSel: any;
  hvacIdNew: any;
allColumns = [
  "OPTIONS", "WALL", "ROOF", "Curtain Walls",
  "WINDOW", "INFILTRATION","SHADING", "DL", "WWR", "HVAC SYS",
  "HEAT REC.", "EUI", "%SAVINGS","CP", "CO2RED","OPCOST","PAYBACK"
];

visibleColumns: string[] = [];
  ashraeEnabled: any;
  necbEnabled: any;
  cbEnabled: any;
  catCustData: any;
  constructor(
    private authService: AuthService,
    private router: Router,
    private _location: Location,
    private http: HttpClient,
    public dialog: MatDialog
  ) {
    this.authService.proEnergy().subscribe((data) => {
      this.proDat = data;

      if (this.proDat.success != '3') {
       
        for (let [key, value] of Object.entries(this.proDat.readData[0])) {
          this.ids.push('[' + "'" + key + "'" + ',' + "'" + +value + "'" + ']');
        }
      }
    });
  }

  backClicked() {
    
    this.router.navigate(['mrfd']);
  }
  clickednew() {
    this.clickme = true;
  }
  clickednewSel() {
    this.clickme = false;
  }
  charttwofun() {
    document.getElementById('hel').style.display = 'none';
    document.getElementById('chartone').style.display = 'block';

    document.getElementById('btnon').style.border = '1px solid #ccc';
    document.getElementById('btnon').style.borderRadius = '6px 6px 0px 0px';
    document.getElementById('btnon').style.borderBottom = 'none';
    document.getElementById('btnon').style.color = '#000';
    document.getElementById('btntw').style.backgroundColor = '#fff';
    document.getElementById('btntw').style.color = '#4682b4';
    document.getElementById('btntw').style.border = 'none';
    document.getElementById('btntw').style.borderBottom = '1px solid #ccc';
  }
  chartonefun() {
    document.getElementById('hel').style.display = 'block';
    document.getElementById('chartone').style.display = 'none';

    document.getElementById('btntw').style.backgroundColor = '#fff';
    document.getElementById('btntw').style.color = '#000';
    document.getElementById('btntw').style.border = '1px solid #ccc';
    document.getElementById('btntw').style.borderRadius = '6px 6px 0px 0px';
    document.getElementById('btntw').style.borderBottom = 'none';
    document.getElementById('btnon').style.backgroundColor = '#fff';
    document.getElementById('btnon').style.color = '#4682b4';
    document.getElementById('btnon').style.border = 'none';
    document.getElementById('btnon').style.borderBottom = '1px solid #ccc';
  }

  // dragabble

  // scroll functions

  scrLeft() {
    document.querySelector('#allcharts').scrollLeft = 1225;
  }

  scrRight() {
    document.querySelector('#allcharts').scrollLeft = -1225;
  }

  //Make the DIV element draggagle:

  dragElement(elmnt) {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    if (document.getElementById(elmnt.id + 'header')) {
      /* if present, the header is where you move the DIV from:*/
      document.getElementById(elmnt.id + 'header').onmousedown = dragMouseDown;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
      elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  // diff chart start

  async diffChart() {
    
    if (1 == 1) {
      await (() => {
        if (this.newEmail == 'anuprathi1@gmail.com') {
          this.condId = this.newEventId;
          //  this.selectionUserId = this.newEventId;
        } else {
          this.condId = this.newUserId;
          //  this.selectionUserId = this.newUserId;
        }

        this.msgurlnw =
          this.rootDomainUrl +
          'adeos/api/monthly_energy_comparison.php?user_id=' +
          this.condId +
          '&proj_id=' +
          this.newProjId +
          '&baseline=' +
          '"' +
          this.newAshNecbNew +
          '"' +
          '&baselineWwr="0.1"' +
          '&' +
          '&wall=' +
          '"' +
          this.initWALL +
          '"' +
          '&roof=' +
          '"' +
          this.initROOF +
          '"' +
          '&floor=' +
          '"' +
          this.initfloor +
          '"' +
          '&window=' +
          '"' +
          this.initWINDOW +
          '"' +
          '&shading="YES"' +
          '&lighting="LPD3"' +
          '&wwr=' +
          '"' +
          this.initWWR +
          '"' +
          '&dl="DLOFF"' +
          '&hvac="VAV with Reheat"' +
          '&heatRecovery="N"';

        return this.http
          .get(this.msgurlnw)
          .pipe(map((res) => res))
          .subscribe((data) => {
            this.engTotal = data;
            this.engtotalnew = this.engTotal.EnergyDiff.janE;
            this.engtotalfeb = this.engTotal.EnergyDiff.febE;
            this.engtotalmar = this.engTotal.EnergyDiff.marE;
            this.engtotalapr = this.engTotal.EnergyDiff.aprE;
            this.engtotalmay = this.engTotal.EnergyDiff.mayE;
            this.engtotaljun = this.engTotal.EnergyDiff.junE;
            this.engtotaljul = this.engTotal.EnergyDiff.julE;
            this.engtotalaug = this.engTotal.EnergyDiff.augE;
            this.engtotalsep = this.engTotal.EnergyDiff.sepE;
            this.engtotaloct = this.engTotal.EnergyDiff.octE;
            this.engtotalnov = this.engTotal.EnergyDiff.novE;
            this.engtotaldec = this.engTotal.EnergyDiff.decE;
          });
      })();
    }
    if (1 == 1) {
      (() => {
        if (this.dls == 'NO') {
          var dl = 'DLOFF';
        }

        if (this.dls == 'YES') {
          var dl = 'DLON';
        }

        if (this.wal == 'R13') {
          var wall = 'W1';
        }

        if (this.wal == 'R20') {
          var wall = 'W2';
        }
        if (this.wal == 'R27') {
          var wall = 'W3';
        }
        if (this.wal == 'R30') {
          var wall = 'W4';
        }
        if (this.wal == 'R40') {
          var wall = 'W5';
        }
        if (this.wal == 'R50') {
          var wall = 'W6';
        }
        if (this.wal == 'R60') {
          var wall = 'W7';
        }
        if (this.newEmail == 'anuprathi1@gmail.com') {
          this.condId = this.newEventId;
        } else {
          this.condId = this.newUserId;
        }
        this.msgurlnwss =
          this.rootDomainUrl +
          'adeos/api/monthly_energy_comparison.php?user_id=' +
          this.condId +
          '&proj_id=' +
          this.newProjId +
          '&baseline=' +
          '"' +
          this.newAshNecbNew +
          '"' +
          '&baselineWwr="0.1"' +
          '&' +
          '&wall=' +
          '"' +
          wall +
          '"' +
          '&roof="R1"' +
          '&floor=' +
          '"' +
          this.initfloor +
          '"' +
          '&window="WIN01"' +
          '&shading="YES"' +
          '&lighting="LPD3"' +
          '&wwr=' +
          '"' +
          this.wwr +
          '"' +
          '&dl=' +
          '"' +
          dl +
          '"' +
          '&hvac="VAV with Reheat"' +
          '&heatRecovery="N"';

        return this.http
          .get(this.msgurlnwss)
          .pipe(map((res) => res))
          .subscribe((data) => {
            this.engTotalss = data;
            this.engtotalnewss = this.engTotalss.EnergyDiff.janE;
            this.engtotalssfeb = this.engTotalss.EnergyDiff.febE;
            this.engtotalssmar = this.engTotalss.EnergyDiff.marE;
            this.engtotalssapr = this.engTotalss.EnergyDiff.aprE;
            this.engtotalssmay = this.engTotalss.EnergyDiff.mayE;
            this.engtotalssjun = this.engTotalss.EnergyDiff.junE;
            this.engtotalssjul = this.engTotalss.EnergyDiff.julE;
            this.engtotalssaug = this.engTotalss.EnergyDiff.augE;
            this.engtotalsssep = this.engTotalss.EnergyDiff.sepE;
            this.engtotalssoct = this.engTotalss.EnergyDiff.octE;
            this.engtotalssnov = this.engTotalss.EnergyDiff.novE;
            this.engtotalssdec = this.engTotalss.EnergyDiff.decE;
          });
      })();
    }


    var margin = { top: 20, right: 20, bottom: 30, left: 50 },
      width = 800 - margin.left - margin.right,
      height = 400 - margin.top - margin.bottom;

    var parseDate = d3.time.format('%Y%m%d').parse;

    var x = d3.time.scale().range([0, width]);

    var y = d3.scale.linear().range([height, 0]);

    var xAxis = d3.svg.axis().scale(x).orient('bottom');

    var yAxis = d3.svg.axis().scale(y).orient('left');

    var line = d3.svg
      .area()
      .interpolate('basis')
      .x(function (d) {
        return x(d.date);
      })
      .y(function (d) {
        return y(d['New York']);
      });

    var area = d3.svg
      .area()
      .interpolate('basis')
      .x(function (d) {
        return x(d.date);
      })
      .y1(function (d) {
        return y(d['New York']);
      });

    var svg = d3
      .select('#diff_chart')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    d3.json(
      this.rootDomainUrl +
        'adeos/api/monthly_energy_comparison.php?user_id=' +
        this.condId +
        '&proj_id=' +
        this.newProjId +
        '&baseline=' +
        '"' +
        this.newAshNecbNew +
        '"' +
        '&baselineWwr="0.1"' +
        '&' +
        '&wall=' +
        '"' +
        this.initWALL +
        '"' +
        '&roof=' +
        '"' +
        this.initROOF +
        '"' +
        '&floor=' +
        '"' +
        this.initfloor +
        '"' +
        '&window=' +
        '"' +
        this.initWINDOW +
        '"' +
        '&shading="YES"' +
        '&lighting="LPD1"' +
        '&wwr=' +
        '"' +
        this.initWWR +
        '"' +
        '&dl="DLOFF"' +
        '&hvac="VAV with Reheat"' +
        '&heatRecovery="N"',
      (error, data) => {
       
        data = [
          {
            date: 20110101,
            'New York': this.engtotalnewss,
            'San Francisco': this.engtotalnew,
          },
          {
            date: 20110202,
            'New York': this.engtotalssfeb,
            'San Francisco': this.engtotalfeb,
          },
          {
            date: 20110303,
            'New York': this.engtotalssmar,
            'San Francisco': this.engtotalmar,
          },
          {
            date: 20110404,
            'New York': this.engtotalssapr,
            'San Francisco': this.engtotalapr,
          },
          {
            date: 20110505,
            'New York': this.engtotalssmay,
            'San Francisco': this.engtotalmay,
          },
          {
            date: 20110606,
            'New York': this.engtotalssjun,
            'San Francisco': this.engtotaljun,
          },
          {
            date: 20110707,
            'New York': this.engtotalssjul,
            'San Francisco': this.engtotaljul,
          },
          {
            date: 20110808,
            'New York': this.engtotalssaug,
            'San Francisco': this.engtotalaug,
          },
          {
            date: 20110909,
            'New York': this.engtotalsssep,
            'San Francisco': this.engtotalsep,
          },
          {
            date: 20111010,
            'New York': this.engtotalssoct,
            'San Francisco': this.engtotaloct,
          },
          {
            date: 20111111,
            'New York': this.engtotalssnov,
            'San Francisco': this.engtotalnov,
          },
          {
            date: 20111212,
            'New York': this.engtotalssdec,
            'San Francisco': this.engtotaldec,
          },
        ];

        if (error) throw error;
        data.forEach(function (d) {
          d.date = String(d.date);
          d.date = parseDate(d.date);
          d['New York'] = +d['New York'];
          d['San Francisco'] = +d['San Francisco'];
        });

        x.domain(
          d3.extent(data, function (d) {
            return d.date;
          })
        );

        y.domain([
          d3.min(data, function (d) {
            return Math.min(d['New York'], d['San Francisco']);
          }),
          d3.max(data, function (d) {
            return Math.max(d['New York'], d['San Francisco']);
          }),
        ]);

        svg.datum(data);

        svg
          .append('clipPath')
          .attr('id', 'clip-below')
          .append('path')
          .attr('d', area.y0(height));

        svg
          .append('clipPath')
          .attr('id', 'clip-above')
          .append('path')
          .attr('d', area.y0(0));

        svg
          .append('path')
          .attr('class', 'area above')
          .attr('clip-path', 'url(#clip-above)')
          .attr(
            'd',
            area.y0(function (d) {
              return y(d['San Francisco']);
            })
          );

        svg
          .append('path')
          .attr('class', 'area below')
          .attr('clip-path', 'url(#clip-below)')
          .attr('d', area);

        svg.append('path').attr('class', 'line').attr('d', line);

        svg
          .append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis);

        svg
          .append('g')
          .attr('class', 'y axis')
          .call(yAxis)
          .append('text')
          .attr('transform', 'rotate(-90)')
          .attr('y', 6)
          .attr('dy', '.71em')
          .style('text-anchor', 'end')
          .text('Temperature (ºF)');
      }
    );
  }

  // diff chart end

  // diff chart  Report start

  diffChartReport() {
    var margin = { top: 20, right: 20, bottom: 30, left: 50 },
      width = 800 - margin.left - margin.right,
      height = 400 - margin.top - margin.bottom;

    var parseDate = d3.time.format('%Y%m%d').parse;

    var x = d3.time.scale().range([0, width]);

    var y = d3.scale.linear().range([height, 0]);

    var xAxis = d3.svg.axis().scale(x).orient('bottom');

    var yAxis = d3.svg.axis().scale(y).orient('left');

    var line = d3.svg
      .area()
      .interpolate('basis')
      .x(function (d) {
        return x(d.date);
      })
      .y(function (d) {
        return y(d['New York']);
      });

    var area = d3.svg
      .area()
      .interpolate('basis')
      .x(function (d) {
        return x(d.date);
      })
      .y1(function (d) {
        return y(d['New York']);
      });

    var svg = d3
      .select('#diff_chart_report')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    d3.tsv('assets/diff.tsv', function (error, data) {
      if (error) throw error;
      data.forEach(function (d) {
        d.date = parseDate(d.date);

        d['New York'] = +d['New York'];
        d['San Francisco'] = +d['San Francisco'];
      });

      x.domain(
        d3.extent(data, function (d) {
          return d.date;
        })
      );

      y.domain([
        d3.min(data, function (d) {
          return Math.min(d['New York'], d['San Francisco']);
        }),
        d3.max(data, function (d) {
          return Math.max(d['New York'], d['San Francisco']);
        }),
      ]);

      svg.datum(data);

      svg
        .append('clipPath')
        .attr('id', 'clip-below')
        .append('path')
        .attr('d', area.y0(height));

      svg
        .append('clipPath')
        .attr('id', 'clip-above')
        .append('path')
        .attr('d', area.y0(0));

      svg
        .append('path')
        .attr('class', 'area above')
        .attr('clip-path', 'url(#clip-above)')
        .attr(
          'd',
          area.y0(function (d) {
            return y(d['San Francisco']);
          })
        );

      svg
        .append('path')
        .attr('class', 'area below')
        .attr('clip-path', 'url(#clip-below)')
        .attr('d', area);

      svg.append('path').attr('class', 'line').attr('d', line);

      svg
        .append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + height + ')')
        .call(xAxis);

      svg
        .append('g')
        .attr('class', 'y axis')
        .call(yAxis)
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '.71em')
        .style('text-anchor', 'end')
        .text('Temperature (ºF)');
    });
  }

  // diff chart Report end

  // group chart start

  groupChart() {
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: string = '5';
      var userProj: string = this.demo_proj_id;
    } else {
      var userDemo: string = this.condId;
      var userProj: string = this.newProjId;
    }

    var margin = { top: 20, right: 20, bottom: 30, left: 40 },
      width = 500 - margin.left - margin.right,
      height = 300 - margin.top - margin.bottom;

    var x0 = d3.scale.ordinal().rangeRoundBands([0, width], 0.1);

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear().range([height, 0]);

    var xAxis = d3.svg.axis().scale(x0).tickSize(0).orient('bottom');

    var yAxis = d3.svg.axis().scale(y).orient('left');

    var color = d3.scale
      .ordinal()
      // .range(["#ca0020","#f4a582","#d5d5d5","#92c5de","#0571b0"]);
      .range(['#4c82bb', '#c1534e']);
    var svg = d3
      .select('#group_chart')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    if (this.newAshNecb == 'Necb' && this.cellmessage !== 'dgt msg') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        encodeURIComponent(this.cellnine?.toString()) +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.cellSevenmessage;
    }

    if (this.newAshNecb == 'Ashare' && this.cellmessage !== 'dgt msg') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        encodeURIComponent(this.cellnine?.toString()) +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.cellSevenmessage;
    }

    // custom baseline start

    if (this.newAshNecb == 'noash' && this.cellmessage !== 'dgt msg') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        encodeURIComponent(this.cellnine?.toString()) +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.custwwr +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        this.authService.custHeat +
        '"';
    }

    // custom baseline end

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Ashare') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwrone +
        '&heatRecovery=' +
        '"' +
        encodeURIComponent(this.hvacone.toString()) +
        '"' +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        +this.cellSevenmessage;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Necb') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwrone +
        '&heatRecovery=' +
        '"' +
        encodeURIComponent(this.hvacone.toString()) +
        '"' +
        '&baseline=NECB' +
        '&baselineWwr=' +
        +this.cellSevenmessage;
    }
    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'noash') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwrone +
        '&heatRecovery=' +
        '"' +
        encodeURIComponent(this.hvacone.toString()) +
        '"' +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        '"' +
        this.custwwr +
        '"' +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        this.authService.custHeat +
        '"';
    }

   
    if (this.newAshNecb == 'noash') {
      var cust = 'CUSTOM';
    }
    if (this.newAshNecb == 'Ashare') {
      var cust = 'ASHRAE';
    }
    if (this.newAshNecb == 'Necb') {
      var cust = 'NECB';
    }

    d3.json(this.heatPeakurl, (error, data) => {
      data = [
        {
          categorie: 'PEAK HEATING LOAD',
          values: [
            {
              value: data?.EnergyDiff?.heatLoadDesign ? +data?.EnergyDiff?.heatLoadDesign : '',
              rate: this.cellOption,
            },

            {
              value: data?.EnergyDiff?.heatLoadBaseline ? +data?.EnergyDiff?.heatLoadBaseline : "",
              rate: cust,
            },
          ],
        },
        {
          categorie: 'PEAK COOLING LOAD',
          values: [
            {
              value: data?.EnergyDiff?.coolLoadDesign ? +data?.EnergyDiff?.coolLoadDesign : "",
              rate: this.cellOption,
            },

            {
              value: data?.EnergyDiff?.coolLoadBaseline ?  +data?.EnergyDiff?.coolLoadBaseline : "",
              rate: cust,
            },
          ],
        },
      ];

      this.heatLoadDesign = data.map((d) => d.values[0].value)[0];
      this.heatLoadBaseline = data.map((d) => d.values[1].value)[0];

      this.coolLoadDesign = data.map((d) => d.values[0].value)[1];
      this.coolLoadBaseline = data.map((d) => d.values[1].value)[1];

      var categoriesNames = data.map(function (d) {
        return d.categorie;
      });
      var rateNames = data[0].values.map(function (d) {
        return d.rate;
      });

      x0.domain(categoriesNames);
      x1.domain(rateNames).rangeRoundBands([0, x0.rangeBand()]);
      y.domain([
        0,
        d3.max(data, function (categorie) {
          return d3.max(categorie.values, function (d) {
            return d.value;
          });
        }),
      ]);

      svg
        .append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + height + ')')
        .call(xAxis);

      svg
        .append('g')
        .attr('class', 'y axis')
        .style('opacity', '0')
        .call(yAxis)
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '.71em')
        .style('text-anchor', 'end')
        .style('font-weight', 'bold')
        .text('Value');

      svg
        .select('.y')
        .transition()
        .duration(500)
        .delay(1300)
        .style('opacity', '1');

      var slice = svg
        .selectAll('.slice')
        .data(data)
        .enter()
        .append('g')
        .attr('class', 'g')
        .attr('transform', function (d) {
          return 'translate(' + x0(d.categorie) + ',0)';
        });

      slice
        .selectAll('rect')
        .data(function (d) {
          return d.values;
        })
        .enter()
        .append('rect')
        .attr('width', x1.rangeBand())
        .attr('x', function (d) {
          return x1(d.rate);
        })
        .style('fill', function (d) {
          return color(d.rate);
        })
        .attr('y', function (d) {
          return y(0);
        })
        .attr('height', function (d) {
          return height - y(0);
        })
        .on('mouseover', function (d) {
          d3.select(this).style('fill', d3.rgb(color(d.rate)).darker(2));
        })
        .on('mouseout', function (d) {
          d3.select(this).style('fill', color(d.rate));
        });

      slice
        .selectAll('rect')
        .transition()
        .delay(function (d) {
          return Math.random() * 1000;
        })
        .duration(1000)
        .attr('y', function (d) {
          return y(d.value);
        })
        .attr('height', function (d) {
          return height - y(d.value);
        });

      //Legend
      var legend = svg
        .selectAll('.legend')
        .data(
          data[0].values
            .map(function (d) {
              return d.rate;
            })
            .reverse()
        )
        .enter()
        .append('g')
        .attr('class', 'legend')
        .attr('transform', function (d, i) {
          return 'translate(0,' + i * 20 + ')';
        })
        .style('opacity', '0');

      legend
        .append('rect')
        .attr('x', width - 18)
        .attr('width', 18)
        .attr('height', 18)
        .style('fill', function (d) {
          return color(d);
        });

      legend
        .append('text')
        .attr('x', width + 1)
        .attr('y', 9)
        .attr('dy', '.35em')
        .style('text-anchor', 'start')
        .style('font-size', '10px')
        .text(function (d) {
          return d;
        });

      legend
        .transition()
        .duration(500)
        .delay(function (d, i) {
          return 1300 + 100 * i;
        })
        .style('opacity', '1');
    });
  }

  // group chart end

  // group chart  Rep ortstart

  groupChartRep() {
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: string = '5';
      var userProj: string = this.demo_proj_id;
    } else {
      var userDemo: string = this.condId;
      var userProj: string = this.newProjId;
    }
    var margin = { top: 20, right: 20, bottom: 30, left: 40 },
      width = 500 - margin.left - margin.right,
      height = 300 - margin.top - margin.bottom;

    var x0 = d3.scale.ordinal().rangeRoundBands([0, width], 0.1);

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear().range([height, 0]);

    var xAxis = d3.svg.axis().scale(x0).tickSize(0).orient('bottom');

    var yAxis = d3.svg.axis().scale(y).orient('left');

    var color = d3.scale
      .ordinal()
      // .range(["#ca0020","#f4a582","#d5d5d5","#92c5de","#0571b0"]);
      .range(['#4c82bb', '#c1534e']);
    var svg = d3
      .select('#group_chart_Rep')
      .append('svg')
      .attr('width', 560)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    if (this.newAshNecb == 'Necb' && this.cellmessage !== 'dgt msg') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        encodeURIComponent(this.cellnine.toString()) +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.cellSevenmessage;
    }

    if (this.newAshNecb == 'Ashare' && this.cellmessage !== 'dgt msg') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        encodeURIComponent(this.cellnine.toString()) +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.cellSevenmessage;
    }

    // custom baseline start

    if (this.newAshNecb == 'noash' && this.cellmessage !== 'dgt msg') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        encodeURIComponent(this.cellnine.toString()) +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.custwwr +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        this.authService.custHeat +
        '"';
    }

    // custom baseline end

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Ashare') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwrone +
        '&heatRecovery=' +
        '"' +
        encodeURIComponent(this.hvacone.toString()) +
        '"' +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        +this.cellSevenmessage;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Necb') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwrone +
        '&heatRecovery=' +
        '"' +
        encodeURIComponent(this.hvacone.toString()) +
        '"' +
        '&baseline=NECB' +
        '&baselineWwr=' +
        +this.cellSevenmessage;
    }
    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'noash') {
      this.heatPeakurl =
        this.rootDomainUrl +
        'adeos/api/heatPeakLoad_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwrone +
        '&heatRecovery=' +
        '"' +
        encodeURIComponent(this.hvacone.toString()) +
        '"' +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        '"' +
        this.custwwr +
        '"' +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        this.authService.custHeat +
        '"';
    }


    if (this.newAshNecb == 'noash') {
      var cust = 'CUSTOM';
    }
    if (this.newAshNecb == 'Ashare') {
      var cust = 'ASHRAE';
    }
    if (this.newAshNecb == 'Necb') {
      var cust = 'NECB';
    }

    d3.json(this.heatPeakurl, (error, data) => {
      data = [
        {
          categorie: 'PEAK HEATING LOAD',
          values: [
            {
              value: +data.EnergyDiff.heatLoadDesign,
              rate: this.cellOption,
            },

            {
              value: +data.EnergyDiff.heatLoadBaseline,
              rate: cust,
            },
          ],
        },
        {
          categorie: 'PEAK COOLING LOAD',
          values: [
            {
              value: +data.EnergyDiff.coolLoadDesign,
              rate: this.cellOption,
            },

            {
              value: +data.EnergyDiff.coolLoadBaseline,
              rate: cust,
            },
          ],
        },
      ];

      this.heatLoadDesign = data.map((d) => d.values[0].value)[0];
      this.heatLoadBaseline = data.map((d) => d.values[1].value)[0];

      this.coolLoadDesign = data.map((d) => d.values[0].value)[1];
      this.coolLoadBaseline = data.map((d) => d.values[1].value)[1];

      var categoriesNames = data.map(function (d) {
        return d.categorie;
      });
      var rateNames = data[0].values.map(function (d) {
        return d.rate;
      });

      x0.domain(categoriesNames);
      x1.domain(rateNames).rangeRoundBands([0, x0.rangeBand()]);
      y.domain([
        0,
        d3.max(data, function (categorie) {
          return d3.max(categorie.values, function (d) {
            return d.value;
          });
        }),
      ]);

      svg
        .append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + height + ')')
        .call(xAxis);

      svg
        .append('g')
        .attr('class', 'y axis')
        .style('opacity', '0')
        .call(yAxis)
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '.71em')
        .style('text-anchor', 'end')
        .style('font-weight', 'bold')
        .text('Value');

      svg
        .select('.y')
        .transition()
        .duration(500)
        .delay(1300)
        .style('opacity', '1');

      var slice = svg
        .selectAll('.slice')
        .data(data)
        .enter()
        .append('g')
        .attr('class', 'g')
        .attr('transform', function (d) {
          return 'translate(' + x0(d.categorie) + ',0)';
        });

      slice
        .selectAll('rect')
        .data(function (d) {
          return d.values;
        })
        .enter()
        .append('rect')
        .attr('width', x1.rangeBand())
        .attr('x', function (d) {
          return x1(d.rate);
        })
        .style('fill', function (d) {
          return color(d.rate);
        })
        .attr('y', function (d) {
          return y(0);
        })
        .attr('height', function (d) {
          return height - y(0);
        })
        .on('mouseover', function (d) {
          d3.select(this).style('fill', d3.rgb(color(d.rate)).darker(2));
        })
        .on('mouseout', function (d) {
          d3.select(this).style('fill', color(d.rate));
        });

      slice
        .selectAll('rect')
        .transition()
        .delay(function (d) {
          return Math.random() * 1000;
        })
        .duration(1000)
        .attr('y', function (d) {
          return y(d.value);
        })
        .attr('height', function (d) {
          return height - y(d.value);
        });

      //Legend
      var legend = svg
        .selectAll('.legend')
        .data(
          data[0].values
            .map(function (d) {
              return d.rate;
            })
            .reverse()
        )
        .enter()
        .append('g')
        .attr('class', 'legend')
        .attr('transform', function (d, i) {
          return 'translate(0,' + i * 20 + ')';
        })
        .style('opacity', '0');

      legend
        .append('rect')
        .attr('x', width - 18)
        .attr('width', 18)
        .attr('height', 18)
        .style('fill', function (d) {
          return color(d);
        });

      legend
        .append('text')
        .attr('x', width + 1)
        .attr('y', 9)
        .attr('dy', '.35em')
        .style('text-anchor', 'start')
        .style('font-size', '10px')
        .text(function (d) {
          return d;
        });

      legend
        .transition()
        .duration(500)
        .delay(function (d, i) {
          return 1300 + 100 * i;
        })
        .style('opacity', '1');
    });
  }

  // group chart Report end

  // stacked chart start

  stackedChart() {
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: string = '5';
      var userProj = this.demo_proj_id;
    } else {
      var userDemo: string = this.condId;
      var userProj: string = this.newProjId;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Ashare') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.dlone+
        '&hvac=' +
        this.hvacIdSel +
        '&baselineHvac=' +
        this.hvacID;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Necb') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.dlone+
        '&hvac=' +
        this.hvacIdSel+
        '&baselineHvac=' +
        this.hvacID;
        
    }

    if (this.newAshNecb == 'Necb' && this.cellmessage !== 'dgt msg') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected +
        '&heatRecovery=' +
        this.celltenNewmessage +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.cellEightmessage + '&hvac=' +
        this.hvacIdSel+
        '&baselineHvac=' +
        this.hvacID;
    }

    if (this.newAshNecb == 'Ashare' && this.cellmessage !== 'dgt msg') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
         this.combIdSelected+
        '&heatRecovery=' +
        this.celltenNewmessage +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.cellEightmessage + '&hvac=' +
        this.hvacIdSel +
        '&baselineHvac=' +
        this.hvacID;
    }
    if (this.authService.custHeat == 'Y') {
      var cuheat = 'Y';
    }
    if (this.authService.custHeat == 'N') {
      var cuheat = 'N';
    }
    if (this.authService.custDl == 'YES') {
      var custDLnew = 'DLON';
    }
    if (this.authService.custDl == 'NO') {
      var custDLnew = 'DLOFF';
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'noash') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        '"' +
        this.cellSevenmessage +
        '"' +
        '&dl=' +
        this.dlone +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        cuheat +
        '"' +
        '&customHvac=' +
        '"' +
        encodeURIComponent(this.authService.custHvac.toString()) +
        '"' +
        '&customDl=' +
        '"' +
        custDLnew +
        '"'+ '&hvac=' +
        this.hvacIdSel;;
    }

    if (this.cellmessage !== 'dgt msg' && this.newAshNecb == 'noash') {
      var wwr = (this.newcustBaseWwr.replace('%', '') / 100).toFixed(3);
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        '"' +
        wwr  +
        '"' +
        '&dl=' +
        this.cellEightmessage +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        cuheat +
        '"' +
        '&customHvac=' +
        '"' +
        encodeURIComponent(this.authService.custHvac.toString()) +
        '"' +
        '&customDl=' +
        '"' +
        custDLnew +
        '"'+ '&hvac=' +
        this.hvacIdSel;;
    }

  
    return this.http
      .get(msgurlnwstchart)
      .pipe(map((res) => res))
      .subscribe((data) => {
        this.optone = data;

        this.Heating = +this.optone.BaselineData.heating_energy_total;
        this.Cooling = +this.optone.BaselineData.cooling_energy_total;
        this.Fans = +this.optone.BaselineData.TotalDistrFanEnergy;
        this.Pumps = +this.optone.BaselineData.TotalDistrPumpE;
        this.HeatRej = +this.optone.BaselineData.TotalHeatRejPumpE;
    this.Hum = +this.optone.BaselineData.hum_energy;
        this.Lighting = +this.optone.BaselineData.lighting_energy_total;
        this.DHW = +this.optone.BaselineData.Total_DHW;
        this.RenewBaseline = +this.optone.BaselineData.Renewables.replace(/,/g, '');
    this.SolarBaseline = +this.optone.BaselineData.Total_Solar;
    this.WindBaseline = +this.optone.BaselineData.Total_Wind;
        this.equipBaseline = +this.optone.BaselineData.equip_energy_total;
        this.baselineTotal =
          this.Heating +
          this.Cooling +
          this.Fans +
          this.Pumps +
          this.HeatRej +
          this.Lighting +
          this.DHW +
          this.equipBaseline+
    this.Hum;

        this.HeatingEnergyData = +this.optone.EnergyData.heating_energy_total;
        this.CoolingEnergyData = +this.optone.EnergyData.cooling_energy_total;
        this.FansEnergyData = +this.optone.EnergyData.TotalDistrFanEnergy;
        this.PumpsEnergyData = +this.optone.EnergyData.TotalDistrPumpE;
        this.HeatRejEnergyData = +this.optone.EnergyData.TotalHeatRejPumpE;
    this.HumData = +this.optone.EnergyData.hum_energy;
        this.LightingEnergyData = +this.optone.EnergyData.lighting_energy_total;
        this.DHWEnergyData = +this.optone.EnergyData.Total_DHW;
        this.RenewEnergyData = +this.optone.EnergyData.Renewables.replace(/,/g, '');
    this.windEnergyData = +this.optone.EnergyData.Total_Wind;
    this.solarEnergyData = +this.optone.EnergyData.Total_Solar;
        this.equipEnergyData = +this.optone.EnergyData.equip_energy_total;

        this.optionTotal =
          this.HeatingEnergyData +
          this.CoolingEnergyData +
          this.FansEnergyData +
          this.PumpsEnergyData +
          this.HeatRejEnergyData +
          this.LightingEnergyData +
          this.DHWEnergyData +
          this.RenewEnergyData +
          this.equipEnergyData +
    this.HumData;

        //  this.DHW = +this.optone.EnergyData.Total_DHW
        //   this.Solar = +this.optone.EnergyData.Total_Solar
        //  this.Wind = +this.optone.EnergyData.Total_Wind

        if (data) {
          var margin = { top: 20, right: 160, bottom: 35, left: 30 };

          var width = 500 - margin.left - margin.right,
            height = 280 - margin.top - margin.bottom;

          var svg = d3
            .select('#stack_chart')
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr(
              'transform',
              'translate(' + (margin.left+80) + ',' + margin.top + ')'
            );

          if (this.newAshNecb == 'noash') {
            var cust = this.cb;
          }
          if (this.newAshNecb == 'Ashare') {
            var cust = this.ashrae;
          }
          if (this.newAshNecb == 'Necb') {
            var cust = this.necb;
          }

          /* Data in strings like it would be if imported from a csv */

          var datanew = [
            {
              year: this.cellOption,
              Lighting: this.LightingEnergyData,
              Cooling: this.CoolingEnergyData,
              Heating: this.HeatingEnergyData,
              Fans: this.FansEnergyData,
              Pumps: this.PumpsEnergyData,
              DHW: this.DHWEnergyData,
              HeatRej: this.HeatRejEnergyData,
              Renew: this.RenewEnergyData,
              Equip: this.equipEnergyData,
              Humidification:this.HumData,
            },

            {
              year: cust,
              Lighting: this.Lighting,
              Cooling: this.Cooling,
              Heating: this.Heating,
              Fans: this.Fans,
              Pumps: this.Pumps,
              DHW: this.DHW,
              HeatRej: this.HeatRej,
              Renew: 0,
              Equip: this.equipBaseline,
              Humidification:this.Hum,
            },
          ];

          var parse = d3.time.format('%Y').parse;

          // Transpose the data into layers
          var categories = [
  'Heating',
  'Cooling',
  'Fans',
  'Pumps',
  'Humidification',
  'HeatRej',
  'Lighting',
  'Equip',
  'DHW',
  'Renew'
];

var dataset = categories.map(function(category) {
  return datanew.map(function(d) {

    var value = +d[category];

    if (isNaN(value)) {
      value = 0;
    }

    return {
      x: d.year,
      y: value,
      y0: 0
    };
  });
});


// Stack positive and negative values separately
for (var barIndex = 0; barIndex < datanew.length; barIndex++) {

  var positiveY = 0;
  var negativeY = 0;

  for (var layerIndex = 0; layerIndex < dataset.length; layerIndex++) {

    var item = dataset[layerIndex][barIndex];

    if (item.y >= 0) {

      item.y0 = positiveY;
      positiveY += item.y;

    } else {

      item.y0 = negativeY;
      negativeY += item.y;

    }
  }
}

          // sanitize numeric values but keep negative numbers so chart can show them
          dataset.forEach(function (layer) {
            layer.forEach(function (d) {
              if (isNaN(d.y) || d.y === null) d.y = 0;
              if (isNaN(d.y0) || d.y0 === null) d.y0 = 0;
            });
          });

         


          // Set x, y and colors
          var x = d3.scale
            .ordinal()
            .domain(
              dataset[0].map(function (d) {
                return d.x;
              })
            )
            .rangeRoundBands([10, width - 10], 0.02);

          // compute min/max including negative stacks so axis covers full range
          var yMin = d3.min(dataset, function (layer) {
            return d3.min(layer, function (d) {
              return d.y0;
            });
          });
          var yMax = d3.max(dataset, function (layer) {
            return d3.max(layer, function (d) {
              return d.y0 + d.y;
            });
          });
          var y = d3.scale
            .linear()
            .domain([Math.min(0, yMin), Math.max(0, yMax)])
            .range([height, 0]);

          var colors = [
            '#C1534E',
            '#4C82BB',
            '#95D23E',
            '#A896DB',
            '#2AD9C5',
            '#bb854c',
            '#000000',
            '#cccccc',
             '#D2691E',
            '#F7CE41',
           
      
          ];





          // Define and draw axes
          var yAxis = d3.svg
            .axis()
            .scale(y)
            .orient('left')
            .ticks(5)
            .tickSize(-width, 0, 0)
            .tickFormat(function (d) {
              return d;
            });

          var xAxis = d3.svg.axis().scale(x).orient('bottom');
          // .tickFormat(d3.time.format("%Y"));

          svg.append('g').attr('class', 'y axis').call(yAxis);

          svg
            .append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

          // Create groups for each series, rects for each segment
          var groups = svg
            .selectAll('g.cost')
            .data(dataset)
            .enter()
            .append('g')
            .attr('class', 'cost')
            .style('fill', function (d, i) {
              return colors[i];
            });

          var rect = groups
            .selectAll('rect')
            .data(function (d) {
              return d;
            })
            .enter()
            .append('rect')
            .attr('x', function (d) {
              return x(d.x);
            })
            .attr('y', function (d) {
              return y(Math.max(d.y0, d.y0 + d.y));
            })
            .attr('height', function (d) {
              return Math.abs(y(d.y0) - y(d.y0 + d.y));
            })
            .attr('width', x.rangeBand()-30)
            .on('mouseover', function () {
              tooltip.style('display', null);
            })
            .on('mouseout', function () {
              tooltip.style('display', 'none');
            })
            .on('mousemove', function (d) {
              var xPosition = d3.mouse(this)[0] - 15;
              var yPosition = d3.mouse(this)[1] - 25;
              tooltip.attr(
                'transform',
                'translate(' + xPosition + ',' + yPosition + ')'
              );
              tooltip.select('text').text(d.y);
            });

          // Draw legend
          var legend = svg
            .selectAll('.legend')
            .data(colors)
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', function (d, i) {
              return 'translate(30,' + i * 19 + ')';
            });
      
          legend
            .append('rect')
            .attr('x', width - 18)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', function (d, i) {
              return [
  '#D2691E', // DHW
  '#F7CE41', // Renewables
  '#cccccc', // Equipment
  '#000000', // Lighting
  '#bb854c', // HeatRej
  '#2AD9C5', // Humidification
  '#A896DB', // Pumps
  '#95D23E', // Fans
  '#4C82BB', // Cooling
  '#C1534E'  // Heating
][i];
            });

          legend
            .append('text')
            .attr('x', width + 5)
            .attr('y', 9)
            .attr('dy', '.35em')
            .style('text-anchor', 'start')
            .text(function (d, i) {
              switch (i) {
                case 0:
                  return 'DHW';
                case 1:
                  return 'Renewables';
                case 2:
                  return 'Equipment';
                case 3:
                  return 'Lighting';
                case 4:
                  return 'HeatRej';
                case 5:
                  return 'Humidification';
                case 6:
                  return 'Pumps';
                case 7:
                  return 'Fans';
                case 8:
                  return 'Cooling';
        case 9:
                  return 'Heating';
              }
            });

          // Prep the tooltip bits, initial display is hidden
          var tooltip = svg
            .append('g')
            .attr('class', 'tooltip')
            .style('display', 'none');

          tooltip
            .append('rect')
            .attr('width', 30)
            .attr('height', 20)
            .attr('fill', 'white')
            .style('opacity', 0.5);

          tooltip
            .append('text')
            .attr('x', 15)
            .attr('dy', '1.2em')
            .style('text-anchor', 'middle')
            .attr('font-size', '12px')
            .attr('font-weight', 'bold');
      
      
      
      //stack chart end
      // grouped bar chart start
       margin = {top: 20, right: 20, bottom: 30, left: 40},
  width = 650 + margin.left + margin.right,
  height = 280 - margin.top - margin.bottom;
      var datanew1 = [
              
            {
      "categorie": "Heating",
      "values": [
            
        {
        "value": this.HeatingEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.Heating, 
        "rate": cust
        }, 
        
      ]
            },
      {
      "categorie": "Cooling",
      "values": [
            
        {
        "value": this.CoolingEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.Cooling, 
        "rate": cust
        }, 
        
      ]
            },
       {
      "categorie": "Fans",
      "values": [
            
        {
        "value": this.FansEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.Fans, 
        "rate": cust
        }, 
        
      ]
            },
      {
      "categorie": "Pumps",
      "values": [
            
        {
        "value": this.PumpsEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.Pumps, 
        "rate": cust
        }, 
        
      ]
            },
      {
      "categorie": "Heat Rej",
      "values": [
            
        {
        "value": this.HeatRejEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.HeatRej, 
        "rate": cust
        }, 
        
      ]
            },
       {
      "categorie": "Hum/Pro",
      "values": [
            
        {
        "value": this.HumData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.Hum, 
        "rate": cust
        }, 
        
      ]
            },
            {
              "categorie": "DHW",
              "values": [
                    
                {
                "value": this.DHWEnergyData, 
                "rate": this.cellOption
                }, 
                {
                "value": this.DHW, 
                "rate": cust
                }, 
                
              ]
                    },
     
      {
              "categorie": "Lighting",
      "values": [
        {
        "value": this.LightingEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.Lighting, 
        "rate": cust
        }, 
        
    
      ]
            },
      {
      "categorie": "Equipment",
      "values": [
            
        {
        "value": this.equipEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": this.equipBaseline, 
        "rate": cust
        }, 
        
      ]
            },
      
      {
      "categorie": "Renewables",
      "values": [
            
        {
        "value": this.RenewEnergyData, 
        "rate": this.cellOption
        }, 
        {
        "value": 0, 
        "rate": cust
        }, 
        
      ]
            },
          
          ];
    var svg = d3
            .select('#chartneg')
            .append('svg')
            .attr('width', width + margin.left + margin.right+200)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr(
              'transform',
              'translate(' + (margin.left+30) + ',' + margin.top + ')'
            );
    var x0 = d3.scale.ordinal().rangeRoundBands([0, width], .1);
    var y0 = Math.max(Math.abs(d3.min(datanew1)), Math.abs(d3.max(datanew1)));
    var x1 = d3.scale.ordinal();

    var x0 = d3.scale.ordinal().rangeRoundBands([0, width], .1);

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear().range([height, 0]);

    var netTotals = datanew.map(function (d) {

  var total = 0;

  categories.forEach(function (category) {

    var value = Number(d[category]);

    if (!isNaN(value)) {
      total += value;
    }

  });

  return {
    year: d.year,
    total: total
  };

});
    var xAxis = d3.svg.axis()
      .scale(x0)
      .tickSize(0)
      .orient("bottom");

    var yAxis = d3.svg.axis()
      .scale(y)
      .ticks(5)
       .tickSize(-width, 0, 0)
      .orient("left");

    var color = d3.scale.ordinal()
      .range(['#6F57E8 ', '#01CCCA']);



    var categoriesNames = datanew1.map(function(d) { return d.categorie; });
    var rateNames = datanew1[0].values.map(function(d) { return d.rate; });

    x0.domain(categoriesNames);
    x1.domain(rateNames).rangeRoundBands([0, x0.rangeBand()]);
      
    y.domain([d3.min(datanew1, function(categorie) { return d3.min(categorie.values, function(d) { return d.value; }); }), d3.max(datanew1, function(categorie) { return d3.max(categorie.values, function(d) { return d.value; }); })]);
  
     svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis);

      svg.append("g")
        .attr("class", "y axis")
        .style('opacity','0')
        .call(yAxis)
      .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".71em")
        .style("text-anchor", "end")
        .style('font-weight','bold')
        .text("Value");


      svg.select('.y').transition().duration(500).delay(1300).style('opacity','1');
      
       svg
              .append('g')
              .attr('class', 'infowin')
              .attr('transform', 'translate(50, 0)')
              .append('text')
              .attr('id', '_yr');


      var slice = svg.selectAll(".slice")
        .data(datanew1)
        .enter().append("g")
        .attr("class", "g")
        .attr("transform",function(d) { return "translate(" + x0(d.categorie) + ",0)"; });
      var tooltip = svg
        .append('g')
        .attr('class', 'tooltip')
        .style('display', 'none');
        
      slice.selectAll("rect")
        .data(function(d) { return d.values; })
      .enter().append("rect")
        .attr("width", x1.rangeBand())
        .attr("x", function(d) { return x1(d.rate); })
        .style("fill", function(d) { return color(d.rate) })
        .attr("height", function(d) { return height - y(0); }) 
        .attr("y", function(d) { return y(0); })
       .attr("height", function(d) { return height - y(0); })
      // .append('title').text(function(d) {`Sales were ${d.sales} in ${d.value}`})
        .on("mouseover", function(d) {
          d3.select(this).style("fill", d3.rgb(color(d.rate)).darker(2));
          tooltip.style('display', null);
        })
        .on("mouseout", function(d) {
          d3.select(this).style("fill", color(d.rate));
          tooltip.style('display', 'none');
        })
        .on('mousemove', function (d) {
        /*var xPosition = d3.mouse(this)[0] - 15;
        var yPosition = d3.mouse(this)[1] - 25;
        tooltip.attr(
          'transform',
          'translate(' + xPosition + ',' + yPosition + ')'
        );
        tooltip.select('text').text(d.value);
        d3.select('#_yr').text(d.Year + ':');
        d3.select('#degrree').text(d.Celsius + ' ' + '(MWh)');
        */
         const text = d3.select('#_yr');
        //text.text(`Sales were ${d.categorie} in ${d.value}`);
        text.text(this.parentNode.__data__.categorie+' : '+d.value );
        
        });

      slice.selectAll("rect")
      .transition()
      .delay(function (d) {return Math.random()*1000;})
      .duration(1000)
      .attr("y", d => Math.min(y(d.value), y(0)))
      .attr("height", d => Math.sign(d.value) * (y(0) - y(d.value)))

      //Legend
      var legend = svg.selectAll(".legend")
         .data(datanew1[0].values.map(function(d) { return d.rate; }).reverse())
        .enter().append("g")
        .attr("class", "legend")
        .attr("transform", function(d,i) { return "translate(" + (i+1) * -250 + ",255)"; })
        .style("opacity","0");

      legend.append("rect")
        .attr("x", width - 18)
        .attr("width", 18)
        .attr("height", 18)
        .style("fill", function(d) { return color(d); });

      legend.append("text")
        .attr("x", width - 24)
        .attr("y", 9)
        .attr("dy", ".35em")
        .style("text-anchor", "end")
        .text(function(d) {return d; });

      legend.transition().duration(500).delay(function(d,i){ return 1300 + 100 * i; }).style("opacity","1");
       // Prep the tooltip bits, initial display is hidden
    
  
      tooltip
        .append('rect')
        .attr('width', 30)
        .attr('height', 20)
        .attr('fill', 'white')
        .style('opacity', 0.5);
  
      tooltip
        .append('text')
        .attr('x', 15)
        .attr('dy', '1.2em')
        .style('text-anchor', 'middle')
        .attr('font-size', '12px')
        .attr('font-weight', 'bold');
            //grouped bar chart end
          }
        });
  } // func end

  // stack chart report start

  stackedChartReportNew() {
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: string = '5';
      var userProj = this.demo_proj_id;
    } else {
      var userDemo: string = this.condId;
      var userProj: string = this.newProjId;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Ashare') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.dlone +
        '&baselineHvac=' +
        this.hvacID;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Necb') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
         this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.dlone
        '&baselineHvac=' +
        this.hvacID +
        '&baselineHvac=' +
        this.hvacID;
    }

    if (this.newAshNecb == 'Necb' && this.cellmessage !== 'dgt msg') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.celltenNewmessage +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.cellEightmessage +
        '&baselineHvac=' +
        this.hvacID;
    }

    if (this.newAshNecb == 'Ashare' && this.cellmessage !== 'dgt msg') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.celltenNewmessage +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&dl=' +
        this.cellEightmessage +
        '&baselineHvac=' +
        this.hvacID;
    }
    if (this.authService.custHeat == 'YES') {
      var cuheat = 'Y';
    }
    if (this.authService.custHeat == 'NO') {
      var cuheat = 'N';
    }
    if (this.authService.custDl == 'YES') {
      var custDLnew = 'DLON';
    }
    if (this.authService.custDl == 'NO') {
      var custDLnew = 'DLOFF';
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'noash') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        '"' +
        this.cellSevenmessage +
        '"' +
        '&dl=' +
        this.dlone +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        cuheat +
        '"' +
        '&customHvac=' +
        '"' +
        this.authService.custHvac +
        '"' +
        '&customDl=' +
        '"' +
        custDLnew +
        '"';
    }
    if (this.cellmessage !== 'dgt msg' && this.newAshNecb == 'noash') {
       var wwr = (this.newcustBaseWwr.replace('%', '') / 100).toFixed(3);
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/energy_comparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&cID=' +
        this.combIdSelected+
        '&heatRecovery=' +
        this.heatone +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        '"' +
        wwr  +
        '"' +
        '&dl=' +
        this.cellEightmessage +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        '"' +
        cuheat +
        '"' +
        '&customHvac=' +
        '"' +
        this.authService.custHvac +
        '"' +
        '&customDl=' +
        '"' +
        custDLnew +
        '"';
    }

    return this.http
      .get(msgurlnwstchart)
      .pipe(map((res) => res))
      .subscribe((data) => {
        this.optone = data;

        this.Heating = +this.optone.BaselineData.heating_energy_total;
        this.Cooling = +this.optone.BaselineData.cooling_energy_total;
        this.Fans = +this.optone.BaselineData.TotalDistrFanEnergy;
        this.Pumps = +this.optone.BaselineData.TotalDistrPumpE;
        this.HeatRej = +this.optone.BaselineData.TotalHeatRejPumpE;
    this.Hum = +this.optone.BaselineData.hum_energy;
        this.Lighting = +this.optone.BaselineData.lighting_energy_total;
        this.DHW = +this.optone.BaselineData.Total_DHW;
        this.RenewBaseline = +this.optone.BaselineData.Renewables;
        this.equipBaseline = +this.optone.BaselineData.equip_energy_total;
        this.baselineTotal =
          this.Heating +
          this.Cooling +
          this.Fans +
          this.Pumps +
          this.HeatRej +
          this.Lighting +
          this.DHW +
          this.equipBaseline +
    this.Hum;
        

        this.HeatingEnergyData = +this.optone.EnergyData.heating_energy_total;
        this.CoolingEnergyData = +this.optone.EnergyData.cooling_energy_total;
        this.FansEnergyData = +this.optone.EnergyData.TotalDistrFanEnergy;
        this.PumpsEnergyData = +this.optone.EnergyData.TotalDistrPumpE;
        this.HeatRejEnergyData = +this.optone.EnergyData.TotalHeatRejPumpE;
    this.HumData = +this.optone.EnergyData.hum_energy;
        this.LightingEnergyData = +this.optone.EnergyData.lighting_energy_total;
        this.DHWEnergyData = +this.optone.EnergyData.Total_DHW;
        this.RenewEnergyData = +this.optone.EnergyData.Renewables;
        this.equipEnergyData = +this.optone.EnergyData.equip_energy_total;

        this.optionTotal =
          this.HeatingEnergyData +
          this.CoolingEnergyData +
          this.FansEnergyData +
          this.PumpsEnergyData +
          this.HeatRejEnergyData +
          this.LightingEnergyData +
          this.DHWEnergyData +
          this.RenewEnergyData +
          this.equipEnergyData +
    this.HumData;

        //  this.DHW = +this.optone.EnergyData.Total_DHW
        //   this.Solar = +this.optone.EnergyData.Total_Solar
        //  this.Wind = +this.optone.EnergyData.Total_Wind

        if (data) {
          d3.select('#stack_chart').selectAll('svg').remove();
          var margin = { top: 20, right: 160, bottom: 35, left: 30 };

          var width = 500 - margin.left - margin.right,
            height = 400 - margin.top - margin.bottom;

          var svg = d3
            .select('#stack_chart_report')
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr(
              'transform',
              'translate(' + margin.left + ',' + margin.top + ')'
            );

          if (this.newAshNecb == 'noash') {
            var cust = 'Custom';
          }
          if (this.newAshNecb == 'Ashare') {
            var cust = 'ASHRAE';
          }
          if (this.newAshNecb == 'Necb') {
            var cust = 'NECB';
          }

          /* Data in strings like it would be if imported from a csv */

          var datanew = [
            {
              year: this.cellOption,
              Lighting: this.LightingEnergyData,
              Cooling: this.CoolingEnergyData,
              Heating: this.HeatingEnergyData,
              Fans: this.FansEnergyData,
              Pumps: this.PumpsEnergyData,
              Dhw: this.DHWEnergyData,
              HeatRej: this.HeatRejEnergyData,
              Renew: this.RenewEnergyData,
              Equip: this.equipEnergyData,
              Humidification: this.HumData,
            },

            {
              year: cust,
              Lighting: this.Lighting,
              Cooling: this.Cooling,
              Heating: this.Heating,
              Fans: this.Fans,
              Pumps: this.Pumps,
              Dhw: this.DHW,
              HeatRej: this.HeatRej,
              Renew: 0,
              Equip: this.equipBaseline,
      Humidification: this.Hum,
            },
          ];

          var parse = d3.time.format('%Y').parse;

          // Transpose the data into layers
          var dataset = d3.layout.stack()(
            [
              'Heating',
              'Cooling',
              'Fans',
              'Pumps',
              'HeatRej',
      'Humidification',
              'Lighting',
              'Equip',
               'Renew',
              'DHW',
             
            ].map(function (fruit) {
              return datanew.map(function (d) {
                return { x: d.year, y: +d[fruit] };
              });
            })
          );

          dataset.map((val) => val[0].y < 0 && console.log((val[0].y = 0)));
          dataset.map((val) => val[1].y < 0 && console.log((val[1].y = 0)));
          dataset.map((val) => isNaN(val[0].y) && console.log((val[0].y = 0)));
          dataset.map((val) => isNaN(val[1].y) && console.log((val[1].y = 0)));

          dataset.map(
            (val) => isNaN(val[0].y0) && console.log((val[0].y0 = 0))
          );
          dataset.map(
            (val) => isNaN(val[1].y0) && console.log((val[1].y0 = 0))
          );

          // Set x, y and colors
          var x = d3.scale
            .ordinal()
            .domain(
              dataset[0].map(function (d) {
                return d.x;
              })
            )
            .rangeRoundBands([10, width - 10], 0.02);

          var y = d3.scale
            .linear()
            .domain([
              0,
              d3.max(dataset, function (d) {
                return d3.max(d, function (d) {
                  return d.y0 + d.y;
                });
              }),
            ])
            .range([height, 0]);

           var colors = [
            '#C1534E',
            '#4C82BB',
            '#95D23E',
            '#A896DB',
            '#2AD9C5',
            '#bb854c',
            '#000000',
            '#cccccc',
             '#D2691E',
            '#F7CE41',
           
      
          ];

          // Define and draw axes
          var yAxis = d3.svg
            .axis()
            .scale(y)
            .orient('left')
            .ticks(5)
            .tickSize(-width, 0, 0)
            .tickFormat(function (d) {
              return d;
            });

          var xAxis = d3.svg.axis().scale(x).orient('bottom');
          // .tickFormat(d3.time.format("%Y"));

          svg.append('g').attr('class', 'y axis').call(yAxis);

          svg
            .append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

          // Create groups for each series, rects for each segment
          var groups = svg
            .selectAll('g.cost')
            .data(dataset)
            .enter()
            .append('g')
            .attr('class', 'cost')
            .style('fill', function (d, i) {
              return colors[i];
            });

          var rect = groups
            .selectAll('rect')
            .data(function (d) {
              return d;
            })
            .enter()
            .append('rect')
            .attr('x', function (d) {
              return x(d.x);
            })
            .attr('y', function (d) {
              return y(d.y0 + d.y);
            })
            .attr('height', function (d) {
              return y(d.y0) - y(d.y0 + d.y);
            })
            .attr('width', x.rangeBand())
            .on('mouseover', function () {
              tooltip.style('display', null);
            })
            .on('mouseout', function () {
              tooltip.style('display', 'none');
            })
            .on('mousemove', function (d) {
              var xPosition = d3.mouse(this)[0] - 15;
              var yPosition = d3.mouse(this)[1] - 25;
              tooltip.attr(
                'transform',
                'translate(' + xPosition + ',' + yPosition + ')'
              );
              tooltip.select('text').text(d.y);
            });

          // Draw legend
          var legend = svg
            .selectAll('.legend')
            .data(colors)
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', function (d, i) {
              return 'translate(30,' + i * 19 + ')';
            });

          legend
            .append('rect')
            .attr('x', width - 18)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', function (d, i) {
             return [
  '#D2691E', // DHW
  '#F7CE41', // Renewables
  '#cccccc', // Equipment
  '#000000', // Lighting
  '#bb854c', // HeatRej
  '#2AD9C5', // Humidification
  '#A896DB', // Pumps
  '#95D23E', // Fans
  '#4C82BB', // Cooling
  '#C1534E'  // Heating
][i];
            });

          legend
            .append('text')
            .attr('x', width + 5)
            .attr('y', 9)
            .attr('dy', '.35em')
            .style('text-anchor', 'start')
            .text(function (d, i) {
              switch (i) {
                case 0:
                  return 'Renewables';
                case 1:
                  return 'DHW';
                case 2:
                  return 'Equipment';
                case 3:
                  return 'Lighting';
                case 4:
                  return 'HeatRej';
               case 5:
                  return 'Humidification';
                case 6:
                  return 'Pumps';
                case 7:
                  return 'Fans';
                case 8:
                  return 'Cooling';
        case 9:
                  return 'Heating';
              }
            });

          // Prep the tooltip bits, initial display is hidden
          var tooltip = svg
            .append('g')
            .attr('class', 'tooltip')
            .style('display', 'none');

          tooltip
            .append('rect')
            .attr('width', 30)
            .attr('height', 20)
            .attr('fill', 'white')
            .style('opacity', 0.5);

          tooltip
            .append('text')
            .attr('x', 15)
            .attr('dy', '1.2em')
            .style('text-anchor', 'middle')
            .attr('font-size', '12px')
            .attr('font-weight', 'bold');
        }
      });
  }

  // stack chart report end

  private getDynamicGridColumnClass(baseColumnIndex: number): string {
    const hiddenColumnsCount = (this.currentHideArr || []).filter(Boolean).length;
    const adjustedIndex = Math.max(0, baseColumnIndex - hiddenColumnsCount);
    return `.col-${adjustedIndex}`;
  }

  // costsurcharge function start

  costSurcharge() {
    var ashwwrnew = d3
      .selectAll('.mygrid')
      .select('.row')
      .select('.col-7')
      .text();
    var newashw = ashwwrnew.replace('%', '') / 100;

    var baseline = (this.newcustBaseWwr.replace('%', '') / 100).toFixed(3);

    var ht = this.celltenNewmessage;
    this.heatRec = ht.slice(0, -2);

    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: string = '5';
      var userProj: string = this.demo_proj_id;
    } else {
      var userDemo: string = this.condId;
      var userProj: string = this.newProjId;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Ashare') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/costComparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwronerep +
        '&heatRecovery=' +
        this.heattwo +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        this.cellSevenmessage +
        '&hvac=' +
        this.hvacone +
        '&dl=' +
        this.dlone;
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'Necb') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/costComparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwronerep +
        '&heatRecovery=' +
        this.heattwo +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.newwwrVal +
        '&hvac=' +
        this.hvacone +
        '&dl=' +
        this.dlone;
    }

    if (this.newAshNecb == 'Necb' && this.cellmessage !== 'dgt msg') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/costComparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        this.celltenNewmessage.replace(/"/g, '') +
        '&baseline=NECB' +
        '&baselineWwr=' +
        this.newwwrVal +
        '&hvac=' +
        this.cellNinemessage +
        '&dl=' +
        this.cellEightmessage;
    }

    if (this.newAshNecb == 'Ashare' && this.cellmessage !== 'dgt msg') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/costComparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        this.celltenNewmessage.replace(/"/g, '') +
        '&baseline=ASHRAE' +
        '&baselineWwr=' +
        newashw +
        '&hvac=' +
        this.cellNinemessage +
        '&dl=' +
        this.cellEightmessage;
    }
    if (this.authService.custHeat == 'YES') {
      var cuheat = 'Y';
    }
    if (this.authService.custHeat == 'NO') {
      var cuheat = 'N';
    }
    if (this.authService.custDl == 'YES') {
      var custDLnew = 'DLON';
    }
    if (this.authService.custDl == 'NO') {
      var custDLnew = 'DLOFF';
    }

    if (this.cellmessage == 'dgt msg' && this.newAshNecb == 'noash') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/costComparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.wallone +
        '&roof=' +
        this.roofone +
        '&floor=' +
        this.florone +
        '&window=' +
        this.windone +
        '&shading=' +
        this.shadone +
        '&lighting=' +
        this.ligtone +
        '&wwr=' +
        this.wwronerep +
        '&heatRecovery=' +
        this.heattwo +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        baseline +
        '&hvac=' +
        this.hvacone +
        '&dl=' +
        this.dlone +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        cuheat +
        '&customHvac=' +
        '"' +
        this.authService.custHvac +
        '"' +
        '&customDl=' +
        '"' +
        custDLnew +
        '"';
    }
    if (this.cellmessage !== 'dgt msg' && this.newAshNecb == 'noash') {
      var msgurlnwstchart =
        this.rootDomainUrl +
        'adeos/api/costComparison.php?user_id=' +
        userDemo +
        '&proj_id=' +
        userProj +
        '&wall=' +
        this.cellmessage +
        '&roof=' +
        this.cellTwomessage +
        '&floor=' +
        this.cellThreemessage +
        '&window=' +
        this.cellFourmessage +
        '&shading=' +
        this.cellFivemessage +
        '&lighting=' +
        this.cellSixmessage +
        '&wwr=' +
        this.cellSevenmessage +
        '&heatRecovery=' +
        this.celltenNewmessage.replace(/"/g, '') +
        '&baseline=CUSTOM' +
        '&baselineWwr=' +
        baseline +
        '&hvac=' +
        this.hvacone +
        '&dl=' +
        this.cellEightmessage +
        '&customwall=' +
        '"' +
        this.newcustBase +
        '"' +
        '&customroof=' +
        '"' +
        this.newcustBaseRoof +
        '"' +
        '&customfloor=' +
        '"' +
        this.newcustBaseFloor +
        '"' +
        '&customwindow=' +
        '"' +
        this.newcustBaseWindow +
        '"' +
        '&customshading=' +
        '"' +
        this.newcustBaseShading +
        '"' +
        '&customlighting=' +
        '"' +
        this.newcustBaseInf +
        '"' +
        '&customHeatRec=' +
        cuheat +
        '&customHvac=' +
        '"' +
        this.authService.custHvac +
        '"' +
        '&customDl=' +
        '"' +
        custDLnew +
        '"';
    }

    return this.http
      .get(msgurlnwstchart)
      .pipe(map((res) => res))
      .subscribe((data) => {
        this.costSur = data;

        this.wall_cost = +this.costSur.BaselineData.wall_cost;
        this.roof_cost = +this.costSur.BaselineData.roof_cost;
        this.flr_cost = +this.costSur.BaselineData.flr_cost;
        this.win_cost = +this.costSur.BaselineData.win_cost;
        this.shading_cost = +this.costSur.BaselineData.shading_cost;
        this.lpd_cost = +this.costSur.BaselineData.lpd_cost;
        this.daylight_sensor_cost =
          +this.costSur.BaselineData.daylight_sensor_cost;
        this.hvacCost = +this.costSur.BaselineData.hvaccost;
        this.heatRecoveryCost = +this.costSur.BaselineData.heatRecoveryCost;
        this.heatRecoveryCostLum =
          +this.costSur.BaselineData.heat_recovery_cost_lumpsum;

        this.wall_costopt = +this.costSur.OptionCost.wall_cost;
        this.roof_costopt = +this.costSur.OptionCost.roof_cost;
        this.flr_costopt = +this.costSur.OptionCost.flr_cost;
        this.win_costopt = +this.costSur.OptionCost.win_cost;
        this.shading_costopt = +this.costSur.OptionCost.shading_cost;
        this.lpd_costopt = +this.costSur.OptionCost.lpd_cost;
        this.daylight_sensor_costopt =
          +this.costSur.OptionCost.daylight_sensor_cost;
        this.hvacCostopt = +this.costSur.OptionCost.hvaccost;
        this.heatRecoveryCostopt =
          +this.costSur.OptionCost.heat_recovery_cost_lumpsum;
        this.windCostopt = +this.costSur.OptionCost.wind_cost;
        this.solarCostopt = +this.costSur.OptionCost.solar_cost;

        if (this.solarselnew == 'false') {
          this.solarCostopt = 0;
        }
        if (this.windselnew == 'false') {
          this.windCostopt = 0;
        }

        if (data) {
          var margin = { top: 20, right: 160, bottom: 35, left: 30 };

          var width = 600 - margin.left - margin.right,
            height = 400 - margin.top - margin.bottom;

          var svg = d3
            .select('#stack_chart_new_rep')
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr(
              'transform',
              'translate(' + margin.left + ',' + margin.top + ')'
            );

          if (this.newAshNecb == 'noash') {
            var cust = 'Custom';
          }
          if (this.newAshNecb == 'Ashare') {
            var cust = 'ASHRAE';
          }
          if (this.newAshNecb == 'Necb') {
            var cust = 'NECB';
          }

          /* Data in strings like it would be if imported from a csv */

          var datanew = [
            {
              year: this.cellOption,
              WALL: this.wall_costopt,
              ROOF: this.roof_costopt,
              FLOOR: this.flr_costopt,
              WINDOW: this.win_costopt,
              SHADING: this.shading_costopt,
              INFILTRATION: this.lpd_costopt,
              DLSENSORS: this.daylight_sensor_costopt,
              HVAC: this.hvacCostopt,
              HEATREC: this.heatRecoveryCostopt,
            },

            {
              year: cust,
              WALL: this.wall_cost,
              ROOF: this.roof_cost,
              FLOOR: this.flr_cost,
              WINDOW: this.win_cost,
              SHADING: this.shading_cost,
              INFILTRATION: this.lpd_cost,
              DLSENSORS: this.daylight_sensor_cost,
              HVAC: this.hvacCost,
              HEATREC: this.heatRecoveryCost,
            },
          ];

          var parse = d3.time.format('%Y').parse;

          // Transpose the data into layers
          var dataset = d3.layout.stack()(
            [
              'FLOOR',
              'ROOF',
              'WINDOW',
              'SHADING',
              'WALL',
              'INFILTRATION',
              'DLSENSORS',
              'HVAC',
              'HEATREC',
            ].map(function (fruit) {
              return datanew.map(function (d) {
                return { x: d.year, y: +d[fruit] };
              });
            })
          );

          // Set x, y and colors
          var x = d3.scale
            .ordinal()
            .domain(
              dataset[0].map(function (d) {
                return d.x;
              })
            )
            .rangeRoundBands([10, width - 10], 0.02);

          var y = d3.scale
            .linear()
            .domain([
              0,
              d3.max(dataset, function (d) {
                return d3.max(d, function (d) {
                  return d.y0 + d.y;
                });
              }),
            ])
            .range([height, 0]);

          var colors = [
            '#91c3d5',
            '#a99bbd',
            '#b9cd96',
            '#d19392',
            '#db843d',
            '#71588f',
            '#89a54e',
            '#a65246',
            '#4572a7',
          ];

          // Define and draw axes
          var yAxis = d3.svg
            .axis()
            .scale(y)
            .orient('left')
            .ticks(5)
            .tickSize(-width, 0, 0)
            .tickFormat(function (d) {
              return d;
            });

          var xAxis = d3.svg.axis().scale(x).orient('bottom');
          // .tickFormat(d3.time.format("%Y"));

          svg.append('g').attr('class', 'y axis').call(yAxis);

          svg
            .append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

          // Create groups for each series, rects for each segment
          var groups = svg
            .selectAll('g.cost')
            .data(dataset)
            .enter()
            .append('g')
            .attr('class', 'cost')
            .style('fill', function (d, i) {
              return colors[i];
            });

          var rect = groups
            .selectAll('rect')
            .data(function (d) {
              return d;
            })
            .enter()
            .append('rect')
            .attr('x', function (d) {
              return x(d.x);
            })
            .attr('y', function (d) {
              return y(d.y0 + d.y);
            })
            .attr('height', function (d) {
              return y(d.y0) - y(d.y0 + d.y);
            })
            .attr('width', x.rangeBand())
            .on('mouseover', function () {
              tooltip.style('display', null);
            })
            .on('mouseout', function () {
              tooltip.style('display', 'none');
            })
            .on('mousemove', function (d) {
              var xPosition = d3.mouse(this)[0] - 15;
              var yPosition = d3.mouse(this)[1] - 25;
              tooltip.attr(
                'transform',
                'translate(' + xPosition + ',' + yPosition + ')'
              );
              tooltip.select('text').text(d.y);
            });

          // Draw legend
          var legend = svg
            .selectAll('.legend')
            .data(colors)
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', function (d, i) {
              return 'translate(30,' + i * 19 + ')';
            });

          legend
            .append('rect')
            .attr('x', width - 18)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', function (d, i) {
              return [
  '#D2691E', // DHW
  '#F7CE41', // Renewables
  '#cccccc', // Equipment
  '#000000', // Lighting
  '#bb854c', // HeatRej
  '#2AD9C5', // Humidification
  '#A896DB', // Pumps
  '#95D23E', // Fans
  '#4C82BB', // Cooling
  '#C1534E'  // Heating
][i];
            });

          legend
            .append('text')
            .attr('x', width + 5)
            .attr('y', 9)
            .attr('dy', '.35em')
            .style('text-anchor', 'start')
            .text(function (d, i) {
              switch (i) {
                case 0:
                  return 'HEATREC';
                case 1:
                  return 'HVAC';
                case 2:
                  return 'INFILTRATION';
                case 3:
                  return 'WALL';
                case 4:
                  return 'DLSENSORS';
                case 5:
                  return 'SHADING';
                case 6:
                  return 'WINDOW';
                case 7:
                  return 'ROOF';
                case 8:
                  return 'FLOOR';
              }
            });

          // Prep the tooltip bits, initial display is hidden
          var tooltip = svg
            .append('g')
            .attr('class', 'tooltip')
            .style('display', 'none');

          tooltip
            .append('rect')
            .attr('width', 30)
            .attr('height', 20)
            .attr('fill', 'white')
            .style('opacity', 0.5);

          tooltip
            .append('text')
            .attr('x', 15)
            .attr('dy', '1.2em')
            .style('text-anchor', 'middle')
            .attr('font-size', '12px')
            .attr('font-weight', 'bold');
        }
      });
  }

  //costsurcharg function end

  // stacked chart end

  // stacked report chart start

  stackedChartReport() {
    var margin = { top: 20, right: 20, bottom: 30, left: 40 },
      width = 500 - margin.left - margin.right,
      height = 400 - margin.top - margin.bottom;

    var x0 = d3.scale.ordinal().rangeRoundBands([0, width], 0.1);

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear().range([height, 0]);

    var xAxis = d3.svg.axis().scale(x0).tickSize(0).orient('bottom');

    var yAxis = d3.svg.axis().scale(y).orient('left');

    var color = d3.scale
      .ordinal()
      // .range(["#ca0020","#f4a582","#d5d5d5","#92c5de","#0571b0"]);
      .range(['#4c82bb', '#c1534e']);
    var svg = d3
      .select('#stack_chart_dup')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    d3.json('assets/newdata.json', function (error, data) {
      var categoriesNames = data.map(function (d) {
        return d.categorie;
      });
      var rateNames = data[0].values.map(function (d) {
        return d.rate;
      });

      x0.domain(categoriesNames);
      x1.domain(rateNames).rangeRoundBands([0, x0.rangeBand()]);
      y.domain([
        0,
        d3.max(data, function (categorie) {
          return d3.max(categorie.values, function (d) {
            return d.value;
          });
        }),
      ]);

      svg
        .append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + height + ')')
        .call(xAxis);

      svg
        .append('g')
        .attr('class', 'y axis')
        .style('opacity', '0')
        .call(yAxis)
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '.71em')
        .style('text-anchor', 'end')
        .style('font-weight', 'bold')
        .text('Value');

      svg
        .select('.y')
        .transition()
        .duration(500)
        .delay(1300)
        .style('opacity', '1');

      var slice = svg
        .selectAll('.slice')
        .data(data)
        .enter()
        .append('g')
        .attr('class', 'g')
        .attr('transform', function (d) {
          return 'translate(' + x0(d.categorie) + ',0)';
        });

      slice
        .selectAll('rect')
        .data(function (d) {
          return d.values;
        })
        .enter()
        .append('rect')
        .attr('width', x1.rangeBand())
        .attr('x', function (d) {
          return x1(d.rate);
        })
        .style('fill', function (d) {
          return color(d.rate);
        })
        .attr('y', function (d) {
          return y(0);
        })
        .attr('height', function (d) {
          return height - y(0);
        })
        .on('mouseover', function (d) {
          d3.select(this).style('fill', d3.rgb(color(d.rate)).darker(2));
        })
        .on('mouseout', function (d) {
          d3.select(this).style('fill', color(d.rate));
        });

      slice
        .selectAll('rect')
        .transition()
        .delay(function (d) {
          return Math.random() * 1000;
        })
        .duration(1000)
        .attr('y', function (d) {
          return y(d.value);
        })
        .attr('height', function (d) {
          return height - y(d.value);
        });

      //Legend
      var legend = svg
        .selectAll('.legend')
        .data(
          data[0].values
            .map(function (d) {
              return d.rate;
            })
            .reverse()
        )
        .enter()
        .append('g')
        .attr('class', 'legend')
        .attr('transform', function (d, i) {
          return 'translate(0,' + i * 20 + ')';
        })
        .style('opacity', '0');

      legend
        .append('rect')
        .attr('x', width - 18)
        .attr('width', 18)
        .attr('height', 18)
        .style('fill', function (d) {
          return color(d);
        });

      legend
        .append('text')
        .attr('x', width + 1)
        .attr('y', 9)
        .attr('dy', '.35em')
        .style('text-anchor', 'start')
        .style('font-size', '10px')
        .text(function (d) {
          return d;
        });

      legend
        .transition()
        .duration(500)
        .delay(function (d, i) {
          return 1300 + 100 * i;
        })
        .style('opacity', '1');
    });
  }

  // stacked report chart end

  //  barneg start

  barnegChart() {
    // call api for values
    (() => {
      this.msgurlnw =
        this.rootDomainUrl +
        'adeos/api/sum_energy.php?user_id=' +
        this.condId +
        '&proj_id=' +
        this.newProjId +
        '&wall="W1"' +
        '&roof="R2"' +
        '&floor="F1"' +
        '&window="WIN01"' +
        '&shading="YES"' +
        '&lighting="LPD1"' +
        '&wwr="0.1"' +
        '&dl="DLOFF"' +
        '&hvac="VAV with Reheat"' +
        '&heatRecovery="N"';

      return this.http
        .get(this.msgurlnw)
        .pipe(map((res) => res))
        .subscribe((data) => {
          this.gogdat = data;
          this.hteng = this.gogdat.readData.heating_energy_total;
          this.coeng = this.gogdat.readData.cooling_energy_total;
          var hello = +this.gogdat.readData.heating_energy_total;
          var cool = +this.gogdat.readData.cooling_energy_total;
          var ligt = +this.gogdat.readData.lighting_energy_total;
          var eqpt = +this.gogdat.readData.equip_energy_total;
          var dhwt = +this.gogdat.readData.Total_DHW;
          var fan = +this.gogdat.readData.TotalDistrFanEnergy;
          var distPump = +this.gogdat.readData.TotalDistrPumpE;
          var heatPump = +this.gogdat.readData.TotalHeatRejPumpE;
          var wind = +this.gogdat.readData.Total_Wind;
          var solar = +this.gogdat.readData.Total_Solar;

          var object = {
            param1: 0,
            param2: 0,
            function1: 'param1 += 1;',
            function2: 'param2 = new Date().getTime();',
          };

          // code for chart start

         
          if (this.newEmail == 'anuprathi1@gmail.com') {
            this.condId = this.newEventId;
          } else {
            this.condId = this.newUserId;
          }

          if (this.newEmail == 'demo@ecomatrix.io') {
            var userDemo: string = '5';
            var userProj: string = this.demo_proj_id;
          } else {
            var userDemo: string = this.condId;
            var userProj: string = this.newProjId;
          }

          if (
            this.message == 'default message' &&
            this.cellmessage == 'dgt msg'
          ) {
            
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              userDemo +
              '&proj_id=' +
              userProj +
              '&wall=' +
              this.wallone +
              '&roof=' +
              this.roofone +
              '&floor=' +
              this.florone +
              '&window=' +
              this.windone +
              '&shading=' +
              this.shadone +
              '&lighting=' +
              this.ligtone +
              '&wwr=' +
              this.wwrone +
              '&dl=' +
              this.dlone +
              '&heatRecovery=' +
              this.heatone;
          } else if (
            this.cellmessage == 'dgt msg' &&
            this.newAshNecb == 'noash'
          ) {
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              userDemo +
              '&proj_id=' +
              userProj +
              '&wall=' +
              this.wallone +
              '&roof=' +
              this.roofone +
              '&floor=' +
              this.florone +
              '&window=' +
              this.windone +
              '&shading=' +
              this.shadone +
              '&lighting=' +
              this.ligtone +
              '&wwr=' +
              this.wwrone +
              '&dl=' +
              this.dlone +
              '&heatRecovery=' +
              this.heatone;
          } else if (
            this.cellmessage !== 'dgt msg' &&
            this.newAshNecb == 'noash'
          ) {
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              userDemo +
              '&proj_id=' +
              userProj +
              '&wall=' +
              this.cellmessage +
              '&roof=' +
              this.cellTwomessage +
              '&floor=' +
              this.cellThreemessage +
              '&window=' +
              this.cellFourmessage +
              '&shading=' +
              this.cellFivemessage +
              '&lighting=' +
              this.cellSixmessage +
              '&wwr=' +
              '"' +
              this.cellSevenmessage +
              '"' +
              '&dl=' +
              this.cellEightmessage +
              '&heatRecovery=' +
              this.celltenNewmessage;
          }
          else if (
            this.cellmessage == 'dgt msg' &&
            this.message != 'default message'
          ) {
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              userDemo +
              '&proj_id=' +
              userProj +
              '&wall=' +
              this.wallone +
              '&roof=' +
              this.roofone +
              '&floor=' +
              this.florone +
              '&window=' +
              this.windone +
              '&shading=' +
              this.shadone +
              '&lighting=' +
              this.ligtone +
              '&wwr=' +
              this.wwrone +
              '&dl=' +
              this.dlone +
              '&heatRecovery=' +
              this.heatone;
          } else {
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              userDemo +
              '&proj_id=' +
              userProj +
              '&wall=' +
              this.cellmessage +
              '&roof=' +
              this.cellTwomessage +
              '&floor=' +
              this.cellThreemessage +
              '&window=' +
              this.cellFourmessage +
              '&shading=' +
              this.cellFivemessage +
              '&lighting=' +
              this.cellSixmessage +
              '&wwr=' +
              this.cellSevenmessage +
              '&dl=' +
              this.cellEightmessage +
              '&heatRecovery=' +
              this.celltenNewmessage;
          }

          d3.json(this.sumengurl, function (error, data) {
            //this.gdatanew = data;
            var htnw: any = +data.readData.heating_energy_total;
            var cool: any = +data.readData.cooling_energy_total;
            var fan: any = +data.readData.TotalDistrFanEnergy;
            var pump: any = +data.readData.TotalDistrPumpE;
            var heat: any = +data.readData.TotalHeatRejPumpE;
            var light: any = +data.readData.lighting_energy_total;
            var eq: any = +data.readData.equip_energy_total;
            var dhw: any = +data.readData.Total_DHW;
            var slr: any = +data.readData.Total_Solar;
            var wid: any = +data.readData.Total_Wind;
      var hum: any = +data.readData.hum_energy;

            var total: any =
              htnw + cool + fan + pump + heat + light + eq + dhw + slr + wid+hum;

            //this.htnewgl = +data.readData.heating_energy_total;
            // htnw.toFixed(2)
            //document.getElementById('hteng').innerHTML = htnw.toFixed(0);

           /* document.getElementById('cooleng').innerHTML = cool.toFixed(0);

            document.getElementById('faneng').innerHTML = fan.toFixed(0);

            document.getElementById('pumpeng').innerHTML = pump.toFixed(0);

            document.getElementById('heateng').innerHTML = heat.toFixed(0);

            document.getElementById('lighteng').innerHTML = light.toFixed(0);

            document.getElementById('eqeng').innerHTML = eq.toFixed(0);

            document.getElementById('dhweng').innerHTML = dhw.toFixed(0);

            document.getElementById('slreng').innerHTML = slr.toFixed(0);

            document.getElementById('wideng').innerHTML = wid.toFixed(0);

            document.getElementById('totalVal').innerHTML = total.toFixed(0);
      
      document.getElementById('humE').innerHTML = hum.toFixed(0);*/

            data = [
              {
                Year: 'Heating',
                Celsius: +data.readData.heating_energy_total,
              },
              {
                Year: 'Cooling',
                Celsius: +data.readData.cooling_energy_total,
              },
              {
                Year: 'Fans',
                Celsius: +data.readData.TotalDistrFanEnergy,
              },
              {
                Year: 'Pumps',
                Celsius: +data.readData.TotalDistrPumpE,
              },
              {
                Year: 'Heat Rej',
                Celsius: +data.readData.TotalHeatRejPumpE,
              },
      {
                Year: 'Hum',
                Celsius: +data.readData.hum_energy,
              },
              {
                Year: 'Lighting',
                Celsius: +data.readData.lighting_energy_total,
              },
              {
                Year: 'Equipment',
                Celsius: +data.readData.equip_energy_total,
              },
              {
                Year: 'DHW',
                Celsius: +data.readData.Total_DHW,
              },
              {
                Year: 'Solar',
                Celsius: +data.readData.Total_Solar,
              },
              {
                Year: 'Wind',
                Celsius: +data.readData.Total_Wind,
              },
            ];

            var margin = {
                top: 10,
                right: 25,
                bottom: 20,
                left: 68,
              },
              width = parseInt(((window.innerWidth/2) - margin.left - margin.right).toFixed()),
              height = 280 - margin.top - margin.bottom;

          
            var y = d3.scale.linear().range([height, 0]);

            var x = d3.scale.ordinal().rangeRoundBands([0, width], 0.2);

            var xAxisScale = d3.scale
              .linear()
              // .domain([1880, 2015])
              .range([0, width]);

            var xAxis = d3.svg
              .axis()
              .scale(xAxisScale)
              .orient('bottom')
              .tickFormat(d3.format('d'));

            var yAxis = d3.svg.axis().scale(y).orient('left');

          /*  var svg = d3
              .select('#chartneg')
              .append('svg')
              .attr('width', width)
              .attr('height', height + margin.top + margin.bottom)
              .append('g')
              .attr(
                'transform',
                'translate(' + margin.left + ',' + margin.top + ')'
              );
            x.domain(
              data.map(function (d) {
                return d.Year;
              })
            );
            y.domain(
              d3.extent(data, function (d) {
                return d.Celsius;
              })
            ).nice();

            svg
              .selectAll('.bar')
              .data(data)
              .enter()
              .append('rect')
              .attr('class', function (d) {
                if (d.Celsius < 0) {
                  return 'bar negative';
                } else {
                  return 'bar positive';
                }
              })
              .attr('data-yr', function (d) {
                return d.Year;
              })
              .attr('data-c', function (d) {
                return d.Celsius;
              })
              .attr('title', function (d) {
                return d.Year + ': ' + d.Celsius + 'MWh';
              })
              .attr('y', function (d) {
                if (d.Celsius > 0) {
                  return y(d.Celsius);
                } else {
                  return y(0);
                }
              })
              .attr('x', function (d) {
                return x(d.Year);
              })
              .attr('width', x.rangeBand())
              .attr('height', function (d) {
                return Math.abs(y(d.Celsius) - y(0));
              })
              .on('mouseover', function (d) {
                // alert("Year: " + d.Year + ": " + d.Celsius + " Celsius");
                d3.select('#_yr').text(d.Year + ':');
                d3.select('#degrree').text(d.Celsius + ' ' + '(MWh)');
              });

            svg.append('g').attr('class', 'y axis').call(yAxis);

            

            svg
              .append('g')
              .attr('class', 'x axis')
              .append('line')
              .style('colors', '#ccc')
              .attr('y1', y(0))
              .attr('y2', y(0))
              .attr('x2', width);

            svg
              .append('g')
              .attr('class', 'infowin')
              .attr('transform', 'translate(50, 5)')
              .append('text')
              .attr('id', '_yr');

            svg
              .append('g')
              .attr('class', 'infowin')
              .attr('transform', 'translate(110, 5)')
              .append('text')
              .attr('id', 'degrree');*/
          });

          function type(d) {
            d.Celsius = +d.Celsius;
            return d;
          }

          // code for chart end
        });
    })();

    // end api call

    
  } // function end

  // marneg end

  // sankey chart start

  activateCost() {
    this.authService.newchartBeCost('No');
    this.authService.changeisKpi(true);
    this.authService.changeKpiList([])
    this.router.navigate(["cost"])
    /*const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '750px',
      //	height: '500px',
      data: { isCost: true },
    });*/
  }


  firstColVal() {

    var table = document.querySelectorAll('#grid .row');
    for (var i = 0; i < table.length; i++) {
      var firstColv = table[i].querySelector('.col-1'); //first column

      var secondColv = table[i].querySelector('.col-2'); //second column

      var thirdColv = table[i].querySelector('.col-3'); //second column

      var fourthColv = table[i].querySelector('.col-4'); //second column

      var fiveColv = table[i].querySelector('.col-5'); //second column

      var sixColv = table[i].querySelector('.col-6'); //second column
    }
    this.firstCol = '"' + firstColv.innerHTML + '"';
    this.secondCol = '"' + secondColv.innerHTML + '"';
    this.thirdCol = '"' + thirdColv.innerHTML + '"';
    this.fourcol = '"' + fourthColv.innerHTML + '"';
    this.fivecol = '"' + fiveColv.innerHTML + '"';
    this.sixcol = '"' + sixColv.innerHTML + '"';

    this.cellone = this.firstCol;
    this.celltwo = this.secondCol;
    this.cellthree = this.thirdCol;
    this.cellfour = this.fourcol;
    this.cellfive = this.fivecol;
    this.cellsix = this.sixcol;

    this.authService.cellOneMessage(this.cellone);
    this.authService.cellTwoMessage(this.celltwo);
    this.authService.cellThreeMessage(this.cellthree);
    this.authService.cellFourMessage(this.cellfour);
    this.authService.cellFiveMessage(this.cellfive);
    this.authService.cellSixMessage(this.cellsix);

  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  downloadPdf() {
    if (screen.width == 1366) {
      document.getElementById('pdfdoc').style.display = 'block';

      document.getElementById('dwdpdf').style.display = 'none';

      document.getElementById('actcost').style.display = 'none';

      document.getElementById('hidetwo').style.display = 'block';

      document.getElementById('backwiz').style.display = 'none';

      document.getElementById('gridOuter').style.marginTop = '100px';


      var data = document.getElementById('expm');

      } else {
      var modal = document.getElementById('myModaldeleteNew');

      var btn = document.getElementById('canclprojNew');

      var dlt = document.getElementById('dwdproj');
      modal.style.display = 'block';
      btn.onclick = function () {
        modal.style.display = 'none';
      };

      dlt.onclick = () => {
        document.getElementById('pdfdoc').style.display = 'block';

        document.getElementById('dwdpdf').style.display = 'none';

        document.getElementById('actcost').style.display = 'none';

        document.getElementById('hidetwo').style.display = 'block';

        document.getElementById('backwiz').style.display = 'none';

        document.getElementById('gridOuter').style.marginTop = '100px';

        var data = document.getElementById('expm');

        
        modal.style.display = 'none';
      };

      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = 'none';
        }
      };

    }
  } // download report end

  ngOnInit() {
    this.screenwidth = screen.width;
    this.screenheight = screen.height;

    this.authService.renewablesData().subscribe((data) => {
      this.windCost = data;
      if (this.windCost.success == '1') {
        this.solarselnew = this.windCost.solarPV[0].isSelected;

        if (this.windCost.solarPV[0].isSelected == 'true') {
          this.solarselnew = 'true';
        }
        if (this.windCost.solarPV[0].isSelected == 'false') {
          this.solarselnew = 'false';
        }

        if (this.windCost.windPower[0].isSelected == 'false') {
          //  this.solarCostoptNew = 0;
          this.windselnew = 'false';
        }

        if (this.windCost.windPower[0].isSelected == 'true') {
          //  this.solarCostoptNew = 0;
          this.windselnew = 'true';
        }
      }
    });

    
    document.getElementById('brushdiv').style.display = 'none';
    this.rootDomainUrl = this.authService.rootDomainUrl;


    this.authService.currentToggleStatus.subscribe(
      (toggleStatusNew) => (this.toggleStatusNew = toggleStatusNew)
    );

    this.authService.currentAshNecb.subscribe(
      (newAshNecb) => (this.newAshNecb = newAshNecb)
    );

    this.authService.currentToggleEditable.subscribe(
      (newToggleEditable) => (this.newToggleEditable = newToggleEditable)
    );

    this.authService.currentcustBaseDaylight.subscribe(
      (newcustDaylight) => (this.newcustDaylight = newcustDaylight)
    );

    this.authService.currentcustBaseWwr.subscribe(
      (newcustBaseWwr) => (this.newcustBaseWwr = newcustBaseWwr)
    );

    this.authService.currentcustBaseLighting.subscribe(
      (newcustBaseLighting) => (this.newcustBaseLighting = newcustBaseLighting)
    );

    this.authService.currentcustBaseInf.subscribe(
      (newcustBaseInf) => (this.newcustBaseInf = newcustBaseInf)
    );

    this.authService.currentcustBaseShading.subscribe(
      (newcustBaseShading) => (this.newcustBaseShading = newcustBaseShading)
    );

    this.authService.currentcustBaseWindow.subscribe(
      (newcustBaseWindow) => (this.newcustBaseWindow = newcustBaseWindow)
    );

    this.authService.currentcustBaseFloor.subscribe(
      (newcustBaseFloor) => (this.newcustBaseFloor = newcustBaseFloor)
    );

    this.authService.currentcustBase.subscribe(
      (newcustBase) => (this.newcustBase = newcustBase)
    );

    this.authService.currentcustBaseRoof.subscribe(
      (newcustBaseRoof) => (this.newcustBaseRoof = newcustBaseRoof)
    );

    this.authService.currentcustBaseHvac.subscribe(
      (newcustBaseHvac) => (this.newcustBaseHvac = newcustBaseHvac)
    );
    this.authService.currentcustBaseHtRec.subscribe(
      (newcustHtRec) => (this.newcustHtRec = newcustHtRec)
    );

    this.authService.currentClientEmail.subscribe(
      (newEmail) => (this.newEmail = newEmail)
    );

    this.authService.currentOptionMsg.subscribe(
      (newOptionMsg) => (this.newOptionMsg = newOptionMsg)
    );

    this.authService.currentwwrVal.subscribe(
      (newwwrVal) => (this.newwwrVal = newwwrVal)
    );

    this.authService.currentkpiFactors.subscribe(
      (currentkpiFactors) => (this.currentkpiFactors = currentkpiFactors)
    );

   this.authService.currenthideAxisArr.subscribe(
  (currentHideArr) => {
    this.currentHideArr = currentHideArr;

    // ✅ Step 1: update visible columns
    this.updateVisibleColumns();


  }
);

    this.authService.currentActualName.subscribe(
      (actualName: any) => (this.actualName = actualName)
    );
    this.authService.currentCustName.subscribe(
      (custName: any) => (this.custName = custName)
    );

    if (this.newOptionMsg == 'CUSTOM') {
      this.frrep = 'Custom';

    }
    if (this.newOptionMsg == 'ASHRAE') {
      this.frrep = 'ASHRAE 62.1';

    }
    if (this.newOptionMsg == 'NECB') {
      this.frrep = 'NBC2010';

    }

    if (this.newEmail == 'demo@ecomatrix.io') {
      this.authService.addtoKpiList('eui');
 this.authService.addtoKpiList('cp');

 this.authService.addtoKpiList('ghg');
 this.authService.addtoKpiList('op');
  this.authService.addtoKpiList('pp');

    this.currentkpiFactors = this.currentkpiFactors.filter(x => x !== 'tedi');
    this.authService.addtoHideArr('SHADING');

     this.authService.addtoHideArr('DL');
      
      this.authService.baselineDefnData().subscribe((data) => { 
        this.baselineDefn = data.projLists;
        
        this.ashraeEnabled = this.baselineDefn[1].ashrae;
        this.necbEnabled = this.baselineDefn[1].necb;
        this.cbEnabled = this.baselineDefn[1].cb;
        if(this.ashraeEnabled == "Y") {
          this.newAshNecb = "Ashare";
        } else if(this.necbEnabled == "Y") {
          this.newAshNecb = "Necb";
        } else {
          this.newAshNecb = "noash";
        }
      })

       this.authService.categoryCustomizationData().subscribe((data) => {
      this.catCustData = data;
      if (this.catCustData.projLists) {
        this.actualName = this.catCustData.projLists[0].actual_name;
        this.custName = this.catCustData.projLists[0].customized_name;
        if(this.custName.length > 0)
        console.log(this.actualName);
        console.log(this.custName);
        this.authService.changeActualName(this.actualName);
		    this.authService.changeCustName(this.custName);
      }
    });
    

    }


    if (this.newEmail == 'demo@ecomatrix.io') {
      const bodynew = new HttpParams()
        .set('user_id', this.demo_user_id)
        .set('proj_id', this.demo_proj_id)
        .set('lighting', 'LPD1,LPD2,LPD3,LPD4')
        .set('daylight_sensor', 'YES,NO');

      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/upload_lighting_temp.php',
          bodynew
        )
        .subscribe((data) => {});
    }

    if (this.newAshNecb == 'Ashare') {
      this.newAshNecbNew = 'ASHRAE';
    }
    if (this.newAshNecb == 'Necb') {
      this.newAshNecbNew = 'NECB';
    }
    if (this.newAshNecb == 'noash') {
      this.newAshNecbNew = 'noash';
    }
    if (this.newcustHtRec == 'YES') {
      this.newcustHtRec = 'Y';
    }
    if (this.newcustHtRec == 'NO') {
      this.newcustHtRec = 'N';
    }

    //DL

    if (this.newcustDaylight == 'YES') {
      this.newcustDaylight = 'DLON';
    }

    if (this.newcustDaylight == 'NO') {
      this.newcustDaylight = 'DLOFF';
    }


    if (this.newAshNecb == 'Ashare' || this.newAshNecb == 'Necb') {
      this.newToggleEditable = 'false';
    }
    if (this.newToggleEditable == 'true') {
      this.newAshNecb = 'noash';
    }

    this.authService.modelValues().subscribe((data) => {
      this.modval = data;

      this.modvalNew = data;

      if (this.modvalNew.usrLists.length > 0) {
        this.city = this.modvalNew.usrLists[0].city;

        this.country = this.modvalNew.usrLists[0].country;

        this.buildproj = this.modvalNew.usrLists[0].build_project;

        this.inflt = this.modvalNew.usrLists[0].infiltration;

        this.occup = this.modvalNew.usrLists[0].occupancy;
      }
    });

    this.authService.buildingEnvData().subscribe((data) => {
      this.buildEnv = data;

      this.necbwwr = this.buildEnv.projLists[16]?.necb.WWR1;

     
    });

    this.authService.lightingData().subscribe((data) => {
      this.lightData = data;
    });
    this.authService.infiltrationData().subscribe((data) => {
      this.infData = data;
    });
    this.authService.freshAirData().subscribe((data) => {
      this.freshAir = data;
      //  this.custv = data.freshAir.custom;

      if (this.freshAir.success != '3') {
        this.heatEffect = this.freshAir.freshAir[0].heating_eff;
        this.coolEffect = this.freshAir.freshAir[0].cooling_eff;
        this.ashraeval = this.freshAir.freshAir[0].ashrae;
      }
      if (this.newOptionMsg == 'ASHRAE') {
        this.frrepval = this.freshAir.freshAir[0].ashrae;
      }
      if (this.newOptionMsg == 'NECB') {
        this.frrepval = this.freshAir.freshAir[0].necb;
      }
      if (this.newOptionMsg == 'CUSTOM') {
        this.frrepval = this.freshAir.freshAir[0].custom;
      }

    });

    this.authService.freshAirList().subscribe((data) => {
      this.frAirrep = data;

      this.baselincool = this.frAirrep.baselineData.baselineCool;
      this.baselinheat = this.frAirrep.baselineData.baselineHeat;

      this.optcool = this.frAirrep.readData[2].cool;
      this.optheat = this.frAirrep.readData[2].heat;

      if (data) {
        if (this.newcustHtRec == 'N') {
          this.custheat = '0';
          this.custcool = '0';
        }
        if (this.newcustHtRec == 'Y') {
          this.custheat = this.optheat;
          this.custcool = this.optcool;
        }
      }
    });

    this.authService.hvacData().subscribe((data) => {
      //data[1].projlists.slice(0, 4)

      this.hvData = data;
    });

    this.crtDate = Date.now();
    document.getElementById('pdfdoc').style.display = 'none';

    //document.getElementById('snkreport').style.display="none";

    document.getElementById('hidebefor').style.display = 'none';

    document.getElementById('hidetwo').style.display = 'none';

    document.getElementById('gridOuter').style.display = 'none';

    document.getElementById('dwdpdf').style.display = 'none';

    document.getElementById('actcost').style.display = 'none';

    document.getElementById('backwiz').style.display = 'none';

    // document.getElementById('loader').style.display="block";
    this.authService.currentMesgcellOneMsg.subscribe(
      (cellmessage) => (this.cellmessage = cellmessage)
    );
    this.authService.currentCombIdSel.subscribe(
      (combId) => (this.combIdSelected = combId)
    );
    this.authService.currentMesgcellTwoMsg.subscribe(
      (cellTwomessage) => (this.cellTwomessage = cellTwomessage)
    );
    this.authService.currentMesgcellThreeMsg.subscribe(
      (cellThreemessage) => (this.cellThreemessage = cellThreemessage)
    );
    this.authService.currentMesgcellFourMsg.subscribe(
      (cellFourmessage) => (this.cellFourmessage = cellFourmessage)
    );
    this.authService.currentMesgcellFiveMsg.subscribe(
      (cellFivemessage) => (this.cellFivemessage = cellFivemessage)
    );
    this.authService.currentMesgcellSixMsg.subscribe(
      (cellSixmessage) => (this.cellSixmessage = cellSixmessage)
    );
    this.authService.currentMesgcellTenMsg.subscribe(
      (celltenmessage) => (this.celltenmessage = celltenmessage)
    );
    this.authService.currentMesgcellTenNewMsg.subscribe(
      (celltenNewmessage) => (this.celltenNewmessage = celltenNewmessage)
    );
    this.authService.currentMessage.subscribe(
      (message) => (this.message = message)
    );

    this.authService.currentMesgcellSevenMsg.subscribe(
      (cellSevenmessage) => (this.cellSevenmessage = cellSevenmessage)
    );

    this.authService.currentMesgcellEightMsg.subscribe(
      (cellEightmessage) => (this.cellEightmessage = cellEightmessage)
    );

    this.authService.currentMesgcellNineMsg.subscribe(
      (cellNinemessage) => (this.cellNinemessage = cellNinemessage)
    );

    this.authService.currentMesgcellOPtionMsg.subscribe(
      (cellOption) => (this.cellOption = cellOption)
    );


    this.authService.currenchartBeCost.subscribe(
      (newChartMsg) => (this.newChartMsg = newChartMsg)
    );
    this.authService.currentUserId.subscribe(
      (newUserId) => (this.newUserId = newUserId)
    );
    this.authService.currenteventId.subscribe(
      (newEventId) => (this.newEventId = newEventId)
    );
    this.authService.currentprojId.subscribe(
      (newProjId) => (this.newProjId = newProjId)
    );

    if (this.newChartMsg == 'Yes') {
      document.getElementById('savingscost').style.display = 'none';
    } else {
      document.getElementById('savingscost').style.display = 'block';
    }

    

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.selectionUserId = this.newEventId;
    } else {
      this.selectionUserId = this.newUserId;
    }

      this.authService.baselineDefnData().subscribe((data) => { 
  this.baselineDefn = data.projLists;
  
  this.ashrae = this.baselineDefn[0].ashrae;
  this.necb = this.baselineDefn[0].necb;
  this.cb = this.baselineDefn[0].cb;


  
 })

    if (this.newEmail == 'demo@ecomatrix.io') {
      
 this.authService.newchartBeCost('No');
      this.msgurl =
        this.rootDomainUrl +
        'adeos/api/for_dashboard_chart_search.php?user_id=' +
        this.demo_user_id +
        '&proj_id=' +
        this.demo_proj_id +
        '&newchart=' +
        false +
        '&hideArr=' +
        '' +
        '&baseline=NECB' +
  
        '&wall="R17","R18.5","R21.5","R26.4"' +
        '&roof="R35","R45","R50"' +
        '&floor="CurtainWalls-USI-1.6","CurtainWalls-USI-1.2"' +
        '&window="USI-1.9,g-0.25"|"USI-1.9,g-0.2"|"USI-1.25,g-0.25"|"USI-1.25,g-0.2"|"USI-1.09,g-0.25"|"USI-1.09,g-0.2"' +
        '&inf="0.44-l/s/m2(fac)","0.25-l/s/m2(fac)","0.1-l/s/m2(fac)"' +
        '&shading="NO","YES"' +
        '&wwr="0.433","0.301","0.151"' +
        '&dl="DLON","DLOFF"' +
        '&hvac="Op0 - Standalone w/o HR chiller","Op1 - Standalone with HR Chiller","Op2 - Central HSC Plant with HR Chiller","Op3 - Central HSC Plant with HP Chiller","Op4 - 6 pipe heat pump"'
       +
        '&heatRecovery="S:0.83 L:0.7"';
        
    } else if (this.newChartMsg == 'Yes') {
      if (this.newEmail == 'anuprathi1@gmail.com') {
        this.condId = this.newEventId;
      } else {
        this.condId = this.newUserId;
      }
      this.msgurl =
        this.rootDomainUrl +
        'adeos/api/for_dashboard_chart_search.php?user_id=' +
        this.condId +
        '&proj_id=' +
        this.newProjId +
        '&newchart=' +
        true +
        '&baseline=' +
        this.newAshNecbNew +
        '&' +
        this.message + 
        '&hideArr="' +
        encodeURIComponent(this.currentHideArr.toString())+'"';
      
    } else if (this.newChartMsg == 'No') {
      if (this.newEmail == 'anuprathi1@gmail.com') {
        this.condId = this.newEventId;
      } else {
        this.condId = this.newUserId;
      }
      this.msgurl =
        this.rootDomainUrl +
        'adeos/api/for_dashboard_chart_search.php?user_id=' +
        this.condId +
        '&proj_id=' +
        this.newProjId +
        '&newchart=' +
        false +
        '&baseline=' +
        this.newAshNecbNew +
        '&' +
        this.message +
        '&hideArr=' +
        encodeURIComponent(this.currentHideArr.toString());
    }

    var green_to_blue = d3.scale
      .linear()
      .domain([9, 50])
      .range(['#7AC143', '#00B0DD'])
      .interpolate(d3.interpolateLab);

    var color = function (d) {
      return green_to_blue(d['Length of Day (hours)']);
    };

    // load json file and create the chart

    d3.json(this.msgurl, (data) => {
       this.glbd = data.projLists;
      // custom baseline formula start

      if (this.newToggleEditable == 'true') {
        (() => {
          if (this.newEmail == 'anuprathi1@gmail.com') {
            this.condId = this.newEventId;
          } else {
            this.condId = this.newUserId;
          }
          var wwr = this.newcustBaseWwr;
          if (wwr.indexOf('%') > 0) {
            wwr = (wwr.replace('%', '') / 100).toFixed(3);
            
            this.custwwr = wwr;
          }
          this.msgurl1 =
            this.rootDomainUrl +
            'adeos/api/getCustomBaselineValues.php?user_id=' +
            this.condId +
            '&proj_id=' +
            this.newProjId +
            '&wall=' +
            this.newcustBase +
            '&roof=' +
            this.newcustBaseRoof +
            '&floor=' +
            this.newcustBaseFloor +
            '&window=' +
            this.newcustBaseWindow +
            '&shading=' +
            this.newcustBaseShading +
            '&infiltration=' +
            this.newcustBaseInf +
            '&wwr=' +
            wwr +
            '&dl=' +
            this.newcustDaylight +
            '&hvac=' +
            encodeURIComponent(this.newcustBaseHvac.toString()) +
            '&heatRec=' +
            this.newcustHtRec;

          this.http
            .get(this.msgurl1)
            .pipe(map((res) => res))
            .subscribe((data1) => {
              var eui = data1;
              this.customeui = eui;

              this.newcustumeui = this.customeui.eui;
              this.costpremium = this.customeui.costpremium;

              for (var i = 0; i < this.glbd.length; i++) {
                var lineCharts = d3.selectAll('.mygrid').selectAll('.row');

                var euiO = this.glbd[i]['EUI'];
                var s =
                  Math.floor((1 - euiO / this.newcustumeui) * 100 * 100) / 100;

                var costO = this.glbd[i]['COSTPREMIUM'];

                var c = Math.floor((costO - this.costpremium) * 100) / 100;

                var chart = d3.select(lineCharts[0][i + 1]);
              }
            });
        })();
      }


      var onesc = this.glbd.slice(0, 6);

      this.wallone = '"' + onesc[0].WALL + '"';
      this.roofone = '"' + onesc[0].ROOF + '"';
      this.florone = '"' + onesc[0].FLOOR + '"';
      this.windone = '"' + onesc[0].WINDOW + '"';
      this.shadone = '"' + onesc[0].SHADING + '"';
      this.shadonerep = onesc[0].SHADING;
      this.ligtone = '"' + onesc[0].INFILTRATION + '"';
      this.wwrone = '"' + onesc[0].WWR + '"';
      this.wwronerep = onesc[0].WWR;
      this.dlone = '"' + onesc[0].DL + '"';
      this.hvacone = '"' + onesc[0].HVAC + '"';
      this.hvaconerep = onesc[0].HVAC;
      this.heatone = '"' + onesc[0].HEAT + '"';
      this.heattwo = onesc[0].HEAT;
      this.savingone = onesc[0].SAVINGS;
      this.cprep = onesc[0].COSTPREMIUM;
      this.euirep = onesc[0].EUI;
      this.combIdSelected = onesc[0].COMBID;
      this.hvacIdSel = onesc[0].hvacID;

      this.savingsrep = onesc[0].SAVINGS;

      this.euirepnew = onesc[0].EUI;
      this.costNew = onesc[0].COSTPREMIUM;

      this.cellfive = onesc[0].SHADING;
      this.cellnineNew = onesc[0].HVAC;

      this.walloneCost = onesc[0].WALL;

      var wnew = +onesc[0].WWR;
      var wadd = wnew * 100;
      this.wwronerepNew = wadd + '%';

      if (onesc[0].HEAT == 'Y') {
        this.heatonenew = 'Yes';
      }
      if (onesc[0].HEAT == 'N') {
        this.heatonenew = 'No';
      }

     
      for (var i = 0; i < this.hvData.projLists.length; i++) {
        if (this.hvData.projLists[i].HVAC_system == onesc[0].HVAC) {
          this.boilercop = this.hvData.projLists[i].boilerCOP;
          this.chillercop = this.hvData.projLists[i].chillerCOP;
        }
        if (this.newAshNecb == 'noash') {
          if (this.hvData.projLists[i].HVAC_system == this.newcustBaseHvac) {
            this.boilercopan = this.hvData.projLists[i].boilerCOP;
            this.chillercopan = this.hvData.projLists[i].chillerCOP;

            this.boilercopanCust = this.hvData.projLists[i].boilerCOP;
            this.chillercopanCust = this.hvData.projLists[i].chillerCOP;
          }
        }
        if (this.newAshNecb !== 'noash') {
          if (this.hvData.projLists[i].HVAC_system == this.hva) {
            this.boilercopan = this.hvData.projLists[i].boilerCOP;
            this.chillercopan = this.hvData.projLists[i].chillerCOP;
          }
        }
      }

      //}

      for (var i = 0; i < this.buildEnv.projLists.length; i++) {
        if (this.buildEnv.projLists[i].wall == onesc[0].WALL) {
          this.walluval = this.buildEnv.projLists[i].wall_u_value;
          this.wallip = this.buildEnv.projLists[i].wall_r_value_ip;
        }
        if (this.newAshNecb == 'noash') {
          if (this.newcustBase == this.buildEnv.projLists[i].wall) {
            this.wallan = this.buildEnv.projLists[i].wall_u_value;
          }
        }
        if (this.newAshNecb !== 'noash') {
          if (this.wal == this.buildEnv.projLists[i].wall) {
            this.wallan = this.buildEnv.projLists[i].wall_u_value;
            this.walashnec = this.buildEnv.projLists[i].wall_r_value_ip;
          }
        }

        if (this.buildEnv.projLists[i].roof == onesc[0].ROOF) {
          this.roofuval = this.buildEnv.projLists[i].roof_u_value_si;
          this.roofip = this.buildEnv.projLists[i].roof_r_value_ip;
        }
        if (this.newAshNecb == 'noash') {
          if (this.newcustBaseRoof == this.buildEnv.projLists[i].roof) {
            this.roofan = this.buildEnv.projLists[i].roof_u_value_si;
          }
        }
        if (this.newAshNecb !== 'noash') {
          if (this.rvi == this.buildEnv.projLists[i].roof) {
            this.roofan = this.buildEnv.projLists[i].roof_u_value_si;
            this.roofrvi = this.buildEnv.projLists[i].roof_r_value_ip;
          }
        }

        if (this.buildEnv.projLists[i].floor == onesc[0].FLOOR) {
          this.flooruval = this.buildEnv.projLists[i].flr_u_value_si;
          this.floorip = this.buildEnv.projLists[i].floor_r_value_ip;
        }
        if (this.newAshNecb == 'noash') {
          if (this.newcustBaseFloor == this.buildEnv.projLists[i].floor) {
            this.flooran = this.buildEnv.projLists[i].flr_u_value_si;
          }
        }
        if (this.newAshNecb !== 'noash') {
          if (this.fvi == this.buildEnv.projLists[i].floor) {
            this.flooran = this.buildEnv.projLists[i].flr_u_value_si;
            this.flooranfvi = this.buildEnv.projLists[i].floor_r_value_ip;
          }
        }

        if (this.buildEnv.projLists[i].windows == onesc[0].WINDOW) {
          this.winuval = this.buildEnv.projLists[i].win_u_value_si;
          this.winip = this.buildEnv.projLists[i].win_r_value_ip;
          this.winshgc = this.buildEnv.projLists[i].win_shgc;
        }
        if (this.newAshNecb == 'noash') {
          if (this.newcustBaseWindow == this.buildEnv.projLists[i].windows) {
            this.winan = this.buildEnv.projLists[i].win_u_value_si;
            this.winanshgc = this.buildEnv.projLists[i].win_shgc;
            this.winipCust = this.buildEnv.projLists[i].win_r_value_ip;
            this.winshgc = this.buildEnv.projLists[i].win_shgc;
          }
        }
        if (this.newAshNecb !== 'noash') {
          if (this.wvi == this.buildEnv.projLists[i].windows) {
            this.winan = this.buildEnv.projLists[i].win_u_value_si;
            this.winanshgc = this.buildEnv.projLists[i].win_shgc;
            this.winipBase = this.buildEnv.projLists[i].win_r_value_ip;
          }
        }
      }
      for (var i = 0; i < this.infData.projLists.length; i++) {
        if (this.infData.projLists[i].inf == onesc[0].INFILTRATION) {
          this.lpduval = this.infData.projLists[i].infiltration_val;
        }
        if (this.newAshNecb == 'noash') {
          if (this.infData.projLists[i].inf == this.newcustBaseInf) {
            this.lpduvalCost = this.infData.projLists[i].infiltration_val;
          }
        }
        if (this.newAshNecb !== 'noash') {
          if (this.infData.projLists[i].inf == this.lit) {
            this.litNew = this.infData.projLists[i].infiltration_val;
          }
        }
      }
      for (var i = 0; i < this.lightData.projLists.length; i++) {
        if (this.lightData.projLists[i].lpd == onesc[0].LIGHTING) {
          this.lpduval = this.lightData.projLists[i].lpd_val;

        }

        if (this.newAshNecb == 'noash') {
          if (this.lightData.projLists[i].lpd == this.newcustBaseLighting) {
            this.lpduvalCost = this.lightData.projLists[i].lpd_val;
          }
        }
        if (this.newAshNecb !== 'noash') {
          if (this.infData.projLists[i].inf == this.lit) {
            this.litNew = this.infData.projLists[i].inf;
          }
        }

        if (this.lightData.projLists[i].daylight_sensor == onesc[0].DL) {
          if (onesc[0].DL == 'DLON') {
            this.DLnew = 'YES';
          } else if (onesc[0].DL == 'DLOFF') {
            this.DLnew = 'NO';
          }
        }
      }

     

      for (var i = 0; i < data.projLists.length; i++) {
        //data.projLists[i].WWR=data.projLists[i].WWR*100+"%"

        data.projLists[i].WWR = (data.projLists[i].WWR * 100).toFixed(1) + '%';
        this.hvacID = data.projLists[0].hvacID.slice(0, 1);
      }

      var parcoords = d3.parcoords()('#example').color(color).alpha(0.4);

        // update data table on brush event
        parcoords.on('brushend', (d) => {
          document.getElementById('upval').style.display = 'block';
          (<HTMLInputElement>document.getElementById('dwdpdf')).disabled = true;
  
          var wall = [];
          var roof = [];
          var floor = [];
          var window = [];
          var shading = [];
          var lighting = [];
          var wwr = [];
          var dl = [];
          var hvac = [];
          var heat = [];
  
          var dn = d.map((val) => '"' + val.WALL + '"');
          var dnStr = Array.from(new Set(dn)).toString();
          wall.push(dnStr);
  
          var dnRoof = d.map((val) => '"' + val.ROOF + '"');
          var dnRoofStr = Array.from(new Set(dnRoof)).toString();
          roof.push(dnRoofStr);
          
          var dnFloor = '';
          if(this.custName.length > 0) {
            dnFloor = d.map((val) => '"' + val[this.custName] + '"');
          } else {
            dnFloor = d.map((val) => '"' + val.FLOOR + '"');
          }
          var dnFloorStr = Array.from(new Set(dnFloor)).toString();
          floor.push(dnFloorStr);
  
          var dnWin = d.map((val) => '"' + val.WINDOW + '"');
          //Phase 2.3
          var dnWinStr = Array.from(new Set(dnWin)).join("|");
          //var dnWinStr = Array.from(new Set(dnWin)).toString();
          window.push(dnWinStr);
  
          var dnSha = d.map((val) => '"' + val.SHADING + '"');
          var dnShaStr = Array.from(new Set(dnSha)).toString();
          shading.push(dnShaStr);
  
          var dnLigh = d.map((val) => '"' + val.INFILTRATION + '"');
          var dnLighStr = Array.from(new Set(dnLigh)).toString();
          lighting.push(dnLighStr);
          var str1 = '0.';
  
          var dnWwr = d.map(
            (val) => '"' + str1.concat(val.WWR.replace(/(\%)/, '')) + '"'
          );
          // var dnWwr =  d.map( val =>  val.WWR.replace(/(\%)/, "") )
          var dnWwrStr = Array.from(new Set(dnWwr)).toString();
  
          // dnWwrStr.map( val => str1.concat(val))
  
          wwr.push(dnWwrStr);
  
          var dnWwrNew = d.map((val) => str1.concat(val.WWR.replace(/(\%)/, '')));
          var dnWwrStrn = Array.from(new Set(dnWwrNew));
  
          var finalArr = dnWwrStrn.filter(function (val) {
            return val.toString().slice(-1) == '0';
          });
  
          var bgr = [];
          for (let i = 0; i < finalArr.length; i++) {
            var a = finalArr[i].toString().slice(0, -1);
            bgr.push(a);
          }
          var bgruniq = Array.from(new Set(bgr));
  
          var finalArrNew = dnWwrStrn.filter(function (val) {
            return val.toString().slice(-1) !== '0';
          });
  
          var bgrNew = [];
          for (let i = 0; i < finalArrNew.length; i++) {
            var b = finalArrNew[i].toString();
            bgrNew.push(b);
          }
          var bgruniqNew = Array.from(new Set(bgrNew));
  
          var connew = bgruniq.concat(bgruniqNew);
          var joar = connew.map((val) => '"' + val + '"');
  
          this.newWwr = joar.toString();
  
         
  
          var dnDl = d.map((val) => '"' + val.DL + '"');
          var dnDlStr = Array.from(new Set(dnDl)).toString();
          dl.push(dnDlStr);
  
          var dnHvac = d.map((val) => '"' + val.HVAC + '"');
          var dnHvacStr = Array.from(new Set(dnHvac)).toString();
          hvac.push(dnHvacStr);
  
          var dnHeat = d.map((val) => '"' + val.HEAT + '"');
          var dnHeatStr = Array.from(new Set(dnHeat)).join("|");
          heat.push(dnHeatStr);
  
          var newd: any = d;
  
          // if conditon start for demo project
          if (this.newEmail != 'demo@ecomatrix.io') {
            //  document.getElementById('brushdiv').style.display="none";
            document.getElementById('brushdiv').style.display = 'block';
  
            var dat = d.slice(0, 6);
      
            var tableData : any;
            if (this.newAshNecb == 'Necb') {
              this.selectedWwr = (this.newwwrVal * 100).toFixed(1) + '%';
            }
            if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0)  {
      
              tableData =  
              [{
                OPTIONS: this.ashrae,
                Letter: 'ASHRAE',
                WALL: this.wal,
                ROOF: this.rvi,
                FLOOR: this.fvi,
                WINDOW: this.wvi,
                SHADING: this.shd,
                INFILTRATION: this.lit,
                WWR: this.selectedWwr,
                DL: this.dls,
                HVAC: this.hva,
                HEAT: this.hre,
                EUI: this.eui,
                COSTPREMIUM: ' '
        }]
              ;
          if(this.custName != null && this.custName.length > 0){
            var a:string;
            a = tableData[0]['FLOOR'];
            tableData[0][this.custName] = a;
            delete tableData[0]['FLOOR'];
          }
            
            
  }
           /* var result = dat.reduce((unique, o) => {
              if (
                !unique.some(
                  (obj) => obj.EUI === o.EUI && obj.SAVINGS === o.SAVINGS
                )
              ) {
                unique.push(o);
              }
              return unique;
            }, []);
            
            const result = dat.reduce((accumulator, current) => {
              if (!accumulator.find((item) => item.EUI === current.EUI)) {
                accumulator.push(current);
              }
              return accumulator;
            }, []);*/
            var result = dat;
            if(tableData == undefined) {
              tableData = [];
            }
            this.authService.combIdSelMessage(dat[0]["cID"]);
            for (i = 0; i < result.length; i++) {
              result[i]['OPTIONS'] = 'Option' + (i + 1);
             // result[i]['DL SEN'] = result[i]['DL'];
              result[i]['HVAC SYS'] = result[i]['HVAC'];
              result[i]['HEAT_REC'] = result[i]['HEAT'];
              result[i]['EUI kWh/m2/yr'] = result[i]['EUI'];
              result[i]['SAVINGS %'] = result[i]['SAVINGS'];
              result[i]['COSTPREMIUM ($)'] = result[i]['COSTPREMIUM'];
              result[i]['CO2RED %'] = result[i]['CO2RED'];
              result[i]["OPCOST (1000's$)"] = result[i]['OPCOST'];
              result[i]['PAYBACK (yrs)'] = result[i]['PAYBACK'];
              result[i]['COMBID'] = result[i]['cID'];
              
              tableData.push(result[i]);
  
              d3.select('#grid')
  
                .datum(tableData)
              //   .call(grid)
                .selectAll('.row')
                .on({
                  mouseover: function (d, e) {
                    if (e != 0) {
                      
                      parcoords.highlight([d]);
                    }
                  },
                  click: (d) => {
                    this.savingsrep = d.SAVINGS;
                    this.euirepnew = d.EUI;
                    this.costNew = d.COSTPREMIUM;
                  },
                  mouseout: parcoords.unhighlight,
                });
              // drawchart(tableData);
            }
  
            //  if(this.message != 'default message') {
  
            if (this.newEmail == 'anuprathi1@gmail.com') {
              this.condId = this.newEventId;
            } else {
              this.condId = this.newUserId;
            }
            if (this.clickme == false) {
              this.msgurlNew =
                this.rootDomainUrl +
                'adeos/api/for_dashboard_chart_search.php?user_id=' +
                this.selectionUserId +
                '&proj_id=' +
                this.newProjId +
                '&newchart=' +
                '' +
                '&dl=' +
                dnDlStr +
                '&wall=' +
                dnStr +
                '&roof=' +
                dnRoofStr +
                '&floor=' +
                dnFloorStr +
                '&window=' +
                dnWinStr +
                '&shading=' +
                dnShaStr +
                '&inf=' +
                dnLighStr +
                '&wwr=' +
                this.newWwr +
                '&baseline=' +
                this.newAshNecbNew +
                '&heatRecovery=' +
                dnHeatStr +
                '&hvac=' +
                encodeURIComponent(dnHvacStr.toString());
            }
            if (this.clickme == true) {
              this.msgurlNew =
                this.rootDomainUrl +
                'adeos/api/for_dashboard_chart_search.php?user_id=' +
                this.selectionUserId +
                '&newchart=' +
                false +
                '&proj_id=' +
                this.newProjId +
                '&baseline=ASHRAE&wall="W1","W2","W3","W4","W5","W6","W7"' +
                '&roof="R1","R2","R3","R4","R5"' +
                '&floor="F1","F2","F3"' +
                '&window="WIN01","WIN02","WIN03","WIN04","WIN05","WIN06","WIN07","WIN08","WIN09","WIN10","WIN11","WIN12"' +
                '&inf="INF1","INF2","INF3"' +
                '&shading="NO","YES"' +
                '&wwr="0.1","0.15","0.21","0.3","0.4"' +
                '&dl="DLON","DLOFF"' +
                '&hvac="01_ASHP","02_WSHP","03_GSHP","04_FCU"' +
                '&heatRecovery="Y","N"';
            }
  
            d3.json(this.msgurlNew, (data) => {
              if (data) {
                document.getElementById('brushdiv').style.display = 'none';
  
                document.getElementById('mater').style.display = 'none';
  
                document.getElementById('loader').style.display = 'none';
  
                document.getElementById('mater').style.display = 'none';
                document.getElementById('hidebefor').style.display = 'block';
  
                document.getElementById('gridOuter').style.display = 'block';
  
                document.getElementById('dwdpdf').style.display = 'none';
  
                document.getElementById('actcost').style.display = 'block';
  
                document.getElementById('backwiz').style.display = 'block';
  
                // this.newdat = data.projLists.concat(parcoords.data())

                this.newdat = parcoords.data().concat(data.projLists);
  
                // custom baseline formula start
  
                if (this.newToggleEditable == 'true') {
                  (() => {
                    if (this.newEmail == 'anuprathi1@gmail.com') {
                      this.condId = this.newEventId;
                    } else {
                      this.condId = this.newUserId;
                    }
                    var wwr = this.newcustBaseWwr;
                    if (wwr.indexOf('%') > 0) {
                      wwr = (wwr.replace('%', '') / 100).toFixed(3);
                    }
                    this.msgurl1 =
                      this.rootDomainUrl +
                      'adeos/api/getCustomBaselineValues.php?user_id=' +
                      this.condId +
                      '&proj_id=' +
                      this.newProjId +
                      '&wall=' +
                      this.newcustBase +
                      '&roof=' +
                      this.newcustBaseRoof +
                      '&floor=' +
                      this.newcustBaseFloor +
                      '&window=' +
                      this.newcustBaseWindow +
                      '&shading=' +
                      this.newcustBaseShading +
                      '&infiltration=' +
                      this.newcustBaseInf +
                      '&wwr=' +
                      wwr +
                      '&dl=' +
                      this.newcustDaylight +
                      '&hvac=' +
                      encodeURIComponent(this.newcustBaseHvac.toString()) +
                      '&heatRec=' +
                      this.newcustHtRec;
  
                    this.http
                      .get(this.msgurl1)
                      .pipe(map((res) => res))
                      .subscribe((data1) => {
                        var eui = data1;
                        this.newcustumeui = this.customeui.eui;
                        this.costpremium = this.customeui.costpremium;
                        this.co2 = this.customeui.carbone;
                        this.opCost1 = this.customeui.opcost;

                        if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1)
                          && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                              d3.selectAll('.mygrid')
                                .select('.row')
                                .select('.col-3')
                                .text(this.fvi);
                            
                          }
  
                        for (var i = 0; i < data.projLists.length; i++) {
                          var lineCharts = d3
                            .selectAll('.mygrid')
                            .selectAll('.row');
  
                          var euiO = data.projLists[i]['EUI'];
                          var co2red = data.projLists[i]['CARBONE'];
                          var s =
                            Math.floor(
                              (1 - euiO / this.newcustumeui) * 100 * 100
                            ) / 100;
  
                            var costO = data.projLists[i]['COSTPREMIUM'];

                            var opCost = data.projLists[i]['OPCOST'];
                            
                            var cost1 =  Math.floor((costO - this.costpremium) * 100) / 100;
              
                            var co =
                              Math.floor((1 - co2red / this.co2) * 100);
              
                            var op =  Math.floor((opCost - this.opCost1) * 100) / 100;

                            var payBack = 0;

                            if(cost1 > 0 && op <= 0)
                              payBack = 100;
                            else if(cost1 < 0 && op >= 0)
                              payBack = 0;
                            else if(cost1/op > 100 && op > 0 && cost1 > 0) 
                              payBack = 100;
                            else if(cost1 > 0 && op > 0)
                              payBack =parseFloat ((cost1/op).toFixed(2));
                            else if(cost1 < 0 && op < 0)
                              payBack = 0;
                            else 
                              payBack = 0;
  
                          var chart = d3.select(lineCharts[0][i + 1]);
                         
                          var mySpans = document.getElementsByClassName("cell");
                          for(var j=0;j<mySpans.length;j++){
                            if(mySpans[j].innerHTML.indexOf('%SAVINGS') > -1){
                              var sav = mySpans[j].className;
                            }
                              if(mySpans[j].innerHTML.indexOf('C.P') > -1){
                                var parent = mySpans[j].className;
                              }
                              if(mySpans[j].innerHTML.indexOf('CO2RED') > -1){
                                var co2div = mySpans[j].className;
                           
                              }
                              if(mySpans[j].innerHTML.indexOf('O.C.S') > -1){
                                var ocsdiv = mySpans[j].className;
                               
                              }
                              if(mySpans[j].innerHTML.indexOf('PAYBACK') > -1){
                                var pbdiv = mySpans[j].className;
                                break;
                              }
                          }
                            
                          if (this.currentkpiFactors.indexOf('savings') != -1) {
                            const savingsValue =
                              data.projLists[i]?.SAVINGS ?? s;
                            //chart.select('.' + sav.split(' ')[0]).text(savingsValue);
                          }
                          if (this.currentkpiFactors.indexOf('cp') != -1) {
                        //    chart.select('.'+parent.split(" ")[0]).text(cost1);
                          }
                          if (this.currentkpiFactors.indexOf('ghg') != -1) {
                         //   chart.select('.'+co2div.split(" ")[0]).text(co);
                          }
                          if (this.currentkpiFactors.indexOf('op') != -1) {
                          //  chart.select('.'+ocsdiv.split(" ")[0]).text(op);
                          }
                          if (this.currentkpiFactors.indexOf('pp') != -1) {
                        //    chart.select('.'+pbdiv.split(" ")[0]).text(payBack);
                          }
                        }
                      });
                  })();
  
                }
  
                // custom baseline formula end
  
                for (var i = 0; i < data.projLists.length; i++) {
                  data.projLists[i].WWR =
                    (data.projLists[i].WWR * 100).toFixed(1) + '%';
                }
  
  
                if (this.clickme == false) {
                //  parcoords.render().brushMode('1D-axes').data(this.newdat);
                  
                }
                if (this.clickme == true) {
                  /*parcoords
                    .data(data.projLists)
                    .updateAxes()
                    .render()
                    .brushMode('1D-axes');*/
                }
              }
            });
          } // if conditon end for demo project
  
          if (this.newAshNecb == 'Ashare') {
            var dat = d.slice(0, 6);
            this.selectedWwr = dat[0].WWR;
            this.hvacID = dat[0].hvacID.slice(0, 1);
  
            if (this.newEmail == 'anuprathi1@gmail.com') {
              this.condId = this.newEventId;
            } else {
              this.condId = this.newUserId;
            }
            var wwrnew = this.selectedWwr;
            if (wwrnew.indexOf('%') > 0) {
              var wwrash: any = (wwrnew.replace('%', '') / 100).toFixed(3);
              this.ashwwr = wwrash;
            }
            if (this.newEmail == 'demo@ecomatrix.io') {
              var userDemo: string = '5';
              var userProj: string = this.demo_proj_id;
            } else {
              var userDemo: string = this.condId;
              var userProj: string = this.newProjId;
            }
            const bodynewac = new HttpParams()
              .set('user_id', userDemo)
              .set('proj_id', userProj)
              .set('wwr', wwrash)
              .set('active_hvac_system_id', this.hvacID)
              .set('baseline', 'ASHRAE');
  
            this.http
              .post(this.rootDomainUrl + 'adeos/api/getBaseline.php', bodynewac)
              .subscribe((data) => {
                this.custBaseNew = data;
  
                this.dls = this.custBaseNew.projLists.dls;
                this.eui = this.custBaseNew.projLists.Eui;
                this.lit = this.custBaseNew.projLists.infiltration;
                this.wal = this.custBaseNew.projLists.wall_r_value_ip;
                this.rvi = this.custBaseNew.projLists.roof_r_value_ip;
                this.fvi = this.custBaseNew.projLists.floor_r_value_ip;
  
                this.wvi = this.custBaseNew.projLists.win_r_value_ip;
                this.shd = this.custBaseNew.projLists.shading;
                this.hva = this.custBaseNew.projLists.hvac_sys;
                this.hre = this.custBaseNew.projLists.heatRecovery;
                this.wwr = this.custBaseNew.projLists.wwr;
  
                for (var i = 0; i < this.buildEnv.projLists.length; i++) {
                //  if (this.buildEnv.projLists[i].wall_r_value_ip == this.wal) {
                    //2.3 changes
                 //   this.wal = this.buildEnv.projLists[i].wall_r_value_ip;
                   
                //  }
  
               //   if (this.buildEnv.projLists[i].roof_r_value_ip == this.rvi) {
                 //   this.rvi = this.buildEnv.projLists[i].roof_r_value_ip;
                  
                //  }
  
               //   if (this.buildEnv.projLists[i].floor_r_value_ip == this.fvi) {
               //     this.fvi = this.buildEnv.projLists[i].floor_r_value_ip;
               //   }
  
                  if (this.buildEnv.projLists[i].windows == this.wvi) {
                    this.wvi = this.buildEnv.projLists[i].win_r_value_ip;
                  }
                }
  
                // lighting data start
  
                for (var i = 0; i < this.infData.projLists.length; i++) {
                  if (this.infData.projLists[i].infiltration_val == this.lit) {
                    this.lit = this.infData.projLists[i].infiltration_ref;
                  }
                }
  
                // this.wwr = this.wwr*100
                // this.wwr = this.wwr +'%';
                this.wwr = (this.wwr * 100).toFixed(1) + '%';
                if (this.dls == 'YES') {
                  this.dls = 'DLON';
                }
                if (this.dls == 'NO') {
                  this.dls = 'DLOFF';
                }
                if(this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0) {
                  //const euiColumnClass = this.getDynamicGridColumnClass(11);
                  const euiColumnClass = this.getColumnIndex('EUI');
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select(`.col-${euiColumnClass}`)
                    .text(this.eui);
                
               
                if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WWR') == -1)
                && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                    const wwrColumnClass = this.getColumnIndex('WWR');
                    d3.selectAll('.mygrid')
                      .select('.row')
                      .select(`.col-${wwrColumnClass}`)
                      .text(this.wwr);
                    }
                }
                if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                      const floorColumnClass = this.getColumnIndex('Curtain Walls');
                      d3.selectAll('.mygrid')
                        .select('.row')
                        .select(`.col-${floorColumnClass}`)
                        .text(this.fvi);
                    
                  }

               
        var tableData : any;
      
        if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0)  {
      
            tableData = 
              [{
                 OPTIONS: this.ashrae,
                    Letter: 'ASHRAE',
                    WALL: this.wal,
                    ROOF: this.rvi,
                    FLOOR: this.fvi,
                    WINDOW: this.wvi,
                    SHADING: this.shd,
                    INFILTRATION: this.lit,
                    WWR: this.wwr,
                    DL: this.dls,
                    HVAC: this.hva,
                    HEAT: this.hre,
                    EUI: this.eui,
                    COSTPREMIUM: '',
        }];
              
            
  }
                var dat = d.slice(0, 6);
                /*var result = dat.reduce((unique, o) => {
                  if (
                    !unique.some(
                      (obj) => obj.EUI === o.EUI && obj.SAVINGS === o.SAVINGS
                    )
                  ) {
                    unique.push(o);
                  }
                  return unique;
                }, []);*/
               /* var result = dat.reduce((accumulator, current) => {
                  if (!accumulator.find((item) => item.EUI === current.EUI)) {
                    accumulator.push(current);
                  }
                  return accumulator;
                }, []);*/
                var result = dat;
                for (i = 0; i < result.length; i++) {
                  result[i]['OPTIONS'] = 'Option' + (i + 1);
                  tableData.push(result[i]);
                  drawchart(tableData);
                }
                if (this.newEmail == 'demo@ecomatrix.io') {
                  
                  d3.select('#grid')
  
                    .datum(tableData)
                    .call(grid)
  
                    .selectAll('.row')
                    .on({
                      mouseover: function (d, e) {
                        if (e != 0) {
                          
  
                          parcoords.highlight([d]);
                        }
                      },
                      click: (d) => {
                        this.savingsrep = d.SAVINGS;
                        this.euirepnew = d.EUI;
                        this.costNew = d.COSTPREMIUM;
                      },
                      mouseout: parcoords.unhighlight,
                    });
                }
              });
  
            // drawchart(tableData);
          }
  
          if (this.newAshNecb == 'Necb') {
            var dat = d.slice(0, 6);
  
            this.selectedWwr = dat[0].WWR;
            this.hvacID = dat[0].hvacID.slice(0, 1);
  
            if (this.newEmail == 'anuprathi1@gmail.com') {
              this.condId = this.newEventId;
            } else {
              this.condId = this.newUserId;
            }
            var wwrnew = this.selectedWwr;
            if (wwrnew.indexOf('%') > 0) {
              var wwrash: any = (wwrnew.replace('%', '') / 100).toFixed(3);
              this.ashwwr = wwrash;
            }
            if (this.newEmail == 'demo@ecomatrix.io') {
              var userDemo: string = '5';
              var userProj: string = this.demo_proj_id;
            } else {
              var userDemo: string = this.condId;
              var userProj: string = this.newProjId;
            }
            const bodynewac = new HttpParams()
              .set('user_id', userDemo)
              .set('proj_id', userProj)
              .set('wwr', this.newwwrVal)
              .set('active_hvac_system_id', this.hvacID)
              .set('baseline', 'NECB');
  
            this.http
              .post(this.rootDomainUrl + 'adeos/api/getBaseline.php', bodynewac)
              .subscribe((data) => {
                this.custBaseNew = data;
  
                this.dls = this.custBaseNew.projLists.dls;
                this.eui = this.custBaseNew.projLists.Eui;
                this.lit = this.custBaseNew.projLists.infiltration;
                this.wal = this.custBaseNew.projLists.wall_r_value_ip;
                this.rvi = this.custBaseNew.projLists.roof_r_value_ip;
                this.fvi = this.custBaseNew.projLists.floor_r_value_ip;
  
                this.wvi = this.custBaseNew.projLists.win_r_value_ip;
                this.shd = this.custBaseNew.projLists.shading;
                this.hva = this.custBaseNew.projLists.hvac_sys;
                this.hre = this.custBaseNew.projLists.heatRecovery;
                this.wwr = this.custBaseNew.projLists.wwr;
  
                for (var i = 0; i < this.buildEnv.projLists.length; i++) {
                  if (this.buildEnv.projLists[i].wall_r_value_ip == this.wal) {
                    this.wal = this.buildEnv.projLists[i].wall_r_value_ip;
                  }
  
                  if (this.buildEnv.projLists[i].roof_r_value_ip == this.rvi) {
                    this.rvi = this.buildEnv.projLists[i].roof_r_value_ip;
                  }
  
                  if (this.buildEnv.projLists[i].floor_r_value_ip == this.fvi) {
                    this.fvi = this.buildEnv.projLists[i].floor_r_value_ip;
                  }
  
                  if (this.buildEnv.projLists[i].windows == this.wvi) {
                    this.wvi = this.buildEnv.projLists[i].win_r_value_ip;
                  }
                }
  
                // lighting data start
  
                for (var i = 0; i < this.infData.projLists.length; i++) {
                  if (this.infData.projLists[i].infiltration_val == this.lit) {
                    this.lit = this.infData.projLists[i].infiltration_ref;
                  }
                }
  
                // this.wwr = this.wwr*100
                // this.wwr = this.wwr +'%';
                this.wwr = (this.wwr * 100).toFixed(1) + '%';
                if (this.dls == 'YES') {
                  this.dls = 'DLON';
                }
                if (this.dls == 'NO') {
                  this.dls = 'DLOFF';
                }
                if(this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0) {
                   const euiColumnClass = this.getColumnIndex('EUI');
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select(`.col-${euiColumnClass}`)
                    .text(this.eui);
                
                    d3.selectAll('.mygrid')
                    .select('.row')
                    .select(`.col-${this.getColumnIndex('OPTIONS')}`)
                    .text(this.necb);
                 
                }
                if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                        const floorColumnClass = this.getColumnIndex('Curtain Walls');
                      d3.selectAll('.mygrid')
                        .select('.row')
                        .select(`.col-${floorColumnClass}`)
                        .text(this.fvi);
                    
                  }

                /*if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WWR') == -1)
                && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                    d3.selectAll('.mygrid')
                      .select('.row')
                      .select(`.col-${this.getColumnIndex('WWR')}`)
                      .text(this.wwr);
                    }*/
                  var tableData : any ;
      
                  if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0)  {
      
            tableData = 
              [{
                    OPTIONS: this.necb,
                    Letter: 'NECB',
                    WALL: this.wal,
                    ROOF: this.rvi,
                    FLOOR: this.fvi,
                    WINDOW: this.wvi,
                    SHADING: this.shd,
                    INFILTRATION: this.lit,
                    WWR: this.wwr,
                    DL: this.dls,
                    HVAC: this.hva,
                    HEAT: this.hre,
                    EUI: this.eui,
                    COSTPREMIUM: '',
                  }];
                      
                      
            }

                var dat = d.slice(0, 6);
                /*var result = dat.reduce((unique, o) => {
                  if (
                    !unique.some(
                      (obj) => obj.EUI === o.EUI && obj.SAVINGS === o.SAVINGS
                    )
                  ) {
                    unique.push(o);
                  }
                  return unique;
                }, []);
                var result = dat.reduce((accumulator, current) => {
                  if (!accumulator.find((item) => item.EUI === current.EUI)) {
                    accumulator.push(current);
                  }
                  return accumulator;
                }, []);*/
        var result = dat;
                for (i = 0; i < result.length; i++) {
                  result[i]['OPTIONS'] = 'Option' + (i + 1);
                 
                  tableData.push(result[i]);
                  drawchart(tableData);
                }

                if (
  this.newEmail == 'demo@ecomatrix.io' &&
  this.custName != null &&
  this.custName.length > 0
) {
    tableData.forEach((row) => {
        if (row.FLOOR !== undefined) {
            row[this.custName] = row.FLOOR;
            delete row.FLOOR;
        }
    });
}


                if (this.newEmail == 'demo@ecomatrix.io') {
                  
                  d3.select('#grid')
  
                    .datum(tableData)
                    .call(grid)
  
                    .selectAll('.row')
                    .on({
                      mouseover: function (d, e) {
                        if (e != 0) {
                          
  
                          parcoords.highlight([d]);
                        }
                      },
                      click: (d) => {
                        this.savingsrep = d.SAVINGS;
                        this.euirepnew = d.EUI;
                        this.costNew = d.COSTPREMIUM;
                      },
                      mouseout: parcoords.unhighlight,
                    });
                }
                // drawchart(tableData);
              });
          }
          // custom baseline start
  
          if (this.newAshNecb == 'noash') {
            //  draw(d.slice(0,4))
            var dat = d.slice(0, 6);
            
            d3.selectAll('.mygrid')
              .select('.row')
              .select('.col-11')
              .text(this.newcustumeui);
            d3.selectAll('.mygrid')
              .select('.row')
              .select('.col-9')
              .text(this.newcustBaseHvac);
            
              
            var tableData : any;
            if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0) {
            tableData = [
              {
                OPTIONS: this.cb,
                Letter: this.cb,
                WALL: this.custBaseDispWall,
                ROOF: this.custBaseDispRoof,
                FLOOR: this.custBaseDispFloor,
                WINDOW: this.custBaseDispWin,
                SHADING: this.newcustBaseShading,
                INFILTRATION: this.custBaseDispLight,
                WWR: this.newcustBaseWwr,
                DL: this.newcustDaylight,
                HVAC: this.newcustBaseHvac,
                HEAT: this.hre,
                EUI: this.newcustumeui,
                COSTPREMIUM: '',
              },
            ];
            if(this.custName != null && this.custName.length > 0){
              var a:string;
              a = tableData[0]['FLOOR'];
              tableData[0][this.custName] = a;
              delete tableData[0]['FLOOR'];
            }
          } else {
            tableData = [];
          }
            /*var result = dat.reduce((unique, o) => {
              if (
                !unique.some(
                  (obj) => obj.EUI === o.EUI && obj.SAVINGS === o.SAVINGS
                )
              ) {
                unique.push(o);
              }
              return unique;
            }, []);*/
            if(tableData == undefined) {
              tableData = [];
            }
            var result = dat;
  
            for (i = 0; i < result.length; i++) {
              result[i]['OPTIONS'] = 'Option' + (i + 1);
              
              tableData.push(result[i]);
              drawchart(tableData);
            }
  
            if (this.newEmail == 'demo@ecomatrix.io') {

              d3.select('#grid')
  
                .datum(tableData)
                .call(grid)
  
                .selectAll('.row')
                .on({
                  mouseover: function (d, e) {
                    if (e != 0) {
                     
  
                      parcoords.highlight([d]);
                    }
                  },
                  click: (d) => {
                    this.savingsrep = d.SAVINGS;
                    this.euirepnew = d.EUI;
                    this.costNew = d.COSTPREMIUM;
                  },
                  mouseout: parcoords.unhighlight,
                });
            }
            // drawchart(tableData);
          }
  
          // custom baseline end
  
          if (this.newEmail != 'demo@ecomatrix.io') {
            d3.select('#grid')
  
              .datum(tableData)
              .call(grid)
  
              .selectAll('.row')
              .on({
                mouseover: function (d, e) {
                  if (e != 0) {
                    
  
                    parcoords.highlight([d]);
                  }
                },
                click: (d) => {
                  this.savingsrep = d.SAVINGS;
                  this.euirepnew = d.EUI;
                  this.costNew = d.COSTPREMIUM;
                },
                mouseout: parcoords.unhighlight,
              });
          }

    var elementHeader = document.querySelectorAll('.mygrid > .header')[0];
    var elementChildList = elementHeader['children'];
   
    const screenWidth = ((this.screenwidth/(elementChildList.length-this.gridLen)-1)-0.5)-1;
    //const screenWidth = ((window.innerWidth/(elementChildList.length-this.gridLen)-1)-0.5)-1;
    this.dynamicSingleWidth = screenWidth;
    
    const elementClassNameRecords = document.getElementsByClassName("cell")
    for (var i1 in elementClassNameRecords) {
            if(elementClassNameRecords[i1]) {
             
              
              elementClassNameRecords[i1]["style"].width = `${screenWidth}`+"px";
              elementClassNameRecords[i1]["style"].maxWidth = "40%";
           //   elementClassNameRecords[i1]["style"].paddingLeft = `${screenWidth}`+"px";
           }
    }
  
      }); // brushend event end


      if (data) {
        if (this.newAshNecb == 'Ashare') {
          if (this.newEmail == 'anuprathi1@gmail.com') {
            this.condId = this.newEventId;
          } else {
            this.condId = this.newUserId;
          }
          if (this.newEmail == 'demo@ecomatrix.io') {
            var userDemo: string = '5';
            var userProj: string = this.demo_proj_id;
          } else {
            var userDemo: string = this.condId;
            var userProj: string = this.newProjId;
          }

          const bodynewac = new HttpParams()
            .set('user_id', userDemo)
            .set('proj_id', userProj)
            .set('wwr', this.wwronerep)
            .set('active_hvac_system_id', this.hvacID)
            .set('baseline', 'ASHRAE');

          this.http
            .post(this.rootDomainUrl + 'adeos/api/getBaseline.php', bodynewac)
            .subscribe((data) => {
              this.custBaseNew = data;

              this.dls = this.custBaseNew.projLists.dls;
              this.eui = this.custBaseNew.projLists.Eui;
              this.lit = this.custBaseNew.projLists.infiltration;
              this.wal = this.custBaseNew.projLists.wall_r_value_ip;
              this.rvi = this.custBaseNew.projLists.roof_r_value_ip;
              this.fvi = this.custBaseNew.projLists.floor_r_value_ip;

              this.wvi = this.custBaseNew.projLists.win_r_value_ip;
              this.shd = this.custBaseNew.projLists.shading;
              this.hva = this.custBaseNew.projLists.hvac_sys;
              this.hre = this.custBaseNew.projLists.heatRecovery;
              this.wwr = this.custBaseNew.projLists.wwr;

              //  d3.selectAll(".mygrid").select(".row").select(".col-1").text(this.wal);
              //  d3.selectAll(".mygrid").select(".row").select(".col-2").text(this.fvi);
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WINDOW') == -1) 
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0) ) {
              d3.selectAll('.mygrid')
                .select('.row')
                .select('.col-4')
                .text(this.wvi);
                  }
                

              for (var i = 0; i < this.buildEnv.projLists.length; i++) {
              //  if (this.buildEnv.projLists[i].wall_r_value_ip == this.wal) {
                  //2.3 changes
                  //this.wal = this.buildEnv.projLists[i].wall_r_value_ip;
                 // this.wal = this.buildEnv.projLists[i].wall_r_value_ip;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WALL') == -1) 
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0) ) {
                      d3.selectAll('.mygrid')
                      .select('.row')
                      .select('.col-1')
                      .text(this.wal);
                    }
                  
                 
                d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-1')
                    .style.width = "100px";
                  this.wallan = this.buildEnv.projLists[i].wall_u_value;
                  this.walashnec = this.buildEnv.projLists[i].wall_r_value_ip;
              //  }

                //if (this.buildEnv.projLists[i].roof_r_value_ip == this.rvi) {
                 // this.rvi = this.buildEnv.projLists[i].roof_r_value_ip;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('ROOF') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                      d3.selectAll('.mygrid')
                        .select('.row')
                        .select('.col-2')
                        .text(this.rvi);
                    }
                  
                  this.roofan = this.buildEnv.projLists[i].roof_u_value_si;
                  this.roofrvi = this.buildEnv.projLists[i].roof_r_value_ip;
               // }

              //  if (this.buildEnv.projLists[i].floor_r_value_ip == this.fvi) {
               //   this.fvi = this.buildEnv.projLists[i].floor_r_value_ip;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                      d3.selectAll('.mygrid')
                        .select('.row')
                        .select('.col-3')
                        .text(this.fvi);
                    
                  }
                  this.flooran = this.buildEnv.projLists[i].flr_u_value_si;
                  this.flooranfvi = this.buildEnv.projLists[i].floor_r_value_ip;
                //}

                if (this.buildEnv.projLists[i].windows == this.wvi) {
                  this.winan = this.buildEnv.projLists[i].win_u_value_si;
                  this.winipBase = this.buildEnv.projLists[i].win_r_value_ip;
                  this.winanshgc = this.buildEnv.projLists[i].win_shgc;
                }
              }

              // lighting data start

              //for (var i = 0; i < this.infData.projLists.length; i++) {
              //  if (this.infData.projLists[i].infiltration_ref == this.lit) {
                  //this.lit = this.infData.projLists[i].infiltration_ref;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('INFILTRATION') == -1)
                  &&  (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {

                      d3.selectAll('.mygrid')
                        .select('.row')
                        .select('.col-6')
                        .text(this.lit);
                    
                  }
                  this.litNew = this.lit;
                //}
             // }

              for (var i = 0; i < this.hvData.projLists.length; i++) {
                if (this.hvData.projLists[i].HVAC_system == this.hva) {
                  this.boilercopan = this.hvData.projLists[i].boilerCOP;
                  this.chillercopan = this.hvData.projLists[i].chillerCOP;
                }
              }
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('SHADING') == -1)
              && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-5')
                    .text(this.shd);
                
              }

              this.wwr = (this.wwr * 100).toFixed(1) + '%';

              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WWR') == -1)
              && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-7')
                    .text(this.wwr);
                
              }

              if (this.dls == 'YES') {
                this.dls = 'DLON';
              }
              if (this.dls == 'NO') {
                this.dls = 'DLOFF';
              }
          
                if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('DL') == -1)
                && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-8')
                    .text(this.dls);
                }
            
            
                if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HVAC') == -1)
                && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-9')
                    .text(this.hva);
               
              }
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HEAT') == -1) &&
              (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
              d3.selectAll('.mygrid')
                .select('.row')
                .select('.col-10')
                .text(this.hre);
              }
              if((this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)
                && this.currentkpiFactors.indexOf('eui') >= 0) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-11')
                  .text(this.eui);
              }
            });
        }

        if (this.newAshNecb == 'Necb') {
          if (this.newEmail == 'anuprathi1@gmail.com') {
            this.condId = this.newEventId;
          } else {
            this.condId = this.newUserId;
          }

          if (this.newEmail == 'demo@ecomatrix.io') {
            var userDemo: string = '5';
            var userProj: string = this.demo_proj_id;
            this.newwwrVal = this.buildEnv.projLists[6].necb.WWR1 ;
          
          } else {
            var userDemo: string = this.condId;
            var userProj: string = this.newProjId;
          }
          // var hvacID = data.projLists[0].hvacID.slice(0,1);

          const bodynewac = new HttpParams()
            .set('user_id', userDemo)
            .set('proj_id', userProj)
            .set('wwr', this.newwwrVal)
            .set('active_hvac_system_id', this.hvacID)
            .set('baseline', 'Necb');

          this.http
            .post(this.rootDomainUrl + 'adeos/api/getBaseline.php', bodynewac)
            .subscribe((data) => {
              this.custBaseNew = data;

              this.dls = this.custBaseNew.projLists.dls;
              this.eui = this.custBaseNew.projLists.Eui;
              this.lit = this.custBaseNew.projLists.infiltration;
              this.wal = this.custBaseNew.projLists.wall_r_value_ip;
              this.rvi = this.custBaseNew.projLists.roof_r_value_ip;
              this.fvi = this.custBaseNew.projLists.floor_r_value_ip;

              this.wvi = this.custBaseNew.projLists.win_r_value_ip;
              this.shd = this.custBaseNew.projLists.shading;
              this.hva = this.custBaseNew.projLists.hvac_sys;
              this.hre = this.custBaseNew.projLists.heatRecovery;
              this.wwr = this.custBaseNew.projLists.wwr;

              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WINDOW') == -1) 
              && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0) ) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-4')
                  .text(this.wvi);
              }

              for (var i = 0; i < this.buildEnv.projLists.length; i++) {
                //if (this.buildEnv.projLists[i].wall_r_value_ip == this.wal) {
                 // this.wal = this.buildEnv.projLists[i].wall_r_value_ip;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WALL') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                      d3.selectAll('.mygrid')
                      .select('.row')
                      .select('.col-1')
                      .text(this.wal);
                    }
                    d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-1')
                    .style.width = "100px";

                 
                  this.wallan = this.buildEnv.projLists[i].wall_u_value;
                  this.walashnec = this.buildEnv.projLists[i].wall_r_value_ip;
                //}

               // if (this.buildEnv.projLists[i].roof_r_value_ip == this.rvi) {
                //  this.rvi = this.buildEnv.projLists[i].roof_r_value_ip;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('ROOF') == -1) 
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-2')
                    .text(this.rvi);
                  }
                  this.roofan = this.buildEnv.projLists[i].roof_u_value_si;
                  this.roofrvi = this.buildEnv.projLists[i].roof_r_value_ip;
               // }

               // if (this.buildEnv.projLists[i].floor_r_value_ip == this.fvi) {
              //    this.fvi = this.buildEnv.projLists[i].floor_r_value_ip;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                  d3.selectAll('.mygrid')
                    .select('.row')
                    .select('.col-3')
                    .text(this.fvi);
                  }
                  this.flooran = this.buildEnv.projLists[i].flr_u_value_si;
                  this.flooranfvi = this.buildEnv.projLists[i].floor_r_value_ip;
               // }

                if (this.buildEnv.projLists[i].win_r_value_ip?.split(" ").join("") == this.wvi.split(" ").join("")) {
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WINDOW') == -1) 
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0) ) {
                    //    this.wvi = this.buildEnv.projLists[i].windows;
                    //   d3.selectAll(".mygrid").select(".row").select(".col-4").text(this.wvi);
                    this.winan = this.buildEnv.projLists[i].win_u_value_si;
                    this.winipBase = this.buildEnv.projLists[i].win_r_value_ip;
                    this.winanshgc = this.buildEnv.projLists[i].win_shgc;
                
                  }
                }
              }

              // lighting data start

              for (var i = 0; i < this.infData.projLists.length; i++) {
               // if (this.infData.projLists[i].infiltration_ref == this.lit) {
               //   this.lit = this.infData.projLists[i].infiltration_ref;
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('INFILTRATION') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                    d3.selectAll('.mygrid')
                      .select('.row')
                      .select('.col-6')
                      .text(this.lit);
                  }
                  this.litNew = this.infData.projLists[i].inf_val;
                //}
              }

              for (var i = 0; i < this.hvData.projLists.length; i++) {
                if (this.hvData.projLists[i].HVAC_system == this.hva) {
                  this.boilercopan = this.hvData.projLists[i].boilerCOP;
                  this.chillercopan = this.hvData.projLists[i].chillerCOP;
                }
              }
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('SHADING') == -1)
              && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-5')
                  .text(this.shd);
              }

              this.wwr = (this.wwr * 100).toFixed(1) + '%';
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WWR') == -1)
              && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-7')
                  .text(this.wwr);
              }

              if (this.dls == 'YES') {
                this.dls = 'DLON';
              }
              if (this.dls == 'NO') {
                this.dls = 'DLOFF';
              }
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('DL') == -1)
              && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-8')
                  .text(this.dls);
              }
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HVAC') == -1)
              && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-9')
                  .text(this.hva);
              }
              if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HEAT') == -1) &&
              (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-10')
                  .text(this.hre);
              }
              if((this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)
              && this.currentkpiFactors.indexOf('eui') >= 0) {
                d3.selectAll('.mygrid')
                  .select('.row')
                  .select('.col-11')
                  .text(this.eui);
              }

              this.wwr = (this.wwr * 100).toFixed(1) + '%';
              
              if (this.dls == 'YES') {
                this.dls = 'DLON';
              }
              if (this.dls == 'NO') {
                this.dls = 'DLOFF';
              }
            });
        }
        //  cust baseline start
        if (this.newAshNecb == 'noash') {
          if (this.newEmail == 'anuprathi1@gmail.com') {
            this.condId = this.newEventId;
          } else {
            this.condId = this.newUserId;
          }
          if (this.newEmail == 'demo@ecomatrix.io') {
            var userDemo: string = '5';
            var userProj: string = this.demo_proj_id;
          } else {
            var userDemo: string = this.condId;
            var userProj: string = this.newProjId;
          }
          var wwr = this.newcustBaseWwr;
          if (this.newEmail == 'demo@ecomatrix.io' && wwr.trim().length == 0) {
            wwr = '15%';
          }
          if (wwr.indexOf('%') > 0) {
            var wwrnew: any = wwr.replace('%', '') / 100;
            // this.custwwr = wwr;
          }

          const bodynewac = new HttpParams()
            .set('user_id', userDemo)
            .set('proj_id', userProj)
            .set('wwr', wwrnew)
            .set('active_hvac_system_id', this.newcustBaseHvac)
            .set('baseline', 'CUSTOMBASELINE');

          this.http
            .post(this.rootDomainUrl + 'adeos/api/getBaseline.php', bodynewac)
            .subscribe((data) => {
              this.custBaseNew = data;

              this.dls = this.custBaseNew.projLists.dls;
              this.eui = this.custBaseNew.projLists.Eui;
              this.lit = this.infData.projLists.find((obj) => obj.inf === this.newcustBaseInf).infiltration_ref;
              this.wal = this.buildEnv.projLists.find((obj) => obj.wall === this.newcustBase).wall_r_value_ip;
              this.rvi = this.buildEnv.projLists.find((obj) => obj.roof === this.newcustBaseRoof).roof_r_value_ip;
              this.fvi = this.buildEnv.projLists.find((obj) => obj.floor === this.newcustBaseFloor).floor_r_value_ip;
              this.wvi = this.buildEnv.projLists.find((obj) => obj.windows === this.newcustBaseWindow).win_r_value_ip;
              this.shd = this.custBaseNew.projLists.shading;
              this.hva = this.newcustBaseHvac;
              this.hre = this.custBaseNew.projLists.heatRecovery;
              this.wwr = this.custBaseNew.projLists.wwr;

              for (var i = 0; i < this.buildEnv.projLists.length; i++) {
                //if (this.buildEnv.projLists[i].wall_r_value_ip == this.wal) {
                  if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WALL') == -1)
                  && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                      d3.selectAll('.mygrid')
                      .select('.row')
                      .select('.col-1')
                      .text(this.wal);
                      }
                  //  }
                   // if (this.buildEnv.projLists[i].roof_r_value_ip == this.rvi) {
                        if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('ROOF') == -1) 
                        && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                          d3.selectAll('.mygrid')
                            .select('.row')
                            .select('.col-2')
                            .text(this.rvi);
                      }
                  //  }
                   // if (this.buildEnv.projLists[i].floor_r_value_ip == this.fvi) {
                      if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1)
                        && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                        d3.selectAll('.mygrid')
                          .select('.row')
                          .select('.col-3')
                          .text(this.fvi);
                        }
                    //  }
                      if (this.buildEnv.projLists[i].win_r_value_ip?.split(" ").join("") == this.wvi.split(" ").join("")) {
                      if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WINDOW') == -1)
                      && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                          d3.selectAll('.mygrid')
                        .select('.row')
                        .select('.col-4')
                        .text(this.wvi);
                      }
                    }
                  }
                    if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('SHADING') == -1)
                          && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                            d3.selectAll('.mygrid')
                              .select('.row')
                              .select('.col-5')
                              .text(this.shd);
                    }

                    if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WWR') == -1)
                      && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                       d3.selectAll('.mygrid')
                          .select('.row')
                          .select('.col-7')
                          .text(this.newcustBaseWwr);
                      }
                      if (this.dls == 'YES') {
                        this.dls = 'DLON';
                      }
                      if (this.dls == 'NO') {
                        this.dls = 'DLOFF';
                      }
                      if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('DL') == -1)
                            && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                              d3.selectAll('.mygrid')
                                .select('.row')
                                .select('.col-8')
                                .text(this.dls);
                            }

                      for (var i = 0; i < this.infData.projLists.length; i++) {
                    //    if (this.infData.projLists[i].infiltration_ref == this.lit) {
                         // this.lit = this.infData.projLists[i].infiltration_ref;
                          if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('INFILTRATION') == -1)
                          && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                            d3.selectAll('.mygrid')
                              .select('.row')
                              .select('.col-6')
                              .text(this.lit);
                          }
                        
                    //    }
                      }
                      if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HVAC') == -1)
                        && (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                          d3.selectAll('.mygrid')
                            .select('.row')
                            .select('.col-9')
                            .text(this.hva);
                        }
                  
                      if((this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HEAT') == -1) &&
                      (this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)) {
                        d3.selectAll('.mygrid')
                          .select('.row')
                          .select('.col-10')
                          .text(this.hre);
                      }
                      if((this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)
                        && this.currentkpiFactors.indexOf('eui') >= 0) {
                          d3.selectAll('.mygrid')
                          .select('.row')
                          .select('.col-11')
                          .text(this.newcustumeui);
                        }
              });
                          
        }

        // cust baseline end
        (<HTMLInputElement>document.getElementById('dwdpdf')).disabled = true;
        if (this.newEmail != 'demo@ecomatrix.io') {
          setTimeout(
            () =>
              ((<HTMLInputElement>document.getElementById('dwdpdf')).disabled =
                false),
            7000
          );
        }
        if (this.newEmail == 'demo@ecomatrix.io') {
          setTimeout(
            () =>
              ((<HTMLInputElement>document.getElementById('dwdpdf')).disabled =
                false),
            7000
          );
        }

        //this.groupChart();
        //this.barnegChart();

        //setTimeout(() => this.groupChartRep(), 9000);

        this.child.proSnkapi();

        //    this.costSurcharge()

        //setTimeout(() => this.costSurcharge(), 10000);

        setTimeout(() => this.stackedChart(), 5000);

        //setTimeout(() => this.stackedChartReportNew(), 5000);

    setTimeout(() => this.corechart(), 5000);
    
        document.getElementById('loader').style.display = 'none';
        // document.getElementById('actcost').style.display="block";
        document.getElementById('mater').style.display = 'none';
        document.getElementById('hidebefor').style.display = 'block';

        document.getElementById('gridOuter').style.display = 'block';

        document.getElementById('dwdpdf').style.display = 'none';

        document.getElementById('actcost').style.display = 'block';

        document.getElementById('backwiz').style.display = 'block';
      }

      if (this.newChartMsg == 'No') {
        var gridColumns = [
          'OPTIONS',
          'WALL'
        ];

       // if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WALL') == -1) {
         //   gridColumns.push('WALL');
          //}
        if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('ROOF') == -1) {
            gridColumns.push('ROOF');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1) {
            if(this.custName.length > 0) {
              gridColumns.push(this.custName);
            } else {
              gridColumns.push('FLOOR');
            }
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WINDOW') == -1) {
            gridColumns.push('WINDOW');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WWR') == -1) {
            gridColumns.push('WWR');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('SHADING') == -1) {
            gridColumns.push('SHADING');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('INFILTRATION') == -1) {
            gridColumns.push('INFILTRATION');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('DL') == -1) {
            gridColumns.push('DL');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HVAC') == -1) {
            gridColumns.push('HVAC');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HEAT') == -1) {
            gridColumns.push('HEAT');
          }
          if (this.currentkpiFactors.length > 0) {
            if (this.currentkpiFactors.indexOf('eui') != -1) {
              gridColumns.push('EUI');
            }
            if (this.currentkpiFactors.indexOf('savings') != -1) {
            gridColumns.push('SAVINGS');
            }
            if (this.currentkpiFactors.indexOf('cp') != -1) {
              gridColumns.push('COSTPREMIUM');
            }
            if (this.currentkpiFactors.indexOf('ghg') != -1) {
              gridColumns.push('CO2RED');
            }
            if (this.currentkpiFactors.indexOf('op') != -1) {
              gridColumns.push('OPCOST');
            }
            if (this.currentkpiFactors.indexOf('pp') != -1) {
              gridColumns.push('PAYBACK');
            }
          }
            var scrwid = window.innerWidth - (window.innerWidth/gridColumns.length-this.gridLen-1);
           
            document.getElementById('example').style.marginLeft = (window.innerWidth/gridColumns.length-1).toString()+"px";
          
            this.hideAxisArr = [
              'cID',
              'hvacID',
              'cylinders',
              'TotalCooling',
              'TotalDistrFanEnergy',
              'TotalDistrPumpE',
              'TotalHeatRejPumpE',
              'TotalHeating',
              'TotalLight',
              'CARBONE'
            ];
            if (this.currentkpiFactors.length > 0) {
            if (this.currentkpiFactors.indexOf('eui') == -1) {
                    this.hideAxisArr.push('EUI');
                  }
            if (this.currentkpiFactors.indexOf('savings') == -1) {
                    this.hideAxisArr.push('SAVINGS');
            }
            if (this.currentkpiFactors.indexOf('cp') == -1) {
              this.hideAxisArr.push('COSTPREMIUM');
            }
            if (this.currentkpiFactors.indexOf('ghg') == -1) {
              this.hideAxisArr.push('CO2RED');
            }
            if (this.currentkpiFactors.indexOf('op') == -1) {
              this.hideAxisArr.push('OPCOST');
            }
            if (this.currentkpiFactors.indexOf('pp') == -1) {
              this.hideAxisArr.push('PAYBACK');
            }
            if (this.currentkpiFactors.indexOf('tedi') == -1) {
                    this.hideAxisArr.push('TEDI');
                  }
            if (this.currentkpiFactors.indexOf('tc') == -1) {
                    this.hideAxisArr.push('TEDI_COST');
                  }
                }
        if(this.currentHideArr?.indexOf('WALL') !== -1) {
          this.hideAxisArr.push('WALL');
        }
        if(this.currentHideArr.indexOf('ROOF') !== -1) {
          this.hideAxisArr.push('ROOF');
        }
        if(this.currentHideArr.indexOf('FLOOR') !== -1) {
          if(this.custName.length > 0) {
            this.hideAxisArr.push(this.custName);
          } else {
            this.hideAxisArr.push('FLOOR');
          }
        }
        if(this.currentHideArr.indexOf('WINDOW') !== -1) {
          this.hideAxisArr.push('WINDOW');
        }
        if(this.currentHideArr.indexOf('WWR') !== -1) {
          this.hideAxisArr.push('WWR');
        }
        if(this.currentHideArr.indexOf('SHADING') !== -1) {
          this.hideAxisArr.push('SHADING');
        }
        if(this.currentHideArr.indexOf('INFILTRATION') !== -1) {
          this.hideAxisArr.push('INFILTRATION');
        }
        if(this.currentHideArr.indexOf('DL') !== -1) {
          this.hideAxisArr.push('DL');
        }
        if(this.currentHideArr.indexOf('HVAC') !== -1) {
          this.hideAxisArr.push('HVAC');
        }
        if(this.currentHideArr.indexOf('HEAT') !== -1) {
          this.hideAxisArr.push('HEAT');
        }
        /*var blue_to_brown = d3.scale.linear()
        .domain([9, 50])
        .range(["steelblue", "brown"])
        .interpolate(d3.interpolateLab);

        var dim = [];
        dim[0] = 
            {
              orient: 'right',
              type: 'string',
              tickPadding: 0,
              innerTickSize: 8
            };*/
            var len = Math.floor(gridColumns.length/2);
            var bund = gridColumns[len];

        parcoords
          .data(data.projLists)
          .bundlingStrength(0.5) // set bundling strength
          .bundleDimension(bund)
          .smoothness(0.13)
          .color('steelblue')
         // .color(function(d) { return blue_to_brown(d['economy (mpg)']); }) 
          .height('400')
          .width(scrwid)
          .mode('queue')
          .hideAxis(this.hideAxisArr)
          .render()
          .brushMode('1D-axes'); // enable brushing

        document.getElementById('brushdiv').style.width = '89%';

        var insertLinebreaks = function (d) {
          var el = d3.select(this);

          if (typeof d === 'string' || d instanceof String) {
            var words = [];
            var chunkSize = 12;

            while (d) {
              if (d.length < chunkSize) {
                words.push(d);
                break;
              } else {
                words.push(d.substr(0, chunkSize));
                d = d.substr(chunkSize);
              }
            }
            el.text('');

            for (var i = 0; i < words.length; i++) {
              var tspan = el.append('tspan').text(words[i]);
              if (i > 0) tspan.attr('x', -10).attr('dy', '12');
            }
          }
        };

        d3.selectAll('g.axis g text').each(insertLinebreaks);
      }
      if (this.newChartMsg == 'Yes') {
        var grid = d3.divgrid();

        var gridColumns = [
          'OPTIONS',
   
        ];

       // if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WALL') == -1) {
        //    gridColumns.push('WALL');
       //   }
        if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('ROOF') == -1) {
            gridColumns.push('ROOF');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('FLOOR') == -1) {
            if(this.custName.length > 0) {
              gridColumns.push(this.custName);
            } else {
              gridColumns.push('FLOOR');
            }
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WINDOW') == -1) {
            gridColumns.push('WINDOW');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('WWR') == -1) {
            gridColumns.push('WWR');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('SHADING') == -1) {
            gridColumns.push('SHADING');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('INFILTRATION') == -1) {
            gridColumns.push('INFILTRATION');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('DL') == -1) {
            gridColumns.push('DL');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HVAC') == -1) {
            gridColumns.push('HVAC');
          }
          if(this.currentHideArr?.length == 0 || this.currentHideArr.indexOf('HEAT') == -1) {
            gridColumns.push('HEAT');
          }
   
        if (this.currentkpiFactors.length > 0) {
          if (this.currentkpiFactors.indexOf('eui') != -1) {
            gridColumns.push('EUI');
          }
          if (this.currentkpiFactors.indexOf('savings') != -1) {
            gridColumns.push('SAVINGS');
          }

          if (this.currentkpiFactors.indexOf('cp') != -1) {
            gridColumns.push('COSTPREMIUM');
          }
          if (this.currentkpiFactors.indexOf('ghg') != -1) {
            gridColumns.push('CO2RED');
          }
          if (this.currentkpiFactors.indexOf('op') != -1) {
            gridColumns.push('OPCOST');
          }
          if (this.currentkpiFactors.indexOf('pp') != -1) {
            gridColumns.push('PAYBACK');
          }
          if (this.currentkpiFactors.indexOf('tedi') != -1) {
            gridColumns.push('TEDI');
          }

        }
        
          var scrwid = window.innerWidth - (window.innerWidth/gridColumns.length-this.gridLen-1);
        
        document.getElementById('example').style.marginLeft = (window.innerWidth/gridColumns.length-1).toString()+"px";
        this.hideAxisArr = [
              'cID',
              'hvacID',
              'cylinders',
              'TotalCooling',
              'TotalDistrFanEnergy',
              'TotalDistrPumpE',
              'TotalHeatRejPumpE',
              'TotalHeating',
              'TotalLight',
              'COSTPREMIUM',
              'CO2RED',
              'OPCOST',
              'PAYBACK',
              'TEDI_COST',
              'CARBONE'
            ];
        if (this.currentkpiFactors.length > 0) {
          if (this.currentkpiFactors.indexOf('eui') == -1) {
                  this.hideAxisArr.push('EUI');
                }
          if (this.currentkpiFactors.indexOf('savings') == -1) {
                  this.hideAxisArr.push('SAVINGS');
                }
          if (this.currentkpiFactors.indexOf('tedi') == -1) {
                  this.hideAxisArr.push('TEDI');
                }
          }
       
          if(this.currentHideArr?.indexOf('WALL') !== -1) {
              this.hideAxisArr.push('WALL');
          }
          if(this.currentHideArr.indexOf('ROOF') !== -1) {
            this.hideAxisArr.push('ROOF');
          }
          if(this.currentHideArr.indexOf('FLOOR') !== -1) {
            if(this.custName.length > 0) {
              this.hideAxisArr.push(this.custName);
            } else {
              this.hideAxisArr.push('FLOOR');
            }
          }
          if(this.currentHideArr.indexOf('WINDOW') !== -1) {
            this.hideAxisArr.push('WINDOW');
          }
          if(this.currentHideArr.indexOf('WWR') !== -1) {
            this.hideAxisArr.push('WWR');
          }
          if(this.currentHideArr.indexOf('SHADING') !== -1) {
            this.hideAxisArr.push('SHADING');
          }
          if(this.currentHideArr.indexOf('INFILTRATION') !== -1) {
            this.hideAxisArr.push('INFILTRATION');
          }
          if(this.currentHideArr.indexOf('DL') !== -1) {
            this.hideAxisArr.push('DL');
          }
          if(this.currentHideArr.indexOf('HVAC') !== -1) {
            this.hideAxisArr.push('HVAC');
          }
          if(this.currentHideArr.indexOf('HEAT') !== -1) {
            this.hideAxisArr.push('HEAT');
          }
       /*   var blue_to_brown = d3.scale.linear()
          .domain([9, 50])
          .range(["steelblue", "brown"])
          .interpolate(d3.interpolateLab);

          var dim = [];
          dim[0] = 
              {
                orient: 'right',
                type: 'string',
                tickPadding: 0,
                innerTickSize: 8
              };*/
              var len = Math.floor(gridColumns.length/2);
              var bund = gridColumns[len];
              console.log(' bundle dimension '+bund);
        parcoords
          .data(data.projLists)
          .bundlingStrength(0.5) // set bundling strength
          //.dimensions(dim)
          .bundleDimension(bund)
          .smoothness(0.13)
          //.color(function(d) { return blue_to_brown(d['WALL']); }) 
          .color('steelblue')
          .height('400')
          .width(scrwid)
          .mode('queue')
          .hideAxis(this.hideAxisArr)
          .render()
          .brushMode('1D-axes'); // enable brushing

        document.getElementById('brushdiv').style.width = '80%';

        var insertLinebreaks = function (d) {
          var el = d3.select(this);

          if (typeof d === 'string' || d instanceof String) {
            var words = [];
            var chunkSize = 12;

            while (d) {
              if (d.length < chunkSize) {
                words.push(d);
                break;
              } else {
                words.push(d.substr(0, chunkSize));
                d = d.substr(chunkSize);
              }
            }
            el.text('');

            for (var i = 0; i < words.length; i++) {
              var tspan = el.append('tspan').text(words[i]);
              if (i > 0) tspan.attr('x', -10).attr('dy', '12');
            }
          }
        };

        d3.selectAll('g.axis g text').each(insertLinebreaks);
      }
      d3.select('#addSmooth').on('click', function () {
        parcoords.smoothness(0.13).render();
        parcoords.bundlingStrength(0.5).render();
      });

      d3.select('#remSmooth').on('click', function () {
        parcoords.smoothness(0).render();
        parcoords.bundlingStrength(0).render();
      });

      //  if condition if checkbox is checked
      if (this.newToggleEditable == 'true') {
        //Added by Divya - to display EUI and Savings for Custom baseline
        this.custBaseNew1 = data.display_values;

        var wall = this.custBaseNew1.wall;
        for (var i = 0; i < wall.length; i++) {
          if (wall[i].wall == this.newcustBase) {
            this.custBaseDispWall = wall[i].wall_r_value_ip;
          }
        }
        var roof = this.custBaseNew1.roof;
        for (var i = 0; i < roof.length; i++) {
          if (roof[i].roof == this.newcustBaseRoof) {
            this.custBaseDispRoof = roof[i].roof_r_value_ip;
          }
        }
        var floor = this.custBaseNew1.floor;
        for (var i = 0; i < floor.length; i++) {
          if (floor[i].floor == this.newcustBaseFloor) {
            this.custBaseDispFloor = floor[i].floor_r_value_ip;
          }
        }

        var win = this.custBaseNew1.windows;
        for (var i = 0; i < win.length; i++) {
          if (win[i].windows == this.newcustBaseWindow) {
            this.custBaseDispWin =
              win[i].win_r_value_ip.replace(/\s/g, "");;
          }
        }
        var light = this.custBaseNew1.light;
        for (var i = 0; i < light.length; i++) {
          if (light[i].infiltration == this.newcustBaseInf) {
            this.custBaseDispLight = light[i].infiltration_ref;
          }
        }
        
        var wwr = this.newcustBaseWwr;
        if (wwr.indexOf('%') > 0) {
          wwr = (wwr.replace('%', '') / 100).toFixed(3);
        }

        var dat = data.projLists.slice(0, 6);

        if (this.newEmail == 'anuprathi1@gmail.com') {
          this.condId = this.newEventId;
        } else {
          this.condId = this.newUserId;
        }

        this.msgurl1 =
          this.rootDomainUrl +
          'adeos/api/getCustomBaselineValues.php?user_id=' +
          this.condId +
          '&proj_id=' +
          this.newProjId +
          '&wall=' +
          this.newcustBase +
          '&roof=' +
          this.newcustBaseRoof +
          '&floor=' +
          this.newcustBaseFloor +
          '&window=' +
          this.newcustBaseWindow +
          '&shading=' +
          this.newcustBaseShading +
          '&infiltration=' +
          this.newcustBaseInf +
          '&wwr=' +
          wwr +
          '&dl=' +
          this.newcustDaylight +
          '&hvac=' +
          encodeURIComponent(this.newcustBaseHvac.toString()) +
          '&heatRec=' +
          this.newcustHtRec;

        this.http
          .get(this.msgurl1)
          .pipe(map((res) => res))
          .subscribe((data1) => {
            var eui = data1;
            this.customeui = eui;

            this.newcustumeui = this.customeui.eui;
            this.costpremium = this.customeui.costpremium;
            this.co2 = this.customeui.carbone;
            this.opCost1 = this.customeui.opcost;
            if((this.currentkpiFactors.length > 1 || this.currentkpiFactors.indexOf('tedi') < 0)
              && this.currentkpiFactors.indexOf('eui') >= 0)  {
            d3.selectAll('.mygrid')
              .select('.row')
              .select('.col-11')
              .text(this.newcustumeui);
           /* d3.selectAll('.mygrid')
              .select('.row')
              .select('.col-0')
              .text(this.cb);*/
            var nrt = d3
              .selectAll('.mygrid')
              .select('.row')
              .select('.col-7')
              .text();
            this.wwr = nrt;

            d3.selectAll('.mygrid')
              .select('.row')
              .select('.col-9')
              .text(this.newcustBaseHvac);
            
            }

            var lineCharts = d3.selectAll('.mygrid').selectAll('.row');
            for (var i = 0; i < dat.length; i++) {
              var euiO = dat[i]['EUI'];
              var co2red = dat[i]['CARBONE'];

              var s =
                Math.floor((1 - euiO / this.newcustumeui) * 100 * 100) / 100;

              var costO = dat[i]['COSTPREMIUM'];

              var opCost = dat[i]['OPCOST'];
              
              var cost1 =  Math.floor((costO - this.costpremium) * 100) / 100;

              var co =
                Math.floor((1 - co2red / this.co2) * 100);

              var op =  Math.floor((opCost - this.opCost1) * 100) / 100;

              var payBack = 0;

              if(cost1 > 0 && op <= 0)
                payBack = 100;
              else if(cost1 < 0 && op >= 0)
                payBack = 0;
              else if(cost1/op > 100 && op > 0 && cost1 > 0) 
                payBack = 100;
              else if(cost1 > 0 && op > 0)
                payBack =parseFloat ((cost1/op).toFixed(2));
              else if(cost1 < 0 && op < 0)
                payBack = 0;
              else 
                payBack = 0;
             
              var chart = d3.select(lineCharts[0][i + 1]);
             
              var mySpans = document.getElementsByClassName("cell");
              for(var j=0;j<mySpans.length;j++){
                if(mySpans[j].innerHTML.indexOf('%SAVINGS') > -1){
                  var sav = mySpans[j].className;
                }
                  if(mySpans[j].innerHTML.indexOf('C.P') > -1){
                    var parent = mySpans[j].className;
                  }
                  if(mySpans[j].innerHTML.indexOf('CO2RED') > -1){
                    var co2div = mySpans[j].className;
               
                  }
                  if(mySpans[j].innerHTML.indexOf('O.C.S') > -1){
                    var ocsdiv = mySpans[j].className;
                    
                  }
                  if(mySpans[j].innerHTML.indexOf('PAYBACK') > -1){
                    var pbdiv = mySpans[j].className;
                    break;
                  }
              }
                
              if (this.currentkpiFactors.indexOf('savings') != -1) {
                const savingsValue = dat[i]?.SAVINGS ?? s;
                chart.select('.' + sav.split(' ')[0]).text(savingsValue);
              }
              if (this.currentkpiFactors.indexOf('cp') != -1) {
                chart.select('.'+parent.split(" ")[0]).text(cost1);
              }
              if (this.currentkpiFactors.indexOf('ghg') != -1) {
                chart.select('.'+co2div.split(" ")[0]).text(co);
              }
              if (this.currentkpiFactors.indexOf('op') != -1) {
                chart.select('.'+ocsdiv.split(" ")[0]).text(op);
              }
              if (this.currentkpiFactors.indexOf('pp') != -1) {
                chart.select('.'+pbdiv.split(" ")[0]).text(payBack);
              }

            } 
            grid.columns(gridColumns);
          });

       

        var tableData : any;
        if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0) {
        tableData = [
          {
            OPTIONS: this.cb,
            Letter: 'NECB',
            WALL: this.custBaseDispWall,
            ROOF: this.custBaseDispRoof,
            FLOOR: this.custBaseDispFloor,
            WINDOW: this.custBaseDispWin,
            SHADING: this.newcustBaseShading,
            INFILTRATION: this.custBaseDispLight,
            WWR: this.newcustBaseWwr,
            DL: this.newcustDaylight,
            HVAC: this.newcustBaseHvac,
            HEAT: this.newcustHtRec,
            EUI: this.newcustumeui,
          },
        ];

        if (this.currentkpiFactors.length > 0) {
          if (this.currentkpiFactors.indexOf('eui') != -1) {
                  tableData[0]['EUI'] = '';
                }
          if (this.currentkpiFactors.indexOf('savings') != -1) {
                  tableData[0]['SAVINGS'] = '';
          }

          if (this.currentkpiFactors.indexOf('cp') != -1) {
            tableData[0]['COSTPREMIUM($)'] = '';
          }
          if (this.currentkpiFactors.indexOf('ghg') != -1) {
            tableData[0]['CO2RED'] = '';
          }
          if (this.currentkpiFactors.indexOf('op') != -1) {
            tableData[0]['OPCOST'] = '';
          }
          if (this.currentkpiFactors.indexOf('pp') != -1) {
            tableData[0]['PAYBACK'] = '';
          }
          if (this.currentkpiFactors.indexOf('tedi') != -1) {
                  tableData[0]['TEDI'] = '';
                }
          if (this.currentkpiFactors.indexOf('tc') != -1) {
                  tableData[0]['TEDI_COST'] = '';
          }
        }
      }

      if(tableData == undefined) {
        tableData = [];
      }
        for (var i = 0; i < dat.length; i++) {
          dat[i]['OPTIONS'] = 'Option' + (i + 1);
         // dat[i]['DL SEN'] = dat[i]['DL'];
          dat[i]['HVAC SYS'] = dat[i]['HVAC'];
          dat[i]['HEAT_REC'] = dat[i]['HEAT'];
          dat[i]['EUI kWh/m2/yr'] = dat[i]['EUI'];
          dat[i]['TEDI'] = dat[i]['TEDI'];
          dat[i]['TEDI COST kWh/m2/yr'] = dat[i]['TEDI_COST'];
          dat[i]['SAVINGS %'] = dat[i]['SAVINGS'];
          dat[i]['PAYBACK (yrs)'] = dat[i]['PAYBACK'];
          dat[i]['COSTPREMIUM ($)'] = dat[i]['COSTPREMIUM'];
          dat[i]['CO2RED %'] = dat[i]['CO2RED'];
          dat[i]["OPCOST (1000's$)"] = dat[i]['OPCOST'];
          dat[i]['PAYBACK (yrs)'] = dat[i]['PAYBACK'];
          if(this.currentHideArr?.length >= 1) {
            tableData[0]["WALL"] = " ";
            tableData[0]["ROOF"] = " ";
            tableData[0]["FLOOR"] = " ";
            tableData[0]["WINDOW"] = " ";
            tableData[0]["DL"] = " ";
            tableData[0]["WWR"] = " ";
            tableData[0]["SHADING"] = " ";
            tableData[0]["INFILTRATION"] = " ";
            tableData[0]["HVAC"] = " ";
            tableData[0]["HEAT"] = " ";
          }     
          tableData.push(dat[i]);
        }
      } // end if condition if checkbox is checked

      // ashrae

      if (this.newAshNecb == 'Ashare' || this.newAshNecb == ' ') {
        var grid = d3.divgrid();
         grid.columns(["OPTIONS","WALL", "ROOF","FLOOR","WINDOW","SHADING","LIGHTING","WWR","DL", "TotalHeating", "TotalCooling", "TotalLighting"]);
        if (this.newChartMsg == 'Yes') {
         var gridColumns = [
            'OPTIONS',
            //'WALL',
          //  'ROOF',
          //  'FLOOR',
          //  'WINDOW'
          ];
         // if (this.currentHideArr?.length > 0) {
            if(this.currentHideArr.indexOf('WALL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WALL');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('ROOF') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('ROOF');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('FLOOR') == -1 || this.currentHideArr?.length == 0) {
              if(this.custName.length > 0) {
                gridColumns.push(this.custName);
              } else {
                gridColumns.push('FLOOR');
              }
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('WINDOW') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WINDOW');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('SHADING') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('SHADING');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('INFILTRATION') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('INFILTRATION');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('WWR') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WWR');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            } 
            if(this.currentHideArr.indexOf('DL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('DL');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('HVAC') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HVAC');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('HEAT') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HEAT');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
         // }
          
          if (this.currentkpiFactors.length > 0) {
            if (this.currentkpiFactors.indexOf('eui') != -1) {
              gridColumns.push('EUI');
            }
          if (this.currentkpiFactors.indexOf('savings') != -1) {
                  gridColumns.push('SAVINGS');
                }
          if (this.currentkpiFactors.indexOf('tedi') != -1) {
              gridColumns.push('TEDI');
            }
          }

           grid.columns(gridColumns);

        }
        if (this.newChartMsg == 'No') {
          var gridColumns = [
            'OPTIONS'	
          ];
         // if (this.currentHideArr?.length > 0) {
            if(this.currentHideArr.indexOf('WALL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WALL');
            }
            if(this.currentHideArr.indexOf('ROOF') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('ROOF');
            }
            if(this.currentHideArr.indexOf('FLOOR') == -1 || this.currentHideArr?.length == 0) {
              if(this.custName.length > 0) {
                gridColumns.push(this.custName);
              } else {
                gridColumns.push('FLOOR');
              }
            }
            if(this.currentHideArr.indexOf('WINDOW') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WINDOW');
            }
            if(this.currentHideArr.indexOf('SHADING') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('SHADING');
            }
            if(this.currentHideArr.indexOf('INFILTRATION') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('INFILTRATION');
            }
            if(this.currentHideArr.indexOf('WWR') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WWR');
            }
            if(this.currentHideArr.indexOf('DL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('DL');
            }
            if(this.currentHideArr.indexOf('HVAC') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HVAC');
            }
            if(this.currentHideArr.indexOf('HEAT') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HEAT');
            }
          if (this.currentkpiFactors.length > 0) {
      if (this.currentkpiFactors.indexOf('eui') != -1) {
              gridColumns.push('EUI');
            }
      if (this.currentkpiFactors.indexOf('savings') != -1) {
              gridColumns.push('SAVINGS');
            }

            if (this.currentkpiFactors.indexOf('cp') != -1) {
              gridColumns.push('COSTPREMIUM');
            }
            if (this.currentkpiFactors.indexOf('ghg') != -1) {
              gridColumns.push('CO2RED');
            }
            if (this.currentkpiFactors.indexOf('op') != -1) {
              gridColumns.push('OPCOST');
            }
            if (this.currentkpiFactors.indexOf('pp') != -1) {
              gridColumns.push('PAYBACK');
            }
      if (this.currentkpiFactors.indexOf('tedi') != -1) {
              gridColumns.push('TEDI');
            }
      if (this.currentkpiFactors.indexOf('tc') != -1) {
              gridColumns.push('TEDI_COST');

          }

          grid.columns(gridColumns);
        }
    }
      var tableData : any;
            /*    OPTIONS: this.ashrae,
            Letter: this.ashrae,
            WALL: this.wal,
            ROOF: this.rvi,
            FLOOR: this.fvi,
            WINDOW: this.wvi,
            SHADING: this.shd,
            INFILTRATION: this.lit,
            WWR: this.wwr,
            DL: this.dls,
            HVAC: this.hva,
            HEAT: this.hre,
            EUI: this.eui,*/
        
      
      if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0) {
            tableData =  
              [{
                OPTIONS: this.ashrae,
                  Letter: this.ashrae,
                  WALL: this.wal,
                  ROOF: this.rvi,
                  FLOOR: this.fvi,
                  WINDOW: this.wvi,
                  SHADING: this.shd,
                  INFILTRATION: this.lit,
                  WWR: this.wwr,
                  DL: this.dls,
                  HVAC: this.hva,
                  HEAT: this.hre,
                  EUI: this.eui,
              }]
              ;
            


        if (this.currentkpiFactors.length > 0) {
        if (this.currentkpiFactors.indexOf('eui') != -1) {
            tableData[0]['EUI kWh/m2/yr'] = '';
          }
        if (this.currentkpiFactors.indexOf('savings') != -1) {
            tableData[0]['SAVINGS %'] = '';
          }

          if (this.currentkpiFactors.indexOf('cp') != -1) {
            tableData[0]['COSTPREMIUM($)'] = '';
          }
          if (this.currentkpiFactors.indexOf('ghg') != -1) {
            tableData[0]['CO2RED'] = '';
          }
          if (this.currentkpiFactors.indexOf('op') != -1) {
            tableData[0]['OPCOST'] = '';
          }
          if (this.currentkpiFactors.indexOf('pp') != -1) {
            tableData[0]['PAYBACK'] = '';
          }
          if (this.currentkpiFactors.indexOf('tedi') != -1) {
                  tableData[0]['TEDI'] = '';
                }
          if (this.currentkpiFactors.indexOf('tc') != -1) {
                  tableData[0]['TEDI_COST'] = '';
          }
              }
          }

        var dat = data.projLists.slice(0, 6);
        /*var dat = data.projLists.slice(0, 6).reduce((accumulator, current) => {
          if (!accumulator.find((item) => item.EUI === current.EUI)) {
            accumulator.push(current);
          }
          return accumulator;
        }, []);*/
        
        if(tableData == undefined) {
          tableData = [];
        }
        //When wwr category is hidden, means that results for all wwr's are same, so any one can be chosen
        if(this.currentHideArr.indexOf("WWR") > -1) {
          this.wwrSelected = dat[0].WWR;
        }
        this.authService.combIdSelMessage(dat[0]["cID"]);
        // var i;
        for (var i = 0; i < dat.length; i++) {
          dat[i]['OPTIONS'] = 'Option' + (i + 1);
        //  dat[i]['DL SEN'] = dat[i]['DL'];
        
          dat[i]['HVAC SYS'] = dat[i]['HVAC'];
          dat[i]['HEAT_REC'] = dat[i]['HEAT'];
          dat[i]['EUI kWh/m2/yr'] = dat[i]['EUI'];
          dat[i]['SAVINGS %'] = dat[i]['SAVINGS'];
          dat[i]['COSTPREMIUM ($)'] = dat[i]['COSTPREMIUM'];
          dat[i]['CO2RED %'] = dat[i]['CO2RED'];
          dat[i]["OPCOST (1000's$)"] = dat[i]['OPCOST'];
          dat[i]['PAYBACK (yrs)'] = dat[i]['PAYBACK'];
          dat[i]['TEDI'] = dat[i]['TEDI'];
          dat[i]["TEDI COST (1000's$)"] = dat[i]['TEDI_COST'];
          dat[i]["COMBID"] = dat[i]['cID'];

          if(this.currentHideArr?.indexOf('WALL') !== -1) {
            dat[i]["WALL"] = " ";
          }            
          if(this.currentHideArr?.indexOf('ROOF') !== -1) {

            dat[i]["ROOF"] = " ";

          } 
          if(this.currentHideArr?.indexOf('FLOOR') !== -1) {

            dat[i]["FLOOR"] = " ";

          } 
          if(this.currentHideArr?.indexOf('WINDOW') !== -1) {

            dat[i]["WINDOW"] = " ";

          } 
          if(this.currentHideArr?.indexOf('DL') !== -1) {

            dat[i]["DL"] = " ";

          } 
          if(this.currentHideArr?.indexOf('SHADING') !== -1) {

            dat[i]["SHADING"] = " ";

          } 
          if(this.currentHideArr?.indexOf('WWR') !== -1) {

            dat[i]["WWR"] = " ";

          } 
          if(this.currentHideArr?.indexOf('INFILTRATION') !== -1) {

            dat[i]["INFILTRATION"] = " ";

          } 
          if(this.currentHideArr?.indexOf('HVAC') !== -1) {

            dat[i]["HVAC"] = " ";

          } 
          if(this.currentHideArr?.indexOf('HEAT') !== -1) {

            dat[i]["HEAT"] = " ";

          } 
          tableData.push(dat[i]);
          if (dat[i].FLOOR == 'R8') {
            this.initfloor = 'F1';
          }
          if (dat[i].FLOOR == 'R10') {
            this.initfloor = 'F2';
          }
          if (dat[i].FLOOR == 'R20') {
            this.initfloor = 'F3';
          }

          //  roof
          if (dat[i].ROOF == 'R15') {
            this.initROOF = 'R1';
          }
          if (dat[i].ROOF == 'R21') {
            this.initROOF = 'R2';
          }
          if (dat[i].ROOF == 'R35') {
            this.initROOF = 'R3';
          }
          if (dat[i].ROOF == 'R50') {
            this.initROOF = 'R4';
          }
          if (dat[i].ROOF == 'R75') {
            this.initROOF = 'R5';
          }

          //  window
          if (dat[i].WINDOW == 'R1.8  SHGC1') {
            this.initWINDOW = 'WIN01';
          }
          if (dat[i].WINDOW == 'R1.8 SHGC2') {
            this.initWINDOW = 'WIN02';
          }
          if (dat[i].WINDOW == 'R1.8 SHGC3') {
            this.initWINDOW = 'WIN03';
          }
          if (dat[i].WINDOW == 'R1.8 SHGC4') {
            this.initWINDOW = 'WIN04';
          }
          if (dat[i].WINDOW == 'R2.6 SHGC6') {
            this.initWINDOW = 'WIN06';
          }
          if (dat[i].WINDOW == 'R2.6 SHGC7') {
            this.initWINDOW = 'WIN07';
          }
          if (dat[i].WINDOW == 'R2.6 SHGC8') {
            this.initWINDOW = 'WIN08';
          }
          if (dat[i].WINDOW == 'R6.8 SHGC9') {
            this.initWINDOW = 'WIN09';
          }
          if (dat[i].WINDOW == 'R6.8 SHGC10') {
            this.initWINDOW = 'WIN10';
          }
          if (dat[i].WINDOW == 'R6.8 SHGC11') {
            this.initWINDOW = 'WIN011';
          }
          if (dat[i].WINDOW == 'R6.8 SHGC12') {
            this.initWINDOW = 'WIN012';
          }

          // wall
          if (dat[i].WALL == 'R13') {
            this.initWALL = 'W1';
          }
          if (dat[i].WALL == 'R20') {
            this.initWALL = 'W2';
          }
          if (dat[i].WALL == 'R27') {
            this.initWALL = 'W3';
          }
          if (dat[i].WALL == 'R30') {
            this.initWALL = 'W4';
          }
          if (dat[i].WALL == 'R40') {
            this.initWALL = 'W5';
          }
          if (dat[i].WALL == 'R50') {
            this.initWALL = 'W6';
          }
          if (dat[i].WALL == 'R60') {
            this.initWALL = 'W7';
          }
        }
        //this.diffChart();
      }

      // ashrae end

      // Necb start
      if (this.newAshNecb == 'Necb') {
        var grid = d3.divgrid();

        //Added by Divya
        if (this.newChartMsg == 'Yes') {
          var gridColumns = [
            'OPTIONS'	
          ];
         // if (this.currentHideArr?.length > 0) {
            if(this.currentHideArr.indexOf('WALL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WALL');
            } else {
              gridColumns.push(' ');
              this.gridLen++;
            }
            if(this.currentHideArr.indexOf('ROOF') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('ROOF');
            }
            if(this.currentHideArr.indexOf('FLOOR') == -1 || this.currentHideArr?.length == 0) {
              if(this.custName.length > 0) {
                gridColumns.push(this.custName);
              } else {
                gridColumns.push('FLOOR');
              }
            }
            if(this.currentHideArr.indexOf('WINDOW') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WINDOW');
            }
            if(this.currentHideArr.indexOf('SHADING') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('SHADING');
            }
            if(this.currentHideArr.indexOf('INFILTRATION') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('INFILTRATION');
            }
            if(this.currentHideArr.indexOf('WWR') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WWR');
            }
            if(this.currentHideArr.indexOf('DL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('DL');
            }
            if(this.currentHideArr.indexOf('HVAC') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HVAC');
            }
         // }
         if(this.currentHideArr.indexOf('HEAT') == -1 || this.currentHideArr?.length == 0) {
          gridColumns.push('HEAT');
        }
          if (this.currentkpiFactors.length > 0) {
      if (this.currentkpiFactors.indexOf('eui') != -1) {
              gridColumns.push('EUI');
            }
      if (this.currentkpiFactors.indexOf('savings') != -1) {
              gridColumns.push('SAVINGS');
            }
      if (this.currentkpiFactors.indexOf('tedi') != -1) {
              gridColumns.push('TEDI');
            }
          }

           grid.columns(gridColumns);
        }
        if (this.newChartMsg == 'No') {
          var gridColumns = [
            'OPTIONS'	
          ];
         // if (this.currentHideArr?.length > 0) {
            if(this.currentHideArr.indexOf('WALL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WALL');
            }
            if(this.currentHideArr.indexOf('ROOF') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('ROOF');
            }
            if(this.currentHideArr.indexOf('FLOOR') == -1 || this.currentHideArr?.length == 0) {
              if(this.custName.length > 0) {
                gridColumns.push(this.custName);
              } else {
                gridColumns.push('FLOOR');
              }
            }
            if(this.currentHideArr.indexOf('WINDOW') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WINDOW');
            }
            if(this.currentHideArr.indexOf('SHADING') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('SHADING');
            }
            if(this.currentHideArr.indexOf('INFILTRATION') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('INFILTRATION');
            }
            if(this.currentHideArr.indexOf('WWR') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WWR');
            }
            if(this.currentHideArr.indexOf('DL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('DL');
            }
            if(this.currentHideArr.indexOf('HVAC') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HVAC');
            }
            if(this.currentHideArr.indexOf('HEAT') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HEAT');
            }
          if (this.currentkpiFactors.length > 0) {
            if (this.currentkpiFactors.indexOf('eui') != -1) {
                    gridColumns.push('EUI');
                  }
            if (this.currentkpiFactors.indexOf('savings') != -1) {
                    gridColumns.push('SAVINGS');
                  }
            if (this.currentkpiFactors.indexOf('tedi') != -1) {
                    gridColumns.push('TEDI');
            }

            if (this.currentkpiFactors.indexOf('cp') != -1) {
              gridColumns.push('COSTPREMIUM');
            }
            if (this.currentkpiFactors.indexOf('ghg') != -1) {
              gridColumns.push('CO2RED');
            }
            if (this.currentkpiFactors.indexOf('op') != -1) {
              gridColumns.push('OPCOST');
            }
            if (this.currentkpiFactors.indexOf('pp') != -1) {
              gridColumns.push('PAYBACK');
            }
      if (this.currentkpiFactors.indexOf('tc') != -1) {
              gridColumns.push('TEDI_COST');
            }
          }
          grid.columns(gridColumns);
        }

        var tableData : any;
        if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0) {
          tableData = [
          {
            OPTIONS: this.necb,
            Letter: this.necb,
            WALL: this.wal,
            ROOF: this.rvi,
            FLOOR: this.fvi,
            WINDOW: this.wvi,
            SHADING: this.shd,
            INFILTRATION: this.lit,
            WWR: this.wwr,
            DL: this.dls,
            HVAC: this.hva,
            HEAT: this.hre,
            EUI: this.eui,
          },
        ];
        if (this.currentkpiFactors.length > 0) {
    if (this.currentkpiFactors.indexOf('eui') != -1) {
            tableData[0]['EUI'] = '';
          }
    if (this.currentkpiFactors.indexOf('savings') != -1) {
            tableData[0]['SAVINGS'] = '';
          }
    if (this.currentkpiFactors.indexOf('tedi') != -1) {
            tableData[0]['TEDI'] = '';
          }
    if (this.currentkpiFactors.indexOf('tc') != -1) {
            tableData[0]['TEDI_COST'] = '';
    }
          if (this.currentkpiFactors.indexOf('cp') != -1) {
            tableData[0]['COSTPREMIUM($)'] = '';
          }
          if (this.currentkpiFactors.indexOf('ghg') != -1) {
            tableData[0]['CO2RED'] = '';
          }
          if (this.currentkpiFactors.indexOf('op') != -1) {
            tableData[0]['OPCOST'] = '';
          }
          if (this.currentkpiFactors.indexOf('pp') != -1) {
            tableData[0]['PAYBACK'] = '';
          }
        }
      }
        var dat = data.projLists.slice(0, 6);
        if(this.currentHideArr.indexOf("WWR") > -1) {
          this.wwrSelected = dat[0].WWR;
        }

        if(tableData == undefined) {
          tableData = [];
        }
        this.authService.combIdSelMessage(dat[0]["cID"]);
        // var i;
        for (var i = 0; i < dat.length; i++) {
          dat[i]['OPTIONS'] = 'Option' + (i + 1);
        //  dat[i]['DL SEN'] = dat[i]['DL'];
          dat[i]['HVAC SYS'] = dat[i]['HVAC'];
          dat[i]['HEAT_REC'] = dat[i]['HEAT'];
          dat[i]['EUI kWh/m2/yr'] = dat[i]['EUI'];
          dat[i]['SAVINGS %'] = dat[i]['SAVINGS'];
          dat[i]['TEDI'] = dat[i]['TEDI'];
          dat[i]["TEDI COST (1000's$)"] = dat[i]['TEDI_COST'];
          dat[i]['COSTPREMIUM ($)'] = dat[i]['COSTPREMIUM'];
          dat[i]['CO2RED %'] = dat[i]['CO2RED'];
          dat[i]["OPCOST (1000's$)"] = dat[i]['OPCOST'];
          dat[i]['PAYBACK (yrs)'] = dat[i]['PAYBACK'];
          dat[i]["COMBID"] = dat[i]['cID'];

          if(this.currentHideArr?.indexOf('WALL') !== -1) {
            dat[i]["WALL"] = " ";
          }            
          if(this.currentHideArr?.indexOf('ROOF') !== -1) {

            dat[i]["ROOF"] = " ";

          } 
          if(this.currentHideArr?.indexOf('FLOOR') !== -1) {

            dat[i]["FLOOR"] = " ";

          } 
          if(this.currentHideArr?.indexOf('WINDOW') !== -1) {

            dat[i]["WINDOW"] = " ";

          } 
          if(this.currentHideArr?.indexOf('DL') !== -1) {

            dat[i]["DL"] = " ";

          } 
          if(this.currentHideArr?.indexOf('SHADING') !== -1) {

            dat[i]["SHADING"] = " ";

          } 
          if(this.currentHideArr?.indexOf('WWR') !== -1) {

            dat[i]["WWR"] = " ";

          } 
          if(this.currentHideArr?.indexOf('INFILTRATION') !== -1) {

            dat[i]["INFILTRATION"] = " ";

          } 
          if(this.currentHideArr?.indexOf('HVAC') !== -1) {

            dat[i]["HVAC"] = " ";

          } 
          if(this.currentHideArr?.indexOf('HEAT') !== -1) {

            dat[i]["HEAT"] = " ";

          } 
          tableData.push(dat[i]);
          if (this.newEmail == 'demo@ecomatrix.io') {
  console.log('DEMO DAT = ', dat);
  console.log('DEMO dat[0].EUI = ', dat[0]?.EUI);
}
        }
      }

      // Necb end

      // baseline start

      if (this.newAshNecb == 'noash') {
        var grid = d3.divgrid();

        if (this.newChartMsg == 'Yes') {
          var gridColumns = [
            'OPTIONS'	
          ];
         // if (this.currentHideArr?.length > 0) {
            if(this.currentHideArr.indexOf('WALL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WALL');
            }
            if(this.currentHideArr.indexOf('ROOF') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('ROOF');
            }
            if(this.currentHideArr.indexOf('FLOOR') == -1 || this.currentHideArr?.length == 0) {
              if(this.custName.length > 0) {
                gridColumns.push(this.custName);
              } else {
                gridColumns.push('FLOOR');
              }
            }
            if(this.currentHideArr.indexOf('WINDOW') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WINDOW');
            }
            if(this.currentHideArr.indexOf('SHADING') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('SHADING');
            }
            if(this.currentHideArr.indexOf('INFILTRATION') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('INFILTRATION');
            }
            if(this.currentHideArr.indexOf('WWR') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WWR');
            }
            if(this.currentHideArr.indexOf('DL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('DL');
            }
            if(this.currentHideArr.indexOf('HVAC') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HVAC');
            }
         // }
         if(this.currentHideArr.indexOf('HEAT') == -1 || this.currentHideArr?.length == 0) {
          gridColumns.push('HEAT');
        }
          if (this.currentkpiFactors.length > 0) {
         if (this.currentkpiFactors.indexOf('eui') != -1) {
              gridColumns.push('EUI');
            }
      if (this.currentkpiFactors.indexOf('savings') != -1) {
              gridColumns.push('SAVINGS');
            }
      if (this.currentkpiFactors.indexOf('tedi') != -1) {
              gridColumns.push('TEDI');
            }
          }
          if (this.newEmail == 'demo@ecomatrix.io') {
  console.log('DEMO EUI DEBUG');
  console.log('currentkpiFactors = ', this.currentkpiFactors);
  console.log('gridColumns = ', gridColumns);
  console.log('tableData[0] = ', tableData[0]);
  console.log('tableData[0].EUI = ', tableData[0]?.EUI);
  console.log('newcustumeui = ', this.newcustumeui);
}
          grid.columns(gridColumns);
        }
        if (this.newChartMsg == 'No') {
          var gridColumns = [
            'OPTIONS'	
          ];
         // if (this.currentHideArr?.length > 0) {
            if(this.currentHideArr.indexOf('WALL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WALL');
            }
            if(this.currentHideArr.indexOf('ROOF') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('ROOF');
            }
            if(this.currentHideArr.indexOf('FLOOR') == -1 || this.currentHideArr?.length == 0) {
              if(this.custName.length > 0) {
                gridColumns.push(this.custName);
              } else {
                gridColumns.push('FLOOR');
              }
            }
            if(this.currentHideArr.indexOf('WINDOW') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WINDOW');
            }
            if(this.currentHideArr.indexOf('SHADING') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('SHADING');
            }
            if(this.currentHideArr.indexOf('INFILTRATION') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('INFILTRATION');
            }
            if(this.currentHideArr.indexOf('WWR') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('WWR');
            }
            if(this.currentHideArr.indexOf('DL') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('DL');
            }
            if(this.currentHideArr.indexOf('HVAC') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HVAC');
            }
            if(this.currentHideArr.indexOf('HEAT') == -1 || this.currentHideArr?.length == 0) {
              gridColumns.push('HEAT');
            }
          if (this.currentkpiFactors.length > 0) {
         if (this.currentkpiFactors.indexOf('eui') != -1) {
              gridColumns.push('EUI');
            }
      if (this.currentkpiFactors.indexOf('savings') != -1) {
              gridColumns.push('SAVINGS');
            }
      if (this.currentkpiFactors.indexOf('tedi') != -1) {
              gridColumns.push('TEDI');
            }

            if (this.currentkpiFactors.indexOf('cp') != -1) {
              gridColumns.push('COSTPREMIUM');
            }
            if (this.currentkpiFactors.indexOf('ghg') != -1) {
              gridColumns.push('CO2RED');
            }
            if (this.currentkpiFactors.indexOf('op') != -1) {
              gridColumns.push('OPCOST');
            }
            if (this.currentkpiFactors.indexOf('pp') != -1) {
              gridColumns.push('PAYBACK');
            }
      if (this.currentkpiFactors.indexOf('tc') != -1) {
              gridColumns.push('TEDI_COST');
            }
          }
          grid.columns(gridColumns);
        }
        
        var tableData : any = [];
        if(this.currentkpiFactors.length !== 1 || this.currentkpiFactors.indexOf('tedi') < 0) {
          tableData.push(
          {
            OPTIONS: this.cb,
            Letter: this.cb,
            WALL: this.custBaseDispWall,
            ROOF: this.custBaseDispRoof,
            FLOOR: this.custBaseDispFloor,
            WINDOW: this.custBaseDispWin,
            SHADING: this.newcustBaseShading,
            INFILTRATION: this.custBaseDispLight,
            WWR: this.newcustBaseWwr,
            DL: this.newcustDaylight,
            COSTPREMIUM: this.costPrem,
          }
        );
        if (this.currentkpiFactors.length > 0) {
          if (this.currentkpiFactors.indexOf('eui') != -1) {
                  tableData[0]['EUI'] = '';
                }
          if (this.currentkpiFactors.indexOf('savings') != -1) {
                  tableData[0]['SAVINGS'] = '';
                }
          if (this.currentkpiFactors.indexOf('tedi') != -1) {
                  tableData[0]['TEDI'] = '';
                }
          if (this.currentkpiFactors.indexOf('tc') != -1) {
            tableData[0]['TEDI_COST'] = '';
          }
          if (this.currentkpiFactors.indexOf('cp') != -1) {
            tableData[0]['COSTPREMIUM($)'] = '';
          }
          if (this.currentkpiFactors.indexOf('ghg') != -1) {
            tableData[0]['CO2RED'] = '';
          }
          if (this.currentkpiFactors.indexOf('op') != -1) {
            tableData[0]['OPCOST'] = '';
          }
          if (this.currentkpiFactors.indexOf('pp') != -1) {
            tableData[0]['PAYBACK'] = '';
          }
        }
      }
        var dat = data.projLists.slice(0, 6);
        if(this.currentHideArr.indexOf("WWR") > -1) {
          this.wwrSelected = dat[0].WWR;
        }
        if(tableData == undefined) {
          tableData = [];
        }
        this.authService.combIdSelMessage(dat[0]["cID"]);
        // var i;
        for (var i = 0; i < dat.length; i++) {
          dat[i]['OPTIONS'] = 'Option' + (i + 1);
          //dat[i]['DL SEN'] = dat[i]['DL'];
          dat[i]['HVAC SYS'] = dat[i]['HVAC'];
          dat[i]['HEAT_REC'] = dat[i]['HEAT'];
          dat[i]['EUI kWh/m2/yr'] = dat[i]['EUI'];
          dat[i]['TEDI'] = dat[i]['TEDI'];
          dat[i]['TEDI COST kWh/m2/yr'] = dat[i]['TEDI_COST'];
          dat[i]['SAVINGS %'] = dat[i]['SAVINGS'];
          dat[i]['COSTPREMIUM ($)'] = dat[i]['COSTPREMIUM'];
          dat[i]['CO2RED %'] = dat[i]['CO2RED'];
          dat[i]["OPCOST (1000's$)"] = dat[i]['OPCOST'];
          dat[i]['PAYBACK (yrs)'] = dat[i]['PAYBACK'];
          dat[i]["COMBID"] = dat[i]['cID'];

          if(this.currentHideArr?.length >= 1) {
            tableData[0]["WALL"] = " ";
            tableData[0]["ROOF"] = " ";
            tableData[0]["FLOOR"] = " ";
            tableData[0]["WINDOW"] = " ";
            tableData[0]["DL"] = " ";
            tableData[0]["WWR"] = " ";
            tableData[0]["SHADING"] = " ";
            tableData[0]["INFILTRATION"] = " ";
            tableData[0]["HVAC"] = " ";
            tableData[0]["HEAT"] = " ";
          }            
          tableData.push(dat[i]);
        }
      }
      // baseline end

      function getEventTarget(e) {
        e = e || window.event;
        return e.target || e.srcElement;
      }

      document.querySelector('#grid').addEventListener('click', (event) => {
       
        if (this.newEmail != 'demo@ecomatrix.io') {
          setTimeout(
            () =>
              ((<HTMLInputElement>document.getElementById('dwdpdf')).disabled =
                false),
            10000
          );
        }
        if (this.newEmail == 'demo@ecomatrix.io') {
          setTimeout(
            () =>
              ((<HTMLInputElement>document.getElementById('dwdpdf')).disabled =
                false),
            10000
          );
        }

        var target = getEventTarget(event);

        var cells = target.parentElement.querySelectorAll('.cell');

        var par = target.parentElement;
        
        if (
          target.parentElement.querySelector('.col-0').innerHTML != 'ASHRAE' &&
          target.parentElement.querySelector('.col-0').innerHTML != 'NECB' &&
          target.parentElement.querySelector('.col-0').innerHTML !=
            'Custom Baseline'
        ) {
          
          document.getElementById('upval').style.display = 'none';
          this.cellopt = cells[0].innerHTML;
        /*  this.cellone = '"' + cells[1].innerHTML + '"';
          this.celltwo = '"' + cells[2].innerHTML + '"';
          this.cellthree = '"' + cells[3].innerHTML + '"';
          this.cellfour = '"' + cells[4].innerHTML + '"';
          this.cellfive = '"' + cells[5].innerHTML + '"';
          this.cellsix = '"' + cells[6].innerHTML + '"';
          this.cellseven = '"' + cells[7].innerHTML + '"'; // wwr
          this.celleight = '"' + cells[8].innerHTML + '"'; // DL
          this.cellnine = '"' + cells[9].innerText + '"'; // hvac
          this.cellten = '"' + cells[10].innerHTML + '"';
          this.celltenNew = '"' + cells[10].innerHTML + '"';*/
          var data : any;
          if(par.__data__.length > 1) {
            data = par.__data__[0];
          } else {
            data = par.__data__;
          }
          this.cellone = data?.WALL;
          this.celltwo = '"' + data.ROOF + '"';
          this.cellthree = '"' + data.FLOOR + '"';
          this.cellfour = '"' + data.WINDOW + '"';
          this.cellfive = '"' + data.SHADING + '"';
          this.cellsix = '"' + data.INFILTRATION + '"';
          this.cellseven = '"' + data.WWR + '"'; // wwr
          this.celleight = '"' + data.DL + '"'; // DL
          this.cellnine = '"' + data.HVAC + '"'; // hvac
          this.cellten = '"' + data.HEAT_REC + '"';
          this.celltenNew = '"' + data.HEAT_REC + '"';

          this.cellsixlpd = data.INFILTRATION;
          this.celleightDl =  data.DL; // DL
          this.celloneNew = data.WALL;
          this.celltwoNew = data.ROOF;
          this.cellfourNew = data.WINDOW;
          this.cellthreeNew = data.FLOOR;
          this.cellnineNew = data.HVAC;
          this.celltenNewHeat = data.HEAT_REC;
          this.combIdSelected = data.COMBID;
          this.hvacIdSel = data.hvacID;
          
          if (this.newAshNecb == 'noash') {
            this.savingsrep = data.SAVINGS;
          }
          

          if (data.WALL == 'W3(NECB)') {
            this.cellone = '"' + 'W3' + '"';
          }
          if (data.WALL == 'W2(ASH)') {
            this.cellone = '"' + 'W2' + '"';
          }
          if (data.ROOF == 'R3(NECB)') {
            this.celltwo = '"' + 'R3' + '"';
          }
          if (data.ROOF == 'R2(ASH)') {
            this.celltwo = '"' + 'R2' + '"';
          }
          if (data.FLOOR == 'F1(NECB)') {
            this.cellthree = '"' + 'F1' + '"';
          }
          if (data.FLOOR == 'F2(ASH)') {
            this.cellthree = '"' + 'F2' + '"';
          }
          if (data.WINDOW == 'WIN08(NECB)') {
            this.cellfour = '"' + 'WIN08' + '"';
          }
          if (data.WINDOW == 'WIN04(ASH)') {
            this.cellfour = '"' + 'WIN04' + '"';
          }
          if (data.INFILTRATION == 'LPD3(NECB)') {
            this.cellsix = '"' + 'LPD3' + '"';
          }
          if (data.INFILTRATION == 'LPD3(ASH)') {
            this.cellsix = '"' + 'LPD3' + '"';
          }
          if (data.HEAT == 'Y') {
            this.cellten = 'Yes';
          }
          if (data.HEAT == 'N') {
            this.cellten = 'No';
          }
          if(data.WWR.length > 1) {
            this.wwronerepNew = data.WWR;
            /*var cellnew = data.WWR;
            var str1 = '0.';
            var str2 = cellnew;
            var res = str1.concat(str2);
            if (res == '0.10%') {
              res = '0.1%';
            }*/
           if(this.wwronerepNew.toString().indexOf("%") > -1)
            this.authService.cellSevenMessage((this.wwronerepNew.replace('%', '')/100).toFixed(3));
            //this.wwronerep = res.replace(/(\%)/, '');
          } else {
            if(this.wwrSelected.toString().indexOf("%") > -1)
            this.wwrSelected = (this.wwrSelected.replace('%', '')/100).toFixed(3);
            this.authService.cellSevenMessage(this.wwrSelected);
           // this.wwronerep = res;
          }

          this.authService.cellOneMessage(this.cellone);
          this.authService.cellTwoMessage(this.celltwo);
          this.authService.cellThreeMessage(this.cellthree);
          this.authService.cellFourMessage(this.cellfour);
          this.authService.cellFiveMessage(this.cellfive);
          this.authService.cellSixMessage(this.cellsix);
          
          this.authService.cellEightMessage(this.celleight);
          this.authService.cellNineMessage(this.cellnine);
          this.authService.cellTenMessage(this.cellten);
          this.authService.cellTenNewMessage(this.celltenNew);
          this.authService.cellOptionFn(this.cellopt);
          this.authService.combIdSelMessage(this.combIdSelected);

          for (var i = 0; i < this.buildEnv.projLists.length; i++) {
            if (this.buildEnv.projLists[i].wall == this.celloneNew) {
              this.walluval = this.buildEnv.projLists[i].wall_u_value;
              this.wallip = this.buildEnv.projLists[i].wall_r_value_ip;
            }


            if (this.buildEnv.projLists[i].roof == this.celltwoNew) {
             
              this.roofuval = this.buildEnv.projLists[i].roof_u_value_si;
              this.roofip = this.buildEnv.projLists[i].roof_r_value_ip;
            }

           

            if (this.buildEnv.projLists[i].floor == this.cellthreeNew) {
              this.flooruval = this.buildEnv.projLists[i].flr_u_value_si;
              this.floorip = this.buildEnv.projLists[i].floor_r_value_ip;
            }

            

            if (this.buildEnv.projLists[i].windows == this.cellfourNew) {
              this.winuval = this.buildEnv.projLists[i].win_u_value_si;
              this.winip = this.buildEnv.projLists[i].win_r_value_ip;
              this.winshgc = this.buildEnv.projLists[i].win_shgc;
            }

           
          }

          // building data end

          // lighting data start
          if (this.celleightDl == 'DLON') {
            this.DLnew = 'YES';
          } else if (this.celleightDl == 'DLOFF') {
            this.DLnew = 'NO';
          }

          for (var i = 0; i < this.lightData.projLists.length; i++) {
            if (this.lightData.projLists[i].lpd == this.cellsixlpd) {
              this.lpduval = this.lightData.projLists[i].lpd_val;
              //  this.lpdip = this.lightData.projLists[i].lpd_r_value_ip
            }

          }

          // lighting data end

          // hvac start
          for (var i = 0; i < this.hvData.projLists.length; i++) {
            if (this.hvData.projLists[i].HVAC_system == this.cellnineNew) {
              this.boilercop = this.hvData.projLists[i].boilerCOP;
              this.chillercop = this.hvData.projLists[i].chillerCOP;
            }
            if (this.hvData.projLists[i].HVAC_system == this.hva) {
              this.boilercopan = this.hvData.projLists[i].boilerCOP;
              this.chillercopan = this.hvData.projLists[i].chillerCOP;
            }
          }
          d3.selectAll('#stack_chart_new_rep svg').remove();
          //this.costSurcharge();

          d3.selectAll('#stack_chart svg').remove();
          this.stackedChart();

          d3.selectAll('#stack_chart_report svg').remove();
         // this.stackedChartReportNew();

          d3.selectAll('#group_chart svg').remove();
        //  this.groupChart();

          d3.selectAll('#chartneg svg').remove();
          //this.barnegChart();

          d3.selectAll('#chartcooling svg').remove();

          d3.selectAll('#heating svg').remove();
          this.child.proSnkapi();

          d3.selectAll('#chartcoolingnew svg').remove();

          d3.selectAll('#heatingnew svg').remove();
    
    this.corechart();
        }
      });

      d3.select('#grid')
        .datum(tableData)
        .call(grid)
        .selectAll('.row')
        .on({
          mouseover: (d, e) => {

            if (e != 0) {
             
              parcoords.highlight([d]);
            }
          },
          click: (d) => {
            this.savingsrep = d.SAVINGS;
            this.euirepnew = d.EUI;
            this.costNew = d.COSTPREMIUM;
          },
          mouseout: parcoords.unhighlight,
        });



    var elementHeader = document.querySelectorAll('.mygrid > .header')[0];
    var elementChildList = elementHeader['children'];
    
   // const screenWidth = ((this.screenwidth/elementChildList.length-this.gridLen-1)-0.5)-1;
    const screenWidth = ((window.innerWidth/(elementChildList.length-this.gridLen)-1)-0.5)-1;
    this.dynamicSingleWidth = screenWidth;
   
    const elementClassNameRecords = document.getElementsByClassName("cell")
    for (var i1 in elementClassNameRecords) {
            if(elementClassNameRecords[i1]) {
             
              
              elementClassNameRecords[i1]["style"].width = `${screenWidth}`+"px";
              elementClassNameRecords[i1]["style"].maxWidth = "40%";
           //   elementClassNameRecords[i1]["style"].paddingLeft = `${screenWidth}`+"px";
           }
    }

    var elementRowHeader = document.querySelectorAll('.mygrid > .row')[0];
    

      drawchart(tableData);

    

      // alert(data)

      function draw(data) {
        var scale = d3.scale.linear().domain([0, 50]).range([0, 100]);

        var bars = d3
          .select('#work_queues_chart')
          .selectAll('div')
          .attr('id', 'work_queues_chart')
          .data(data.projLists);

        // enter selection
        bars.enter().append('div');

        // update selection
        bars
          .style('width', function (d) {
            return scale(d.EUI) + 'px';
          })
          .text(function (d) {
            return d.EUI;
          });

        // exit selection
        bars.exit().remove();
      }

      

      function update() {
        var data = [4, 8, 15, 16, 23, 42];
        draw(data);
      }


      d3.select('#update').on('click', update);

      function drawchart(dat) {
        // set the dimensions of the canvas
        var margin = { top: 20, right: 20, bottom: 70, left: 40 },
          width = 300 - margin.left - margin.right,
          height = 300 - margin.top - margin.bottom;

        // set the ranges
        var x = d3.scale.ordinal().rangeRoundBands([0, width], 0.05);

        var y = d3.scale.linear().range([height, 0]);

        // define the axis
        var xAxis = d3.svg.axis().scale(x).orient('bottom');

        var yAxis = d3.svg.axis().scale(y).orient('left').ticks(10);

        d3.select('#bar_chart').select('svg').remove();

        // add the SVG element
        var svg = d3
          .select('#bar_chart')
          .append('svg')
          .attr('width', width + margin.left + margin.right)
          .attr('height', height + margin.top + margin.bottom)
          .append('g')
          .attr(
            'transform',
            'translate(' + margin.left + ',' + margin.top + ')'
          );

        // load the data

        data.projLists.forEach(function (d) {
          d.Letter = d.OPTIONS;
          d.Freq = d.EUI;
        });

        // scale the range of the data
        x.domain(
          dat.map(function (d) {
            return d.Letter;
          })
        );
        var maxFreq = d3.max(dat, function (d) {
          return d.Freq;
        });
        y.domain([0, maxFreq]);

        // add axis
        svg
          .append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .style('text-anchor', 'end')
          .attr('dx', '-.8em')
          .attr('dy', '-.55em')
          .attr('transform', 'rotate(-90)');

        svg
          .append('g')
          .attr('class', 'y axis')
          .call(yAxis)
          .append('text')
          .attr('transform', 'rotate(-90)')
          .attr('y', 5)
          .attr('dy', '.71em')
          .style('text-anchor', 'end')
          .text('EUI');

        // Add bar chart
        svg
          .selectAll('bar')
          .data(dat)
          .enter()
          .append('rect')
          .attr('class', 'bar')
          .attr('x', function (d) {
            return x(d.Letter);
          })
          .attr('width', x.rangeBand())
          .attr('y', function (d) {
            return y(d.Freq);
          })
          .attr('height', function (d) {
            return height - y(d.Freq);
          });
      }
    });

    this.ids.push(["['" + 'Task' + "'", "'" + 'Hours per Day' + "'" + ']']);


    if (this.newAshNecb == 'Ashare') {
      this.newAshNecbNew = 'ASHRAE';
    }
    if (this.newAshNecb == 'Necb') {
      this.newAshNecbNew = 'NECB';
    }

   
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }

    const bodynews = new HttpParams()
      .set('user_id', this.currentId)
      .set('proj_id', this.newProjId)
      .set('wall', '"' + this.newcustBase + '"')
      .set('roof', '"' + this.newcustBaseRoof + '"')
      .set('floor', '"' + this.newcustBaseFloor + '"')
      .set('window', '"' + this.newcustBaseWindow + '"')
      .set('shading', '"' + this.newcustBaseShading + '"')
      .set('lighting', '"' + this.newcustBaseLighting + '"')

      .set('wwr', '"' + this.newcustBaseWwr + '"')
      .set('dl', '"' + this.newcustDaylight + '"')
      .set('hvac', "'01_VAV.aps'")
      .set('heatRecovery', "'N'");

    if (1 == 1) {
      document.getElementById('donutchart').innerHTML = '';


      this.msgurlnw =
        this.rootDomainUrl +
        'adeos/api/sum_energy.php?user_id=' +
        this.condId +
        '&proj_id=' +
        this.newProjId +
        '&wall="W1"' +
        '&roof="R2"' +
        '&floor="F1"' +
        '&window="WIN01"' +
        '&shading="YES"' +
        '&inf="INF1"' +
        '&wwr="0.1"' +
        '&dl="DLOFF"' +
        '&hvac="VAV with Reheat"' +
        '&heatRecovery="N"';

      return this.http
        .get(this.msgurlnw)
        .pipe(map((res) => res))
        .subscribe((data) => {
          this.gogdat = data;

          this.hteng = this.gogdat.readData.heating_energy_total;
          this.coeng = this.gogdat.readData.cooling_energy_total;

          var hello = +this.gogdat.readData.heating_energy_total;
          var cool = +this.gogdat.readData.cooling_energy_total;
          var ligt = +this.gogdat.readData.lighting_energy_total;
          var eqpt = +this.gogdat.readData.equip_energy_total;
          var dhwt = +this.gogdat.readData.Total_DHW;

          google.charts.load('current', { packages: ['corechart'] });
          google.charts.setOnLoadCallback(drawChart);
          function drawChart() {
            var data = google.visualization.arrayToDataTable([
              ['Task', 'Hours per Day'],
              ['Heating Energy(kwh)', hello],
              ['Cooling Energy(kwh)', cool],
              ['Lighting Energy(kwh)', ligt],
              ['Equipment Energy(kwh)', eqpt],
              ['DHW Energy(kwh)', dhwt],
            ]);

            var options = {
              title: 'Proposed Energy new(kwh)',
              pieHole: 0.4,
              width: 460,
              height: 400,
            };

            var chart = new google.visualization.PieChart(
              document.getElementById('donutchart')
            );
            chart.draw(data, options);
          }
        });
    }

   
  } // ngonint end

  corechart() {
    (() => {
            
    if (
            this.message == 'default message' &&
            this.cellmessage == 'dgt msg'
          ) {
    this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              this.condId +
              '&proj_id=' +
              this.newProjId +
              '&cID=' +
              this.combIdSelected+
              '&heatRecovery=' +
              this.heatone+
              '&hvac=' +
              this.hvacIdSel;
          } else if (
            this.cellmessage == 'dgt msg' &&
            this.newAshNecb == 'noash'
          ) {
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              this.condId  +
              '&proj_id=' +
              this.newProjId +
              '&cID=' +
              this.combIdSelected+
              '&heatRecovery=' +
              this.heatone+
              '&hvac=' +
              this.hvacIdSel;
          } else if (
            this.cellmessage !== 'dgt msg' &&
            this.newAshNecb == 'noash'
          ) {
           /* this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              this.condId  +
              '&proj_id=' +
              this.newProjId +
              '&wall=' +
              this.cellmessage +
              '&roof=' +
              this.cellTwomessage +
              '&floor=' +
              this.cellThreemessage +
              '&window=' +
              this.cellFourmessage +
              '&shading=' +
              this.cellFivemessage +
              '&lighting=' +
              this.cellSixmessage +
              '&wwr=' +
              '"' +
              this.cellSevenmessage +
              '"' +
              '&dl=' +
              this.cellEightmessage +
              '&hvac=' +
              encodeURIComponent(this.cellNinemessage.toString()) +
              '&heatRecovery=' +
              this.celltenNewmessage;*/
              this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              this.condId  +
              '&proj_id=' +
              this.newProjId +
              '&cID=' +
              this.combIdSelected+
              '&heatRecovery=' +
              this.celltenNewmessage+
              '&hvac=' +
              this.hvacIdSel;

          }
          else if (
            this.cellmessage == 'dgt msg' &&
            this.message != 'default message'
          ) {
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              this.condId  +
              '&proj_id=' +
              this.newProjId +
              '&cID=' +
              this.combIdSelected+
              '&heatRecovery=' +
              this.heatone+
              '&hvac=' +
              this.hvacIdSel;
          } else {
            this.sumengurl =
              this.rootDomainUrl +
              'adeos/api/sum_energy.php?user_id=' +
              this.condId  +
              '&proj_id=' +
              this.newProjId +
              '&cID=' +
              this.combIdSelected+
              '&heatRecovery=' +
              this.celltenNewmessage+
              '&hvac=' +
              this.hvacIdSel;
          }

  
      return this.http
        .get(this.sumengurl)
        .pipe(map((res) => res))
        .subscribe((data) => {
          this.gogdat = data;

          this.hteng = this.gogdat.readData.heating_energy_total;
          this.coeng = this.gogdat.readData.cooling_energy_total;

          var hello = +this.gogdat.readData.heating_energy_total;
          var cool = +this.gogdat.readData.cooling_energy_total;
          var ligt = +this.gogdat.readData.lighting_energy_total;
          var eqpt = +this.gogdat.readData.equip_energy_total;
          var dhwt = +this.gogdat.readData.Total_DHW;
    var fans = +this.gogdat.readData.TotalDistrFanEnergy;
    var pumps = +this.gogdat.readData.TotalDistrPumpE;
    var heatrej = +this.gogdat.readData.TotalHeatRejPumpE;
    var hum = +this.gogdat.readData.hum_energy;

          google.charts.load('current', { packages: ['corechart'] });
          google.charts.setOnLoadCallback(drawChart);
          function drawChart() {
            var data = google.visualization.arrayToDataTable([
              ['Task', 'Hours per Day'],
              ['HEATING', hello],
              ['COOLING', cool],
      ['FANS', fans],
      ['PUMPS', pumps],
      ['HEAT REJ', heatrej],
      ['HUM/PRO', hum],
      ['DHW', dhwt],
              ['LIGHTING', ligt],
              ['EQP', eqpt],
              

            ]);

            var options = {
              title: 'PROPOSED ENERGY BREAKUP',
               backgroundColor: 'transparent',
      pieSliceText: 'none',
        sliceVisibilityThreshold: 0,             
      legend: 'labeled',
              width: 750,
              height: 400,
      slices: {0: {color: '#C1534E'}, 1: {color: '#4C82BB'}, 2: {color: '#95D23E'}, 3: {color: '#A896DB'},4: {color: '#2AD9C5'},
      5: {color: '#bb854c'},6: {color: '#000000'},7: {color: '#cccccc'},8: {color: '#F7CE41'}}
            };
            var colors = [
              '#C1534E',
              '#4C82BB',
              '#95D23E',
              '#A896DB',
              '#2AD9C5',
              '#bb854c',
              '#000000',
              '#cccccc',
              '#D2691E',
              '#F7CE41',
              
        
            ];
            var chart = new google.visualization.PieChart(
              document.getElementById('donutchart')
            );
            chart.draw(data, options);
          }
        });
    })();
  }

  populateRow(rowData: any) {

  const row = d3.selectAll('.mygrid')
                .select('.row.data');

  this.visibleColumns.forEach(col => {

    const index = this.getColumnIndex(col);

    row.select(`.col-${index}`)
       .text(rowData[col] ?? '');

  });
}
updateVisibleColumns() {
  this.visibleColumns = this.allColumns.filter(
    col => !this.currentHideArr.includes(col)
  );
}
getColumnIndex(colName: string): number {
    if (!colName) return -1;
    const lookup = colName.toString().toLowerCase();
    return this.visibleColumns.findIndex((c) =>
      c && c.toString().toLowerCase() === lookup
    );
}
}
